webpackJsonp([9249036036638527000,16304781003358073000],{

/***/ "./node_modules/@vx/axis/build/axis/Axis.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Axis;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _shape = __webpack_require__("./node_modules/@vx/shape/build/index.js");
	
	var _point = __webpack_require__("./node_modules/@vx/point/build/index.js");
	
	var _group = __webpack_require__("./node_modules/@vx/group/build/index.js");
	
	var _center = __webpack_require__("./node_modules/@vx/axis/build/utils/center.js");
	
	var _center2 = _interopRequireDefault(_center);
	
	var _identity = __webpack_require__("./node_modules/@vx/axis/build/utils/identity.js");
	
	var _identity2 = _interopRequireDefault(_identity);
	
	var _labelTransform = __webpack_require__("./node_modules/@vx/axis/build/utils/labelTransform.js");
	
	var _labelTransform2 = _interopRequireDefault(_labelTransform);
	
	var _orientation = __webpack_require__("./node_modules/@vx/axis/build/constants/orientation.js");
	
	var _orientation2 = _interopRequireDefault(_orientation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Axis(_ref) {
	  var scale = _ref.scale,
	      orientation = _ref.orientation,
	      _ref$top = _ref.top,
	      top = _ref$top === undefined ? 0 : _ref$top,
	      _ref$left = _ref.left,
	      left = _ref$left === undefined ? 0 : _ref$left,
	      _ref$rangePadding = _ref.rangePadding,
	      rangePadding = _ref$rangePadding === undefined ? 0 : _ref$rangePadding,
	      _ref$stroke = _ref.stroke,
	      stroke = _ref$stroke === undefined ? 'black' : _ref$stroke,
	      _ref$strokeWidth = _ref.strokeWidth,
	      strokeWidth = _ref$strokeWidth === undefined ? 1 : _ref$strokeWidth,
	      strokeDasharray = _ref.strokeDasharray,
	      _ref$numTicks = _ref.numTicks,
	      numTicks = _ref$numTicks === undefined ? 10 : _ref$numTicks,
	      tickFormat = _ref.tickFormat,
	      _ref$tickStroke = _ref.tickStroke,
	      tickStroke = _ref$tickStroke === undefined ? 'black' : _ref$tickStroke,
	      _ref$tickLength = _ref.tickLength,
	      tickLength = _ref$tickLength === undefined ? 8 : _ref$tickLength,
	      tickTransform = _ref.tickTransform,
	      tickValues = _ref.tickValues,
	      _ref$hideAxisLine = _ref.hideAxisLine,
	      hideAxisLine = _ref$hideAxisLine === undefined ? false : _ref$hideAxisLine,
	      _ref$hideTicks = _ref.hideTicks,
	      hideTicks = _ref$hideTicks === undefined ? false : _ref$hideTicks,
	      _ref$hideZero = _ref.hideZero,
	      hideZero = _ref$hideZero === undefined ? false : _ref$hideZero,
	      _ref$labelOffset = _ref.labelOffset,
	      labelOffset = _ref$labelOffset === undefined ? 14 : _ref$labelOffset,
	      labelComponent = _ref.labelComponent,
	      _ref$tickLabelCompone = _ref.tickLabelComponent,
	      tickLabelComponent = _ref$tickLabelCompone === undefined ? _react2.default.createElement('text', {
	    textAnchor: 'middle',
	    fontFamily: 'Arial',
	    fontSize: 10,
	    fill: 'black'
	  }) : _ref$tickLabelCompone,
	      className = _ref.className;
	
	  var values = scale.ticks ? scale.ticks(numTicks) : scale.domain();
	  if (tickValues) values = tickValues;
	  var format = scale.tickFormat ? scale.tickFormat() : _identity2.default;
	  if (tickFormat) format = tickFormat;
	
	  console.log(!!tickFormat)
	
	  var range = scale.range();
	  var range0 = range[0] + 0.5 - rangePadding;
	  var range1 = range[range.length - 1] + 0.5 + rangePadding;
	
	  var horizontal = orientation !== _orientation2.default.left && orientation !== _orientation2.default.right;
	  var isLeft = orientation === _orientation2.default.left;
	  var isTop = orientation === _orientation2.default.top;
	  var tickSign = isLeft || isTop ? -1 : 1;
	
	  var position = (scale.bandwidth ? _center2.default : _identity2.default)(scale.copy());
	
	  var axisFromPoint = new _point.Point({
	    x: horizontal ? range0 : 0,
	    y: horizontal ? 0 : range0
	  });
	  var axisToPoint = new _point.Point({
	    x: horizontal ? range1 : 0,
	    y: horizontal ? 0 : range1
	  });
	
	  var tickLabelFontSize = tickLabelComponent.props.fontSize || 10;
	
	  var labelTransform = (0, _labelTransform2.default)({
	    tickLength: tickLength,
	    labelComponent: labelComponent,
	    labelOffset: labelOffset,
	    tickLabelFontSize: tickLabelFontSize,
	    orientation: orientation,
	    range: range
	  });
	
	  return _react2.default.createElement(
	    _group.Group,
	    {
	      className: (0, _classnames2.default)('vx-axis', className),
	      top: top,
	      left: left
	    },
	    labelComponent && _react2.default.cloneElement(labelComponent, labelTransform),
	    values.map(function (val, i) {
	      if (hideZero && val === 0) return null;
	
	      var tickFromPoint = new _point.Point({
	        x: horizontal ? position(val) : 0,
	        y: horizontal ? 0 : position(val)
	      });
	      var tickToPoint = new _point.Point({
	        x: horizontal ? position(val) : tickSign * tickLength,
	        y: horizontal ? tickLength * tickSign : position(val)
	      });
	      var tickLabelProps = {
	        x: tickToPoint.x,
	        y: tickToPoint.y + (horizontal && !isTop ? tickLabelFontSize : 0)
	      };
	
	      return _react2.default.createElement(
	        _group.Group,
	        {
	          key: 'vx-tick-' + val + '-' + i,
	          className: 'vx-axis-ticks',
	          transform: tickTransform
	        },
	        !hideTicks && _react2.default.createElement(_shape.Line, {
	          from: tickFromPoint,
	          to: tickToPoint,
	          stroke: tickStroke || stroke
	        }),
	        _react2.default.cloneElement(tickLabelComponent, tickLabelProps, format(val, i))
	      );
	    }),
	    !hideAxisLine && _react2.default.createElement(_shape.Line, {
	      from: axisFromPoint,
	      to: axisToPoint,
	      stroke: stroke,
	      strokeWidth: strokeWidth,
	      strokeDasharray: strokeDasharray
	    })
	  );
	}


/***/ }),

/***/ "./node_modules/@vx/axis/build/axis/AxisBottom.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AxisBottom;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Axis = __webpack_require__("./node_modules/@vx/axis/build/axis/Axis.js");
	
	var _Axis2 = _interopRequireDefault(_Axis);
	
	var _orientation = __webpack_require__("./node_modules/@vx/axis/build/constants/orientation.js");
	
	var _orientation2 = _interopRequireDefault(_orientation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AxisBottom(_ref) {
	  var scale = _ref.scale,
	      top = _ref.top,
	      left = _ref.left,
	      stroke = _ref.stroke,
	      strokeWidth = _ref.strokeWidth,
	      strokeDasharray = _ref.strokeDasharray,
	      rangePadding = _ref.rangePadding,
	      label = _ref.label,
	      _ref$labelOffset = _ref.labelOffset,
	      labelOffset = _ref$labelOffset === undefined ? 8 : _ref$labelOffset,
	      numTicks = _ref.numTicks,
	      tickFormat = _ref.tickFormat,
	      tickStroke = _ref.tickStroke,
	      tickTransform = _ref.tickTransform,
	      tickValues = _ref.tickValues,
	      _ref$tickLength = _ref.tickLength,
	      tickLength = _ref$tickLength === undefined ? 8 : _ref$tickLength,
	      _ref$tickLabelCompone = _ref.tickLabelComponent,
	      tickLabelComponent = _ref$tickLabelCompone === undefined ? _react2.default.createElement('text', {
	    textAnchor: 'middle',
	    fontFamily: 'Arial',
	    fontSize: 10,
	    fill: 'black',
	    dy: '0.25em'
	  }) : _ref$tickLabelCompone,
	      hideAxisLine = _ref.hideAxisLine,
	      hideTicks = _ref.hideTicks,
	      hideZero = _ref.hideZero,
	      className = _ref.className;
	
	  return _react2.default.createElement(_Axis2.default, {
	    className: (0, _classnames2.default)('vx-axis-bottom', className),
	    orientation: _orientation2.default.bottom,
	    top: top,
	    left: left,
	    scale: scale,
	    stroke: stroke,
	    strokeWidth: strokeWidth,
	    strokeDasharray: strokeDasharray,
	    rangePadding: rangePadding,
	    labelComponent: typeof label === 'string' ? _react2.default.createElement(
	      'text',
	      {
	        textAnchor: 'middle',
	        fontFamily: 'Arial',
	        fontSize: 10,
	        fill: 'black'
	      },
	      label
	    ) : label,
	    numTicks: numTicks,
	    tickFormat: tickFormat,
	    tickLength: tickLength,
	    tickTransform: tickTransform,
	    tickStroke: tickStroke,
	    tickValues: tickValues,
	    labelOffset: labelOffset,
	    tickLabelComponent: tickLabelComponent,
	    hideAxisLine: hideAxisLine,
	    hideTicks: hideTicks,
	    hideZero: hideZero
	  });
	}

/***/ }),

/***/ "./node_modules/@vx/axis/build/axis/AxisLeft.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AxisLeft;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Axis = __webpack_require__("./node_modules/@vx/axis/build/axis/Axis.js");
	
	var _Axis2 = _interopRequireDefault(_Axis);
	
	var _orientation = __webpack_require__("./node_modules/@vx/axis/build/constants/orientation.js");
	
	var _orientation2 = _interopRequireDefault(_orientation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AxisLeft(_ref) {
	  var scale = _ref.scale,
	      top = _ref.top,
	      left = _ref.left,
	      stroke = _ref.stroke,
	      strokeWidth = _ref.strokeWidth,
	      strokeDasharray = _ref.strokeDasharray,
	      rangePadding = _ref.rangePadding,
	      label = _ref.label,
	      _ref$labelOffset = _ref.labelOffset,
	      labelOffset = _ref$labelOffset === undefined ? 36 : _ref$labelOffset,
	      numTicks = _ref.numTicks,
	      tickFormat = _ref.tickFormat,
	      tickStroke = _ref.tickStroke,
	      tickTransform = _ref.tickTransform,
	      tickValues = _ref.tickValues,
	      _ref$tickLength = _ref.tickLength,
	      tickLength = _ref$tickLength === undefined ? 8 : _ref$tickLength,
	      _ref$tickLabelCompone = _ref.tickLabelComponent,
	      tickLabelComponent = _ref$tickLabelCompone === undefined ? _react2.default.createElement('text', {
	    textAnchor: 'end',
	    fontFamily: 'Arial',
	    fontSize: 10,
	    fill: 'black',
	    dx: '-0.25em',
	    dy: '0.25em'
	  }) : _ref$tickLabelCompone,
	      hideAxisLine = _ref.hideAxisLine,
	      hideTicks = _ref.hideTicks,
	      hideZero = _ref.hideZero,
	      className = _ref.className;
	
	  return _react2.default.createElement(_Axis2.default, {
	    className: (0, _classnames2.default)('vx-axis-left', className),
	    orientation: _orientation2.default.left,
	    top: top,
	    left: left,
	    scale: scale,
	    stroke: stroke,
	    strokeWidth: strokeWidth,
	    strokeDasharray: strokeDasharray,
	    rangePadding: rangePadding,
	    labelComponent: typeof label === 'string' ? _react2.default.createElement(
	      'text',
	      {
	        textAnchor: 'middle',
	        fontFamily: 'Arial',
	        fontSize: 10,
	        fill: 'black'
	      },
	      label
	    ) : label,
	    numTicks: numTicks,
	    tickFormat: tickFormat,
	    tickLength: tickLength,
	    tickTransform: tickTransform,
	    tickStroke: tickStroke,
	    tickValues: tickValues,
	    labelOffset: labelOffset,
	    tickLabelComponent: tickLabelComponent,
	    hideAxisLine: hideAxisLine,
	    hideTicks: hideTicks,
	    hideZero: hideZero
	  });
	}

/***/ }),

/***/ "./node_modules/@vx/axis/build/axis/AxisRight.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AxisRight;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Axis = __webpack_require__("./node_modules/@vx/axis/build/axis/Axis.js");
	
	var _Axis2 = _interopRequireDefault(_Axis);
	
	var _orientation = __webpack_require__("./node_modules/@vx/axis/build/constants/orientation.js");
	
	var _orientation2 = _interopRequireDefault(_orientation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AxisRight(_ref) {
	  var scale = _ref.scale,
	      top = _ref.top,
	      left = _ref.left,
	      stroke = _ref.stroke,
	      strokeWidth = _ref.strokeWidth,
	      strokeDasharray = _ref.strokeDasharray,
	      rangePadding = _ref.rangePadding,
	      label = _ref.label,
	      _ref$labelOffset = _ref.labelOffset,
	      labelOffset = _ref$labelOffset === undefined ? 36 : _ref$labelOffset,
	      numTicks = _ref.numTicks,
	      tickFormat = _ref.tickFormat,
	      tickStroke = _ref.tickStroke,
	      tickTransform = _ref.tickTransform,
	      tickValues = _ref.tickValues,
	      _ref$tickLength = _ref.tickLength,
	      tickLength = _ref$tickLength === undefined ? 8 : _ref$tickLength,
	      _ref$tickLabelCompone = _ref.tickLabelComponent,
	      tickLabelComponent = _ref$tickLabelCompone === undefined ? _react2.default.createElement('text', {
	    textAnchor: 'start',
	    fontFamily: 'Arial',
	    fontSize: 10,
	    fill: 'black',
	    dx: '0.25em',
	    dy: '0.25em'
	  }) : _ref$tickLabelCompone,
	      hideAxisLine = _ref.hideAxisLine,
	      hideTicks = _ref.hideTicks,
	      hideZero = _ref.hideZero,
	      className = _ref.className;
	
	  return _react2.default.createElement(_Axis2.default, {
	    className: (0, _classnames2.default)('vx-axis-right', className),
	    orientation: _orientation2.default.right,
	    top: top,
	    left: left,
	    scale: scale,
	    stroke: stroke,
	    strokeWidth: strokeWidth,
	    strokeDasharray: strokeDasharray,
	    rangePadding: rangePadding,
	    labelComponent: typeof label === 'string' ? _react2.default.createElement(
	      'text',
	      {
	        textAnchor: 'middle',
	        fontFamily: 'Arial',
	        fontSize: 10,
	        fill: 'black'
	      },
	      label
	    ) : label,
	    numTicks: numTicks,
	    tickFormat: tickFormat,
	    tickLength: tickLength,
	    tickTransform: tickTransform,
	    tickStroke: tickStroke,
	    tickValues: tickValues,
	    labelOffset: labelOffset,
	    tickLabelComponent: tickLabelComponent,
	    hideAxisLine: hideAxisLine,
	    hideTicks: hideTicks,
	    hideZero: hideZero
	  });
	}

/***/ }),

/***/ "./node_modules/@vx/axis/build/axis/AxisTop.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AxisTop;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Axis = __webpack_require__("./node_modules/@vx/axis/build/axis/Axis.js");
	
	var _Axis2 = _interopRequireDefault(_Axis);
	
	var _orientation = __webpack_require__("./node_modules/@vx/axis/build/constants/orientation.js");
	
	var _orientation2 = _interopRequireDefault(_orientation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AxisTop(_ref) {
	  var scale = _ref.scale,
	      top = _ref.top,
	      left = _ref.left,
	      stroke = _ref.stroke,
	      strokeWidth = _ref.strokeWidth,
	      strokeDasharray = _ref.strokeDasharray,
	      rangePadding = _ref.rangePadding,
	      label = _ref.label,
	      _ref$labelOffset = _ref.labelOffset,
	      labelOffset = _ref$labelOffset === undefined ? 8 : _ref$labelOffset,
	      numTicks = _ref.numTicks,
	      tickFormat = _ref.tickFormat,
	      tickStroke = _ref.tickStroke,
	      tickTransform = _ref.tickTransform,
	      tickValues = _ref.tickValues,
	      _ref$tickLength = _ref.tickLength,
	      tickLength = _ref$tickLength === undefined ? 8 : _ref$tickLength,
	      _ref$tickLabelCompone = _ref.tickLabelComponent,
	      tickLabelComponent = _ref$tickLabelCompone === undefined ? _react2.default.createElement('text', {
	    textAnchor: 'middle',
	    fontFamily: 'Arial',
	    fontSize: 10,
	    fill: 'black',
	    dy: '-0.25em'
	  }) : _ref$tickLabelCompone,
	      hideAxisLine = _ref.hideAxisLine,
	      hideTicks = _ref.hideTicks,
	      hideZero = _ref.hideZero,
	      className = _ref.className;
	
	  return _react2.default.createElement(_Axis2.default, {
	    className: (0, _classnames2.default)('vx-axis-top', className),
	    orientation: _orientation2.default.top,
	    top: top,
	    left: left,
	    scale: scale,
	    stroke: stroke,
	    strokeWidth: strokeWidth,
	    strokeDasharray: strokeDasharray,
	    rangePadding: rangePadding,
	    labelComponent: typeof label === 'string' ? _react2.default.createElement(
	      'text',
	      {
	        textAnchor: 'middle',
	        fontFamily: 'Arial',
	        fontSize: 10,
	        fill: 'black'
	      },
	      label
	    ) : label,
	    numTicks: numTicks,
	    tickFormat: tickFormat,
	    tickLength: tickLength,
	    tickTransform: tickTransform,
	    tickStroke: tickStroke,
	    tickValues: tickValues,
	    labelOffset: labelOffset,
	    tickLabelComponent: tickLabelComponent,
	    hideAxisLine: hideAxisLine,
	    hideTicks: hideTicks,
	    hideZero: hideZero
	  });
	}

/***/ }),

/***/ "./node_modules/@vx/axis/build/constants/orientation.js":
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  top: 'top',
	  left: 'left',
	  right: 'right',
	  bottom: 'bottom'
	};

/***/ }),

/***/ "./node_modules/@vx/axis/build/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Axis = __webpack_require__("./node_modules/@vx/axis/build/axis/Axis.js");
	
	Object.defineProperty(exports, 'Axis', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Axis).default;
	  }
	});
	
	var _AxisLeft = __webpack_require__("./node_modules/@vx/axis/build/axis/AxisLeft.js");
	
	Object.defineProperty(exports, 'AxisLeft', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AxisLeft).default;
	  }
	});
	
	var _AxisRight = __webpack_require__("./node_modules/@vx/axis/build/axis/AxisRight.js");
	
	Object.defineProperty(exports, 'AxisRight', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AxisRight).default;
	  }
	});
	
	var _AxisTop = __webpack_require__("./node_modules/@vx/axis/build/axis/AxisTop.js");
	
	Object.defineProperty(exports, 'AxisTop', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AxisTop).default;
	  }
	});
	
	var _AxisBottom = __webpack_require__("./node_modules/@vx/axis/build/axis/AxisBottom.js");
	
	Object.defineProperty(exports, 'AxisBottom', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AxisBottom).default;
	  }
	});
	
	var _orientation = __webpack_require__("./node_modules/@vx/axis/build/constants/orientation.js");
	
	Object.defineProperty(exports, 'Orientation', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_orientation).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "./node_modules/@vx/axis/build/utils/center.js":
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = center;
	function center(scale) {
	  var offset = scale.bandwidth() / 2;
	  if (scale.round()) offset = Math.round(offset);
	  return function (d) {
	    return scale(d) + offset;
	  };
	}

/***/ }),

/***/ "./node_modules/@vx/axis/build/utils/identity.js":
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = identity;
	function identity(x) {
	  return x;
	}

/***/ }),

/***/ "./node_modules/@vx/axis/build/utils/labelTransform.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = labelTransform;
	
	var _orientation = __webpack_require__("./node_modules/@vx/axis/build/constants/orientation.js");
	
	var _orientation2 = _interopRequireDefault(_orientation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function labelTransform(_ref) {
	  var tickLength = _ref.tickLength,
	      labelOffset = _ref.labelOffset,
	      tickLabelFontSize = _ref.tickLabelFontSize,
	      labelComponent = _ref.labelComponent,
	      orientation = _ref.orientation,
	      range = _ref.range;
	
	  if (!labelComponent || !labelComponent.props) return {};
	  var sign = orientation === _orientation2.default.left || orientation === _orientation2.default.top ? -1 : 1;
	  var _labelComponent$props = labelComponent.props.fontSize,
	      fontSize = _labelComponent$props === undefined ? 10 : _labelComponent$props;
	
	
	  var x = void 0,
	      y = void 0,
	      transform = null;
	  if (orientation === _orientation2.default.top || orientation === _orientation2.default.bottom) {
	    x = Math.max.apply(Math, _toConsumableArray(range)) / 2;
	    y = sign * (tickLength + labelOffset + tickLabelFontSize + (orientation === _orientation2.default.bottom ? fontSize : 0));
	  } else {
	    x = sign * (Math.max.apply(Math, _toConsumableArray(range)) / 2);
	    y = -(tickLength + labelOffset);
	    transform = 'rotate(' + sign * 90 + ')';
	  }
	
	  return { x: x, y: y, transform: transform };
	}

/***/ }),

/***/ "./node_modules/@vx/curve/build/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _d3Shape = __webpack_require__("./node_modules/d3-shape/build/d3-shape.js");
	
	Object.defineProperty(exports, 'curveBasis', {
	  enumerable: true,
	  get: function get() {
	    return _d3Shape.curveBasis;
	  }
	});
	Object.defineProperty(exports, 'curveBasisClosed', {
	  enumerable: true,
	  get: function get() {
	    return _d3Shape.curveBasisClosed;
	  }
	});
	Object.defineProperty(exports, 'curveBasisOpen', {
	  enumerable: true,
	  get: function get() {
	    return _d3Shape.curveBasisOpen;
	  }
	});
	Object.defineProperty(exports, 'curveStep', {
	  enumerable: true,
	  get: function get() {
	    return _d3Shape.curveStep;
	  }
	});
	Object.defineProperty(exports, 'curveStepAfter', {
	  enumerable: true,
	  get: function get() {
	    return _d3Shape.curveStepAfter;
	  }
	});
	Object.defineProperty(exports, 'curveStepBefore', {
	  enumerable: true,
	  get: function get() {
	    return _d3Shape.curveStepBefore;
	  }
	});
	Object.defineProperty(exports, 'curveBundle', {
	  enumerable: true,
	  get: function get() {
	    return _d3Shape.curveBundle;
	  }
	});
	Object.defineProperty(exports, 'curveLinear', {
	  enumerable: true,
	  get: function get() {
	    return _d3Shape.curveLinear;
	  }
	});
	Object.defineProperty(exports, 'curveLinearClosed', {
	  enumerable: true,
	  get: function get() {
	    return _d3Shape.curveLinearClosed;
	  }
	});
	Object.defineProperty(exports, 'curveCardinal', {
	  enumerable: true,
	  get: function get() {
	    return _d3Shape.curveCardinal;
	  }
	});
	Object.defineProperty(exports, 'curveCardinalClosed', {
	  enumerable: true,
	  get: function get() {
	    return _d3Shape.curveCardinalClosed;
	  }
	});
	Object.defineProperty(exports, 'curveCardinalOpen', {
	  enumerable: true,
	  get: function get() {
	    return _d3Shape.curveCardinalOpen;
	  }
	});
	Object.defineProperty(exports, 'curveCatmullRom', {
	  enumerable: true,
	  get: function get() {
	    return _d3Shape.curveCatmullRom;
	  }
	});
	Object.defineProperty(exports, 'curveCatmullRomClosed', {
	  enumerable: true,
	  get: function get() {
	    return _d3Shape.curveCatmullRomClosed;
	  }
	});
	Object.defineProperty(exports, 'curveCatmullRomOpen', {
	  enumerable: true,
	  get: function get() {
	    return _d3Shape.curveCatmullRomOpen;
	  }
	});
	Object.defineProperty(exports, 'curveMonotoneX', {
	  enumerable: true,
	  get: function get() {
	    return _d3Shape.curveMonotoneX;
	  }
	});
	Object.defineProperty(exports, 'curveMonotoneY', {
	  enumerable: true,
	  get: function get() {
	    return _d3Shape.curveMonotoneY;
	  }
	});
	Object.defineProperty(exports, 'curveNatural', {
	  enumerable: true,
	  get: function get() {
	    return _d3Shape.curveNatural;
	  }
	});

/***/ }),

/***/ "./node_modules/@vx/event/build/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _localPoint = __webpack_require__("./node_modules/@vx/event/build/localPoint.js");
	
	Object.defineProperty(exports, 'localPoint', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_localPoint).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "./node_modules/@vx/event/build/localPoint.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = localPoint;
	
	var _point = __webpack_require__("./node_modules/@vx/point/build/index.js");
	
	function localPoint(node, event) {
	  if (!node) return;
	  var svg = node.ownerSVGElement || node;
	  if (svg.createSVGPoint) {
	    var point = svg.createSVGPoint();
	    point.x = event.clientX;
	    point.y = event.clientY;
	    point = point.matrixTransform(node.getScreenCTM().inverse());
	    return new _point.Point({
	      x: point.x,
	      y: point.y
	    });
	  }
	  var rect = node.getBoundingClientRect();
	  return new _point.Point({
	    x: event.clientX - rect.left - node.clientLeft,
	    y: event.clientY - rect.top - node.clientTop
	  });
	}

/***/ }),

/***/ "./node_modules/@vx/event/build/touchPoint.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = touchPoint;
	
	var _point = __webpack_require__("./node_modules/@vx/point/build/index.js");
	
	function touchPoint(node, event) {
	  if (!node) return;
	  var svg = node.ownerSVGElement || node;
	  if (svg.createSVGPoint) {
	    var point = svg.createSVGPoint();
	    point.x = event.changedTouches[0].clientX;
	    point.y = event.changedTouches[0].clientY;
	    point = point.matrixTransform(node.getScreenCTM().inverse());
	    return new _point.Point({
	      x: point.x,
	      y: point.y
	    });
	  }
	  var rect = node.getBoundingClientRect();
	  return new _point.Point({
	    x: event.changedTouches[0].clientX - rect.left - node.clientLeft,
	    y: event.changedTouches[0].clientY - rect.top - node.clientTop
	  });
	}

/***/ }),

/***/ "./node_modules/@vx/grid/build/grids/Columns.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Columns;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _shape = __webpack_require__("./node_modules/@vx/shape/build/index.js");
	
	var _group = __webpack_require__("./node_modules/@vx/group/build/index.js");
	
	var _point = __webpack_require__("./node_modules/@vx/point/build/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function Columns(_ref) {
	  var _ref$top = _ref.top,
	      top = _ref$top === undefined ? 0 : _ref$top,
	      _ref$left = _ref.left,
	      left = _ref$left === undefined ? 0 : _ref$left,
	      scale = _ref.scale,
	      height = _ref.height,
	      _ref$stroke = _ref.stroke,
	      stroke = _ref$stroke === undefined ? '#eaf0f6' : _ref$stroke,
	      _ref$strokeWidth = _ref.strokeWidth,
	      strokeWidth = _ref$strokeWidth === undefined ? 1 : _ref$strokeWidth,
	      strokeDasharray = _ref.strokeDasharray,
	      className = _ref.className,
	      _ref$numTicks = _ref.numTicks,
	      numTicks = _ref$numTicks === undefined ? 10 : _ref$numTicks,
	      lineStyle = _ref.lineStyle,
	      restProps = _objectWithoutProperties(_ref, ['top', 'left', 'scale', 'height', 'stroke', 'strokeWidth', 'strokeDasharray', 'className', 'numTicks', 'lineStyle']);
	
	  return _react2.default.createElement(
	    _group.Group,
	    {
	      className: (0, _classnames2.default)('vx-columns', className),
	      top: top,
	      left: left
	    },
	    scale.ticks && scale.ticks(numTicks).map(function (d, i) {
	      var x = scale(d);
	      var fromPoint = new _point.Point({
	        x: x,
	        y: 0
	      });
	      var toPoint = new _point.Point({
	        x: x,
	        y: height
	      });
	      return _react2.default.createElement(_shape.Line, _extends({
	        key: 'column-line-' + d + '-' + i,
	        from: fromPoint,
	        to: toPoint,
	        stroke: stroke,
	        strokeWidth: strokeWidth,
	        strokeDasharray: strokeDasharray,
	        style: lineStyle
	      }, restProps));
	    })
	  );
	}

/***/ }),

/***/ "./node_modules/@vx/grid/build/grids/Grid.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Grid;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _group = __webpack_require__("./node_modules/@vx/group/build/index.js");
	
	var _Rows = __webpack_require__("./node_modules/@vx/grid/build/grids/Rows.js");
	
	var _Rows2 = _interopRequireDefault(_Rows);
	
	var _Columns = __webpack_require__("./node_modules/@vx/grid/build/grids/Columns.js");
	
	var _Columns2 = _interopRequireDefault(_Columns);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Grid(_ref) {
	  var top = _ref.top,
	      left = _ref.left,
	      xScale = _ref.xScale,
	      yScale = _ref.yScale,
	      width = _ref.width,
	      height = _ref.height,
	      className = _ref.className,
	      stroke = _ref.stroke,
	      strokeWidth = _ref.strokeWidth,
	      strokeDasharray = _ref.strokeDasharray,
	      numTicksRows = _ref.numTicksRows,
	      numTicksColumns = _ref.numTicksColumns,
	      rowLineStyle = _ref.rowLineStyle,
	      columnLineStyle = _ref.columnLineStyle;
	
	  return _react2.default.createElement(
	    _group.Group,
	    { className: (0, _classnames2.default)('vx-grid', className), top: top, left: left },
	    _react2.default.createElement(_Rows2.default, {
	      className: className,
	      scale: yScale,
	      width: width,
	      stroke: stroke,
	      strokeWidth: strokeWidth,
	      strokeDasharray: strokeDasharray,
	      numTicks: numTicksRows,
	      style: rowLineStyle
	    }),
	    _react2.default.createElement(_Columns2.default, {
	      className: className,
	      scale: xScale,
	      height: height,
	      stroke: stroke,
	      strokeWidth: strokeWidth,
	      strokeDasharray: strokeDasharray,
	      numTicks: numTicksColumns,
	      style: columnLineStyle
	    })
	  );
	}

/***/ }),

/***/ "./node_modules/@vx/grid/build/grids/Rows.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Rows;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _shape = __webpack_require__("./node_modules/@vx/shape/build/index.js");
	
	var _group = __webpack_require__("./node_modules/@vx/group/build/index.js");
	
	var _point = __webpack_require__("./node_modules/@vx/point/build/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function Rows(_ref) {
	  var _ref$top = _ref.top,
	      top = _ref$top === undefined ? 0 : _ref$top,
	      _ref$left = _ref.left,
	      left = _ref$left === undefined ? 0 : _ref$left,
	      scale = _ref.scale,
	      width = _ref.width,
	      _ref$stroke = _ref.stroke,
	      stroke = _ref$stroke === undefined ? '#eaf0f6' : _ref$stroke,
	      _ref$strokeWidth = _ref.strokeWidth,
	      strokeWidth = _ref$strokeWidth === undefined ? 1 : _ref$strokeWidth,
	      strokeDasharray = _ref.strokeDasharray,
	      className = _ref.className,
	      _ref$numTicks = _ref.numTicks,
	      numTicks = _ref$numTicks === undefined ? 10 : _ref$numTicks,
	      lineStyle = _ref.lineStyle,
	      restProps = _objectWithoutProperties(_ref, ['top', 'left', 'scale', 'width', 'stroke', 'strokeWidth', 'strokeDasharray', 'className', 'numTicks', 'lineStyle']);
	
	  return _react2.default.createElement(
	    _group.Group,
	    { className: (0, _classnames2.default)('vx-rows', className), top: top, left: left },
	    scale.ticks && scale.ticks(numTicks).map(function (d, i) {
	      var y = scale(d);
	      var fromPoint = new _point.Point({
	        x: 0,
	        y: y
	      });
	      var toPoint = new _point.Point({
	        x: width,
	        y: y
	      });
	      return _react2.default.createElement(_shape.Line, _extends({
	        key: 'row-line-' + d + '-' + i,
	        from: fromPoint,
	        to: toPoint,
	        stroke: stroke,
	        strokeWidth: strokeWidth,
	        strokeDasharray: strokeDasharray,
	        style: lineStyle
	      }, restProps));
	    })
	  );
	}

/***/ }),

/***/ "./node_modules/@vx/grid/build/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Rows = __webpack_require__("./node_modules/@vx/grid/build/grids/Rows.js");
	
	Object.defineProperty(exports, 'GridRows', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Rows).default;
	  }
	});
	
	var _Columns = __webpack_require__("./node_modules/@vx/grid/build/grids/Columns.js");
	
	Object.defineProperty(exports, 'GridColumns', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Columns).default;
	  }
	});
	
	var _Grid = __webpack_require__("./node_modules/@vx/grid/build/grids/Grid.js");
	
	Object.defineProperty(exports, 'Grid', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Grid).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "./node_modules/@vx/group/build/Group.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Group;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function Group(_ref) {
	  var _ref$top = _ref.top,
	      top = _ref$top === undefined ? 0 : _ref$top,
	      _ref$left = _ref.left,
	      left = _ref$left === undefined ? 0 : _ref$left,
	      transform = _ref.transform,
	      className = _ref.className,
	      children = _ref.children,
	      restProps = _objectWithoutProperties(_ref, ['top', 'left', 'transform', 'className', 'children']);
	
	  return _react2.default.createElement(
	    'g',
	    _extends({
	      className: (0, _classnames2.default)('cx-group', className),
	      transform: transform || 'translate(' + left + ', ' + top + ')'
	    }, restProps),
	    children
	  );
	}

/***/ }),

/***/ "./node_modules/@vx/group/build/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Group = __webpack_require__("./node_modules/@vx/group/build/Group.js");
	
	Object.defineProperty(exports, 'Group', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Group).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "./node_modules/@vx/point/build/Point.js":
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Point = function () {
	  function Point(_ref) {
	    var _ref$x = _ref.x,
	        x = _ref$x === undefined ? 0 : _ref$x,
	        _ref$y = _ref.y,
	        y = _ref$y === undefined ? 0 : _ref$y;
	
	    _classCallCheck(this, Point);
	
	    this.x = x;
	    this.y = y;
	  }
	
	  _createClass(Point, [{
	    key: "value",
	    value: function value() {
	      return {
	        x: this.x,
	        y: this.y
	      };
	    }
	  }, {
	    key: "toArray",
	    value: function toArray() {
	      return [this.x, this.y];
	    }
	  }]);
	
	  return Point;
	}();
	
	exports.default = Point;

/***/ }),

/***/ "./node_modules/@vx/point/build/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Point = __webpack_require__("./node_modules/@vx/point/build/Point.js");
	
	Object.defineProperty(exports, 'Point', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Point).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "./node_modules/@vx/responsive/build/components/ScaleSVG.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ResponsiveSVG;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ResponsiveSVG(_ref) {
	  var children = _ref.children,
	      width = _ref.width,
	      height = _ref.height,
	      _ref$xOrigin = _ref.xOrigin,
	      xOrigin = _ref$xOrigin === undefined ? 0 : _ref$xOrigin,
	      _ref$yOrigin = _ref.yOrigin,
	      yOrigin = _ref$yOrigin === undefined ? 0 : _ref$yOrigin,
	      _ref$preserveAspectRa = _ref.preserveAspectRatio,
	      preserveAspectRatio = _ref$preserveAspectRa === undefined ? 'xMinYMin meet' : _ref$preserveAspectRa;
	
	  return _react2.default.createElement(
	    'div',
	    { style: {
	        display: 'inline-block',
	        position: 'relative',
	        width: '100%',
	        verticalAlign: 'top',
	        overflow: 'hidden'
	      } },
	    _react2.default.createElement(
	      'svg',
	      {
	        preserveAspectRatio: preserveAspectRatio,
	        viewBox: xOrigin + ' ' + yOrigin + ' ' + width + ' ' + height
	      },
	      children
	    )
	  );
	}

/***/ }),

/***/ "./node_modules/@vx/responsive/build/enhancers/withParentSize.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = withParentSize;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _debounce = __webpack_require__("./node_modules/lodash/debounce.js");
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withParentSize(BaseComponent) {
	  var WrappedComponent = function (_React$Component) {
	    _inherits(WrappedComponent, _React$Component);
	
	    function WrappedComponent(props) {
	      _classCallCheck(this, WrappedComponent);
	
	      var _this = _possibleConstructorReturn(this, (WrappedComponent.__proto__ || Object.getPrototypeOf(WrappedComponent)).call(this, props));
	
	      _this.state = {
	        parentWidth: null,
	        parentHeight: null
	      };
	
	      _this.handleResize = (0, _debounce2.default)(_this.resize.bind(_this), props.windowResizeDebounceTime).bind(_this);
	      return _this;
	    }
	
	    _createClass(WrappedComponent, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        window.addEventListener('resize', this.handleResize, false);
	        this.resize();
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        window.removeEventListener('resize', this.handleResize, false);
	      }
	    }, {
	      key: 'resize',
	      value: function resize(event) {
	        if (this.container) {
	          var boundingRect = this.container.getBoundingClientRect();
	          this.setState(function (prevState, props) {
	            return {
	              parentWidth: boundingRect.width,
	              parentHeight: boundingRect.height
	            };
	          });
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this2 = this;
	
	        var _state = this.state,
	            parentWidth = _state.parentWidth,
	            parentHeight = _state.parentHeight;
	
	        return _react2.default.createElement(
	          'div',
	          {
	            style: { width: '100%', height: '100%' },
	            ref: function ref(_ref) {
	              _this2.container = _ref;
	            }
	          },
	          parentWidth !== null && parentHeight !== null && _react2.default.createElement(BaseComponent, _extends({
	            parentWidth: parentWidth,
	            parentHeight: parentHeight
	          }, this.props))
	        );
	      }
	    }]);
	
	    return WrappedComponent;
	  }(_react2.default.Component);
	
	  WrappedComponent.defaultProps = {
	    windowResizeDebounceTime: 300
	  };
	
	  return WrappedComponent;
	}

/***/ }),

/***/ "./node_modules/@vx/responsive/build/enhancers/withScreenSize.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = withScreenSize;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _debounce = __webpack_require__("./node_modules/lodash/debounce.js");
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withScreenSize(BaseComponent) {
	  var WrappedComponent = function (_React$Component) {
	    _inherits(WrappedComponent, _React$Component);
	
	    function WrappedComponent(props) {
	      _classCallCheck(this, WrappedComponent);
	
	      var _this = _possibleConstructorReturn(this, (WrappedComponent.__proto__ || Object.getPrototypeOf(WrappedComponent)).call(this, props));
	
	      _this.state = {
	        screenWidth: null,
	        screenHeight: null
	      };
	
	      _this.handleResize = (0, _debounce2.default)(_this.resize.bind(_this), props.windowResizeDebounceTime).bind(_this);
	      return _this;
	    }
	
	    _createClass(WrappedComponent, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        window.addEventListener('resize', this.handleResize, false);
	        this.resize();
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        window.removeEventListener('resize', this.handleResize, false);
	      }
	    }, {
	      key: 'resize',
	      value: function resize(event) {
	        this.setState(function (prevState, props) {
	          return {
	            screenWidth: window.innerWidth,
	            screenHeight: window.innerHeight
	          };
	        });
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _state = this.state,
	            screenWidth = _state.screenWidth,
	            screenHeight = _state.screenHeight;
	
	        if (!screenWidth && !screenHeight) return null;
	        return _react2.default.createElement(BaseComponent, _extends({
	          screenWidth: screenWidth,
	          screenHeight: screenHeight
	        }, this.props));
	      }
	    }]);
	
	    return WrappedComponent;
	  }(_react2.default.Component);
	
	  WrappedComponent.defaultProps = {
	    windowResizeDebounceTime: 300
	  };
	
	  return WrappedComponent;
	}

/***/ }),

/***/ "./node_modules/@vx/responsive/build/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ScaleSVG = __webpack_require__("./node_modules/@vx/responsive/build/components/ScaleSVG.js");
	
	Object.defineProperty(exports, 'ScaleSVG', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ScaleSVG).default;
	  }
	});
	
	var _withParentSize = __webpack_require__("./node_modules/@vx/responsive/build/enhancers/withParentSize.js");
	
	Object.defineProperty(exports, 'withParentSize', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_withParentSize).default;
	  }
	});
	
	var _withScreenSize = __webpack_require__("./node_modules/@vx/responsive/build/enhancers/withScreenSize.js");
	
	Object.defineProperty(exports, 'withScreenSize', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_withScreenSize).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "./node_modules/@vx/scale/build/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _band = __webpack_require__("./node_modules/@vx/scale/build/scales/band.js");
	
	Object.defineProperty(exports, 'scaleBand', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_band).default;
	  }
	});
	
	var _point = __webpack_require__("./node_modules/@vx/scale/build/scales/point.js");
	
	Object.defineProperty(exports, 'scalePoint', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_point).default;
	  }
	});
	
	var _linear = __webpack_require__("./node_modules/@vx/scale/build/scales/linear.js");
	
	Object.defineProperty(exports, 'scaleLinear', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_linear).default;
	  }
	});
	
	var _time = __webpack_require__("./node_modules/@vx/scale/build/scales/time.js");
	
	Object.defineProperty(exports, 'scaleTime', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_time).default;
	  }
	});
	
	var _utc = __webpack_require__("./node_modules/@vx/scale/build/scales/utc.js");
	
	Object.defineProperty(exports, 'scaleUtc', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_utc).default;
	  }
	});
	
	var _log = __webpack_require__("./node_modules/@vx/scale/build/scales/log.js");
	
	Object.defineProperty(exports, 'scaleLog', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_log).default;
	  }
	});
	
	var _power = __webpack_require__("./node_modules/@vx/scale/build/scales/power.js");
	
	Object.defineProperty(exports, 'scalePower', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_power).default;
	  }
	});
	
	var _ordinal = __webpack_require__("./node_modules/@vx/scale/build/scales/ordinal.js");
	
	Object.defineProperty(exports, 'scaleOrdinal', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ordinal).default;
	  }
	});
	
	var _quantize = __webpack_require__("./node_modules/@vx/scale/build/scales/quantize.js");
	
	Object.defineProperty(exports, 'scaleQuantize', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_quantize).default;
	  }
	});
	
	var _quantile = __webpack_require__("./node_modules/@vx/scale/build/scales/quantile.js");
	
	Object.defineProperty(exports, 'scaleQuantile', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_quantile).default;
	  }
	});
	
	var _threshold = __webpack_require__("./node_modules/@vx/scale/build/scales/threshold.js");
	
	Object.defineProperty(exports, 'scaleThreshold', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_threshold).default;
	  }
	});
	
	var _schemeCategory = __webpack_require__("./node_modules/@vx/scale/build/scales/color/schemeCategory10.js");
	
	Object.defineProperty(exports, 'schemeCategory10', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_schemeCategory).default;
	  }
	});
	
	var _schemeCategory2 = __webpack_require__("./node_modules/@vx/scale/build/scales/color/schemeCategory20.js");
	
	Object.defineProperty(exports, 'schemeCategory20', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_schemeCategory2).default;
	  }
	});
	
	var _schemeCategory20b = __webpack_require__("./node_modules/@vx/scale/build/scales/color/schemeCategory20b.js");
	
	Object.defineProperty(exports, 'schemeCategory20b', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_schemeCategory20b).default;
	  }
	});
	
	var _schemeCategory20c = __webpack_require__("./node_modules/@vx/scale/build/scales/color/schemeCategory20c.js");
	
	Object.defineProperty(exports, 'schemeCategory20c', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_schemeCategory20c).default;
	  }
	});
	
	var _updateScale = __webpack_require__("./node_modules/@vx/scale/build/util/updateScale.js");
	
	Object.defineProperty(exports, 'updateScale', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_updateScale).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "./node_modules/@vx/scale/build/scales/band.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _d3Scale = __webpack_require__("./node_modules/d3-scale/build/d3-scale.js");
	
	exports.default = function (_ref) {
	  var range = _ref.range,
	      rangeRound = _ref.rangeRound,
	      domain = _ref.domain,
	      padding = _ref.padding,
	      paddingInner = _ref.paddingInner,
	      paddingOuter = _ref.paddingOuter,
	      align = _ref.align,
	      tickFormat = _ref.tickFormat;
	
	  var scale = (0, _d3Scale.scaleBand)();
	
	  if (range) scale.range(range);
	  if (rangeRound) scale.rangeRound(rangeRound);
	  if (domain) scale.domain(domain);
	  if (padding) scale.padding(padding);
	  if (paddingInner) scale.paddingInner(paddingInner);
	  if (paddingOuter) scale.paddingOuter(paddingOuter);
	  if (align) scale.align(align);
	  if (tickFormat) scale.tickFormat = tickFormat;
	
	  return scale;
	};

/***/ }),

/***/ "./node_modules/@vx/scale/build/scales/color/schemeCategory10.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ordinal = __webpack_require__("./node_modules/@vx/scale/build/scales/ordinal.js");
	
	var _ordinal2 = _interopRequireDefault(_ordinal);
	
	var _d3Scale = __webpack_require__("./node_modules/d3-scale/build/d3-scale.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _ordinal2.default)(_d3Scale.schemeCategory10);

/***/ }),

/***/ "./node_modules/@vx/scale/build/scales/color/schemeCategory20.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ordinal = __webpack_require__("./node_modules/@vx/scale/build/scales/ordinal.js");
	
	var _ordinal2 = _interopRequireDefault(_ordinal);
	
	var _d3Scale = __webpack_require__("./node_modules/d3-scale/build/d3-scale.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _ordinal2.default)(_d3Scale.schemeCategory20);

/***/ }),

/***/ "./node_modules/@vx/scale/build/scales/color/schemeCategory20b.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ordinal = __webpack_require__("./node_modules/@vx/scale/build/scales/ordinal.js");
	
	var _ordinal2 = _interopRequireDefault(_ordinal);
	
	var _d3Scale = __webpack_require__("./node_modules/d3-scale/build/d3-scale.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _ordinal2.default)(_d3Scale.schemeCategory20b);

/***/ }),

/***/ "./node_modules/@vx/scale/build/scales/color/schemeCategory20c.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ordinal = __webpack_require__("./node_modules/@vx/scale/build/scales/ordinal.js");
	
	var _ordinal2 = _interopRequireDefault(_ordinal);
	
	var _d3Scale = __webpack_require__("./node_modules/d3-scale/build/d3-scale.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _ordinal2.default)(_d3Scale.schemeCategory20c);

/***/ }),

/***/ "./node_modules/@vx/scale/build/scales/linear.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _d3Scale = __webpack_require__("./node_modules/d3-scale/build/d3-scale.js");
	
	exports.default = function (_ref) {
	  var range = _ref.range,
	      rangeRound = _ref.rangeRound,
	      domain = _ref.domain,
	      _ref$nice = _ref.nice,
	      nice = _ref$nice === undefined ? false : _ref$nice,
	      _ref$clamp = _ref.clamp,
	      clamp = _ref$clamp === undefined ? false : _ref$clamp;
	
	  var scale = (0, _d3Scale.scaleLinear)();
	
	  if (range) scale.range(range);
	  if (rangeRound) scale.rangeRound(rangeRound);
	  if (domain) scale.domain(domain);
	  if (nice) scale.nice();
	  if (clamp) scale.clamp(true);
	
	  return scale;
	};

/***/ }),

/***/ "./node_modules/@vx/scale/build/scales/log.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _d3Scale = __webpack_require__("./node_modules/d3-scale/build/d3-scale.js");
	
	exports.default = function (_ref) {
	  var range = _ref.range,
	      rangeRound = _ref.rangeRound,
	      domain = _ref.domain,
	      base = _ref.base,
	      _ref$nice = _ref.nice,
	      nice = _ref$nice === undefined ? false : _ref$nice,
	      _ref$clamp = _ref.clamp,
	      clamp = _ref$clamp === undefined ? false : _ref$clamp;
	
	  var scale = (0, _d3Scale.scaleLog)();
	
	  if (range) scale.range(range);
	  if (rangeRound) scale.rangeRound(rangeRound);
	  if (domain) scale.domain(domain);
	  if (nice) scale.nice();
	  if (clamp) scale.clamp(true);
	  if (base) scale.base(base);
	
	  return scale;
	};

/***/ }),

/***/ "./node_modules/@vx/scale/build/scales/ordinal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _d3Scale = __webpack_require__("./node_modules/d3-scale/build/d3-scale.js");
	
	exports.default = function (_ref) {
	  var range = _ref.range,
	      domain = _ref.domain,
	      unknown = _ref.unknown;
	
	  var scale = (0, _d3Scale.scaleOrdinal)();
	
	  if (range) scale.range(range);
	  if (domain) scale.domain(domain);
	  if (unknown) scale.unknown(unknown);
	
	  return scale;
	};

/***/ }),

/***/ "./node_modules/@vx/scale/build/scales/point.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _d3Scale = __webpack_require__("./node_modules/d3-scale/build/d3-scale.js");
	
	exports.default = function (_ref) {
	  var range = _ref.range,
	      rangeRound = _ref.rangeRound,
	      domain = _ref.domain,
	      padding = _ref.padding,
	      align = _ref.align,
	      _ref$nice = _ref.nice,
	      nice = _ref$nice === undefined ? false : _ref$nice;
	
	  var scale = (0, _d3Scale.scalePoint)();
	
	  if (range) scale.range(range);
	  if (rangeRound) scale.rangeRound(rangeRound);
	  if (domain) scale.domain(domain);
	  if (nice) scale.nice();
	  if (padding) scale.padding(padding);
	  if (align) scale.align(align);
	
	  return scale;
	};

/***/ }),

/***/ "./node_modules/@vx/scale/build/scales/power.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _d3Scale = __webpack_require__("./node_modules/d3-scale/build/d3-scale.js");
	
	exports.default = function (_ref) {
	  var range = _ref.range,
	      rangeRound = _ref.rangeRound,
	      domain = _ref.domain,
	      base = _ref.base,
	      _ref$nice = _ref.nice,
	      nice = _ref$nice === undefined ? false : _ref$nice,
	      _ref$clamp = _ref.clamp,
	      clamp = _ref$clamp === undefined ? false : _ref$clamp;
	
	  var scale = (0, _d3Scale.scalePow)();
	
	  if (range) scale.range(range);
	  if (rangeRound) scale.rangeRound(rangeRound);
	  if (domain) scale.domain(domain);
	  if (nice) scale.nice();
	  if (clamp) scale.clamp(true);
	  if (base) scale.base(base);
	
	  return scale;
	};

/***/ }),

/***/ "./node_modules/@vx/scale/build/scales/quantile.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _d3Scale = __webpack_require__("./node_modules/d3-scale/build/d3-scale.js");
	
	exports.default = function (_ref) {
	  var range = _ref.range,
	      domain = _ref.domain;
	
	  var scale = (0, _d3Scale.scaleQuantile)();
	
	  if (range) scale.range(range);
	  if (domain) scale.domain(domain);
	
	  return scale;
	};

/***/ }),

/***/ "./node_modules/@vx/scale/build/scales/quantize.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _d3Scale = __webpack_require__("./node_modules/d3-scale/build/d3-scale.js");
	
	exports.default = function (_ref) {
	  var range = _ref.range,
	      domain = _ref.domain,
	      ticks = _ref.ticks,
	      tickFormat = _ref.tickFormat,
	      _ref$nice = _ref.nice,
	      nice = _ref$nice === undefined ? false : _ref$nice;
	
	  var scale = (0, _d3Scale.scaleQuantize)();
	
	  if (range) scale.range(range);
	  if (domain) scale.domain(domain);
	  if (nice) scale.nice();
	  if (ticks) scale.ticks(ticks);
	  if (tickFormat) scale.tickFormat(tickFormat);
	
	  return scale;
	};

/***/ }),

/***/ "./node_modules/@vx/scale/build/scales/threshold.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _d3Scale = __webpack_require__("./node_modules/d3-scale/build/d3-scale.js");
	
	exports.default = function (_ref) {
	  var range = _ref.range,
	      domain = _ref.domain;
	
	  var scale = (0, _d3Scale.scaleThreshold)();
	
	  if (range) scale.range(range);
	  if (domain) scale.domain(domain);
	
	  return scale;
	};

/***/ }),

/***/ "./node_modules/@vx/scale/build/scales/time.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _d3Scale = __webpack_require__("./node_modules/d3-scale/build/d3-scale.js");
	
	exports.default = function (_ref) {
	  var range = _ref.range,
	      rangeRound = _ref.rangeRound,
	      domain = _ref.domain,
	      _ref$nice = _ref.nice,
	      nice = _ref$nice === undefined ? false : _ref$nice,
	      _ref$clamp = _ref.clamp,
	      clamp = _ref$clamp === undefined ? false : _ref$clamp;
	
	  var scale = (0, _d3Scale.scaleTime)();
	
	  if (range) scale.range(range);
	  if (rangeRound) scale.rangeRound(rangeRound);
	  if (domain) scale.domain(domain);
	  if (nice) scale.nice();
	  if (clamp) scale.clamp(true);
	
	  return scale;
	};

/***/ }),

/***/ "./node_modules/@vx/scale/build/scales/utc.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _d3Scale = __webpack_require__("./node_modules/d3-scale/build/d3-scale.js");
	
	exports.default = function (_ref) {
	  var range = _ref.range,
	      rangeRound = _ref.rangeRound,
	      domain = _ref.domain,
	      _ref$nice = _ref.nice,
	      nice = _ref$nice === undefined ? false : _ref$nice,
	      _ref$clamp = _ref.clamp,
	      clamp = _ref$clamp === undefined ? false : _ref$clamp;
	
	  var scale = (0, _d3Scale.scaleUtc)();
	
	  if (range) scale.range(range);
	  if (rangeRound) scale.rangeRound(rangeRound);
	  if (domain) scale.domain(domain);
	  if (nice) scale.nice();
	  if (clamp) scale.clamp(true);
	
	  return scale;
	};

/***/ }),

/***/ "./node_modules/@vx/scale/build/util/updateScale.js":
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = updateScale;
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function updateScale(scale, _ref) {
	  var args = _objectWithoutProperties(_ref, []);
	
	  var nextScale = scale.copy();
	  Object.keys(args).forEach(function (key) {
	    if (nextScale.hasOwnProperty(key)) nextScale[key](args[key]);
	  });
	  return nextScale;
	}

/***/ }),

/***/ "./node_modules/@vx/shape/build/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Arc = __webpack_require__("./node_modules/@vx/shape/build/shapes/Arc.js");
	
	Object.defineProperty(exports, 'Arc', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Arc).default;
	  }
	});
	
	var _Line = __webpack_require__("./node_modules/@vx/shape/build/shapes/Line.js");
	
	Object.defineProperty(exports, 'Line', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Line).default;
	  }
	});
	
	var _LinePath = __webpack_require__("./node_modules/@vx/shape/build/shapes/LinePath.js");
	
	Object.defineProperty(exports, 'LinePath', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LinePath).default;
	  }
	});
	
	var _LineRadial = __webpack_require__("./node_modules/@vx/shape/build/shapes/LineRadial.js");
	
	Object.defineProperty(exports, 'LineRadial', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LineRadial).default;
	  }
	});
	
	var _LinkHorizontal = __webpack_require__("./node_modules/@vx/shape/build/shapes/LinkHorizontal.js");
	
	Object.defineProperty(exports, 'LinkHorizontal', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LinkHorizontal).default;
	  }
	});
	
	var _LinkVertical = __webpack_require__("./node_modules/@vx/shape/build/shapes/LinkVertical.js");
	
	Object.defineProperty(exports, 'LinkVertical', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LinkVertical).default;
	  }
	});
	
	var _LinkRadial = __webpack_require__("./node_modules/@vx/shape/build/shapes/LinkRadial.js");
	
	Object.defineProperty(exports, 'LinkRadial', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LinkRadial).default;
	  }
	});
	
	var _AreaClosed = __webpack_require__("./node_modules/@vx/shape/build/shapes/AreaClosed.js");
	
	Object.defineProperty(exports, 'AreaClosed', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AreaClosed).default;
	  }
	});
	
	var _AreaStack = __webpack_require__("./node_modules/@vx/shape/build/shapes/AreaStack.js");
	
	Object.defineProperty(exports, 'AreaStack', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AreaStack).default;
	  }
	});
	
	var _Bar = __webpack_require__("./node_modules/@vx/shape/build/shapes/Bar.js");
	
	Object.defineProperty(exports, 'Bar', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Bar).default;
	  }
	});
	
	var _BarGroup = __webpack_require__("./node_modules/@vx/shape/build/shapes/BarGroup.js");
	
	Object.defineProperty(exports, 'BarGroup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BarGroup).default;
	  }
	});
	
	var _BarStack = __webpack_require__("./node_modules/@vx/shape/build/shapes/BarStack.js");
	
	Object.defineProperty(exports, 'BarStack', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BarStack).default;
	  }
	});
	
	var _callOrValue = __webpack_require__("./node_modules/@vx/shape/build/util/callOrValue.js");
	
	Object.defineProperty(exports, 'callOrValue', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_callOrValue).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "./node_modules/@vx/shape/build/shapes/Arc.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Arc;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _group = __webpack_require__("./node_modules/@vx/group/build/index.js");
	
	var _d3Shape = __webpack_require__("./node_modules/d3-shape/build/d3-shape.js");
	
	var _additionalProps = __webpack_require__("./node_modules/@vx/shape/build/util/additionalProps.js");
	
	var _additionalProps2 = _interopRequireDefault(_additionalProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function Arc(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$top = _ref.top,
	      top = _ref$top === undefined ? 0 : _ref$top,
	      _ref$left = _ref.left,
	      left = _ref$left === undefined ? 0 : _ref$left,
	      data = _ref.data,
	      centroid = _ref.centroid,
	      _ref$innerRadius = _ref.innerRadius,
	      innerRadius = _ref$innerRadius === undefined ? 0 : _ref$innerRadius,
	      outerRadius = _ref.outerRadius,
	      cornerRadius = _ref.cornerRadius,
	      _ref$startAngle = _ref.startAngle,
	      startAngle = _ref$startAngle === undefined ? 0 : _ref$startAngle,
	      endAngle = _ref.endAngle,
	      padAngle = _ref.padAngle,
	      padRadius = _ref.padRadius,
	      pieSort = _ref.pieSort,
	      pieValue = _ref.pieValue,
	      restProps = _objectWithoutProperties(_ref, ['className', 'top', 'left', 'data', 'centroid', 'innerRadius', 'outerRadius', 'cornerRadius', 'startAngle', 'endAngle', 'padAngle', 'padRadius', 'pieSort', 'pieValue']);
	
	  var path = (0, _d3Shape.arc)();
	  path.innerRadius(innerRadius);
	  if (outerRadius) path.outerRadius(outerRadius);
	  if (cornerRadius) path.cornerRadius(cornerRadius);
	  if (padRadius) path.padRadius(padRadius);
	  var pie = (0, _d3Shape.pie)();
	  if (pieSort) pie.sort(pieSort);
	  if (pieValue) pie.value(pieValue);
	  if (padAngle) pie.padAngle(padAngle);
	  var arcs = pie(data);
	  return _react2.default.createElement(
	    _group.Group,
	    { className: 'vx-arcs-group', top: top, left: left },
	    arcs.map(function (arc, i) {
	      var c = void 0;
	      if (centroid) c = path.centroid(arc);
	      return _react2.default.createElement(
	        'g',
	        { key: 'arc-' + i },
	        _react2.default.createElement('path', _extends({
	          className: (0, _classnames2.default)('vx-arc', className),
	          d: path(arc)
	        }, (0, _additionalProps2.default)(restProps, _extends({}, arc, { index: i, centroid: c })))),
	        centroid && centroid(c, arc)
	      );
	    })
	  );
	}

/***/ }),

/***/ "./node_modules/@vx/shape/build/shapes/AreaClosed.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = AreaClosed;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _d3Shape = __webpack_require__("./node_modules/d3-shape/build/d3-shape.js");
	
	var _additionalProps = __webpack_require__("./node_modules/@vx/shape/build/util/additionalProps.js");
	
	var _additionalProps2 = _interopRequireDefault(_additionalProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function AreaClosed(_ref) {
	  var x = _ref.x,
	      y = _ref.y,
	      xScale = _ref.xScale,
	      yScale = _ref.yScale,
	      data = _ref.data,
	      _ref$defined = _ref.defined,
	      defined = _ref$defined === undefined ? function () {
	    return true;
	  } : _ref$defined,
	      className = _ref.className,
	      strokeDasharray = _ref.strokeDasharray,
	      _ref$strokeWidth = _ref.strokeWidth,
	      strokeWidth = _ref$strokeWidth === undefined ? 2 : _ref$strokeWidth,
	      _ref$stroke = _ref.stroke,
	      stroke = _ref$stroke === undefined ? 'black' : _ref$stroke,
	      _ref$fill = _ref.fill,
	      fill = _ref$fill === undefined ? 'rgba(0,0,0,0.3)' : _ref$fill,
	      curve = _ref.curve,
	      restProps = _objectWithoutProperties(_ref, ['x', 'y', 'xScale', 'yScale', 'data', 'defined', 'className', 'strokeDasharray', 'strokeWidth', 'stroke', 'fill', 'curve']);
	
	  var path = (0, _d3Shape.area)().x(function (d) {
	    return xScale(x(d));
	  }).y0(yScale.range()[0]).y1(function (d) {
	    return yScale(y(d));
	  }).defined(defined);
	  if (curve) path.curve(curve);
	  return _react2.default.createElement(
	    'g',
	    null,
	    _react2.default.createElement('path', _extends({
	      className: (0, _classnames2.default)('vx-area-closed', className),
	      d: path(data),
	      stroke: stroke,
	      strokeWidth: strokeWidth,
	      strokeDasharray: strokeDasharray,
	      fill: fill
	    }, (0, _additionalProps2.default)(restProps, data)))
	  );
	}

/***/ }),

/***/ "./node_modules/@vx/shape/build/shapes/AreaStack.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = AreaStack;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _additionalProps = __webpack_require__("./node_modules/@vx/shape/build/util/additionalProps.js");
	
	var _additionalProps2 = _interopRequireDefault(_additionalProps);
	
	var _d3Shape = __webpack_require__("./node_modules/d3-shape/build/d3-shape.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function AreaStack(_ref) {
	  var className = _ref.className,
	      _ref$top = _ref.top,
	      top = _ref$top === undefined ? 0 : _ref$top,
	      _ref$left = _ref.left,
	      left = _ref$left === undefined ? 0 : _ref$left,
	      keys = _ref.keys,
	      data = _ref.data,
	      curve = _ref.curve,
	      defined = _ref.defined,
	      x = _ref.x,
	      x0 = _ref.x0,
	      x1 = _ref.x1,
	      y0 = _ref.y0,
	      y1 = _ref.y1,
	      glyph = _ref.glyph,
	      _ref$reverse = _ref.reverse,
	      reverse = _ref$reverse === undefined ? false : _ref$reverse,
	      restProps = _objectWithoutProperties(_ref, ['className', 'top', 'left', 'keys', 'data', 'curve', 'defined', 'x', 'x0', 'x1', 'y0', 'y1', 'glyph', 'reverse']);
	
	  var stack = (0, _d3Shape.stack)();
	  if (keys) stack.keys(keys);
	
	  var path = (0, _d3Shape.area)();
	  if (x) path.x(x);
	  if (x0) path.x0(x0);
	  if (x1) path.x1(x1);
	  if (y0) path.y0(y0);
	  if (y1) path.y1(y1);
	  if (curve) path.curve(curve);
	  if (defined) path.defined(defined);
	
	  var seriesData = stack(data);
	  if (reverse) seriesData.reverse();
	
	  return _react2.default.createElement(
	    'g',
	    null,
	    seriesData.map(function (series, i) {
	      return _react2.default.createElement('path', _extends({
	        className: (0, _classnames2.default)('vx-area-stack', className),
	        key: 'area-stack-' + i + '-' + (series.key || ''),
	        d: path(series)
	      }, (0, _additionalProps2.default)(restProps, {
	        datum: series[i],
	        index: i,
	        series: series
	      })));
	    }),
	    !!glyph && _react2.default.createElement(
	      'g',
	      { className: 'vx-area-stack-glyphs' },
	      data.map(glyph)
	    )
	  );
	}

/***/ }),

/***/ "./node_modules/@vx/shape/build/shapes/Bar.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _additionalProps = __webpack_require__("./node_modules/@vx/shape/build/util/additionalProps.js");
	
	var _additionalProps2 = _interopRequireDefault(_additionalProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = function (_ref) {
	  var className = _ref.className,
	      data = _ref.data,
	      _ref$x = _ref.x,
	      x = _ref$x === undefined ? 0 : _ref$x,
	      _ref$y = _ref.y,
	      y = _ref$y === undefined ? 0 : _ref$y,
	      width = _ref.width,
	      height = _ref.height,
	      rx = _ref.rx,
	      ry = _ref.ry,
	      _ref$fill = _ref.fill,
	      fill = _ref$fill === undefined ? 'steelblue' : _ref$fill,
	      fillOpacity = _ref.fillOpacity,
	      stroke = _ref.stroke,
	      strokeWidth = _ref.strokeWidth,
	      strokeDasharray = _ref.strokeDasharray,
	      strokeLinecap = _ref.strokeLinecap,
	      strokeLinejoin = _ref.strokeLinejoin,
	      strokeMiterlimit = _ref.strokeMiterlimit,
	      strokeOpacity = _ref.strokeOpacity,
	      restProps = _objectWithoutProperties(_ref, ['className', 'data', 'x', 'y', 'width', 'height', 'rx', 'ry', 'fill', 'fillOpacity', 'stroke', 'strokeWidth', 'strokeDasharray', 'strokeLinecap', 'strokeLinejoin', 'strokeMiterlimit', 'strokeOpacity']);
	
	  return _react2.default.createElement('rect', _extends({
	    className: (0, _classnames2.default)('vx-bar', className),
	    x: x,
	    y: y,
	    width: width,
	    height: height,
	    rx: rx,
	    ry: ry,
	    fill: fill,
	    fillOpacity: fillOpacity,
	    stroke: stroke,
	    strokeWidth: strokeWidth,
	    strokeDasharray: strokeDasharray,
	    strokeLinecap: strokeLinecap,
	    strokeLinejoin: strokeLinejoin,
	    strokeMiterlimit: strokeMiterlimit,
	    strokeOpacity: strokeOpacity
	  }, (0, _additionalProps2.default)(restProps, data)));
	};

/***/ }),

/***/ "./node_modules/@vx/shape/build/shapes/BarGroup.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = BarGroup;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _group = __webpack_require__("./node_modules/@vx/group/build/index.js");
	
	var _Bar = __webpack_require__("./node_modules/@vx/shape/build/shapes/Bar.js");
	
	var _Bar2 = _interopRequireDefault(_Bar);
	
	var _additionalProps = __webpack_require__("./node_modules/@vx/shape/build/util/additionalProps.js");
	
	var _additionalProps2 = _interopRequireDefault(_additionalProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function BarGroup(_ref) {
	  var data = _ref.data,
	      className = _ref.className,
	      top = _ref.top,
	      left = _ref.left,
	      x0 = _ref.x0,
	      x0Scale = _ref.x0Scale,
	      x1Scale = _ref.x1Scale,
	      yScale = _ref.yScale,
	      zScale = _ref.zScale,
	      keys = _ref.keys,
	      height = _ref.height,
	      restProps = _objectWithoutProperties(_ref, ['data', 'className', 'top', 'left', 'x0', 'x0Scale', 'x1Scale', 'yScale', 'zScale', 'keys', 'height']);
	
	  var format = x0Scale.tickFormat ? x0Scale.tickFormat() : function (d) {
	    return d;
	  };
	  return _react2.default.createElement(
	    _group.Group,
	    {
	      className: (0, _classnames2.default)('vx-bar-group', className),
	      top: top,
	      left: left
	    },
	    data && data.map(function (d, i) {
	      return _react2.default.createElement(
	        _group.Group,
	        {
	          key: 'bar-group-' + i + '-' + x0(d),
	          left: x0Scale(x0(d))
	        },
	        keys && keys.map(function (key, i) {
	          var value = d[key];
	          return _react2.default.createElement(_Bar2.default, _extends({
	            key: 'bar-group-bar-' + i + '-' + value + '-' + key,
	            x: x1Scale(key),
	            y: yScale(value),
	            width: x1Scale.bandwidth(),
	            height: height - yScale(value),
	            fill: zScale(key),
	            data: {
	              key: key,
	              value: value,
	              x: format(x0(d)),
	              data: d
	            }
	          }, restProps));
	        })
	      );
	    })
	  );
	}
	
	BarGroup.propTypes = {
	  data: _propTypes2.default.array.isRequired,
	  x0: _propTypes2.default.func.isRequired,
	  x0Scale: _propTypes2.default.func.isRequired,
	  x1Scale: _propTypes2.default.func.isRequired,
	  yScale: _propTypes2.default.func.isRequired,
	  zScale: _propTypes2.default.func.isRequired,
	  keys: _propTypes2.default.array.isRequired,
	  height: _propTypes2.default.number.isRequired,
	  className: _propTypes2.default.string,
	  top: _propTypes2.default.number,
	  left: _propTypes2.default.number
	};

/***/ }),

/***/ "./node_modules/@vx/shape/build/shapes/BarStack.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = BarStack;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _group = __webpack_require__("./node_modules/@vx/group/build/index.js");
	
	var _Bar = __webpack_require__("./node_modules/@vx/shape/build/shapes/Bar.js");
	
	var _Bar2 = _interopRequireDefault(_Bar);
	
	var _d3Shape = __webpack_require__("./node_modules/d3-shape/build/d3-shape.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function BarStack(_ref) {
	  var data = _ref.data,
	      className = _ref.className,
	      top = _ref.top,
	      left = _ref.left,
	      x = _ref.x,
	      xScale = _ref.xScale,
	      yScale = _ref.yScale,
	      zScale = _ref.zScale,
	      keys = _ref.keys,
	      height = _ref.height,
	      restProps = _objectWithoutProperties(_ref, ['data', 'className', 'top', 'left', 'x', 'xScale', 'yScale', 'zScale', 'keys', 'height']);
	
	  var series = (0, _d3Shape.stack)().keys(keys)(data);
	  var format = xScale.tickFormat ? xScale.tickFormat() : function (d) {
	    return d;
	  };
	  var bandwidth = xScale.bandwidth();
	  var step = xScale.step();
	  var paddingInner = xScale.paddingInner();
	  var paddingOuter = xScale.paddingOuter();
	  return _react2.default.createElement(
	    _group.Group,
	    { className: (0, _classnames2.default)('vx-bar-stack', className), top: top, left: left },
	    series && series.map(function (s, i) {
	      return _react2.default.createElement(
	        _group.Group,
	        { key: 'vx-bar-stack-' + i },
	        s.map(function (d, ii) {
	          var barHeight = yScale(d[0]) - yScale(d[1]);
	          return _react2.default.createElement(_Bar2.default, _extends({
	            key: 'bar-group-bar-' + i + '-' + ii + '-' + s.key,
	            x: xScale(x(d.data)),
	            y: yScale(d[1]),
	            width: bandwidth,
	            height: barHeight,
	            fill: zScale(s.key),
	            data: {
	              bandwidth: bandwidth,
	              paddingInner: paddingInner,
	              paddingOuter: paddingOuter,
	              step: step,
	              key: s.key,
	              value: d[1],
	              height: barHeight,
	              width: bandwidth,
	              x: x(d.data),
	              xFormatted: format(x(d.data)),
	              data: d.data
	            }
	          }, restProps));
	        })
	      );
	    })
	  );
	}
	
	BarStack.propTypes = {
	  data: _propTypes2.default.array.isRequired,
	  x: _propTypes2.default.func.isRequired,
	  xScale: _propTypes2.default.func.isRequired,
	  yScale: _propTypes2.default.func.isRequired,
	  zScale: _propTypes2.default.func.isRequired,
	  keys: _propTypes2.default.array.isRequired,
	  className: _propTypes2.default.string,
	  top: _propTypes2.default.number,
	  left: _propTypes2.default.number
	};

/***/ }),

/***/ "./node_modules/@vx/shape/build/shapes/Line.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Line;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _point = __webpack_require__("./node_modules/@vx/point/build/index.js");
	
	var _additionalProps = __webpack_require__("./node_modules/@vx/shape/build/util/additionalProps.js");
	
	var _additionalProps2 = _interopRequireDefault(_additionalProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function Line(_ref) {
	  var _ref$from = _ref.from,
	      from = _ref$from === undefined ? new _point.Point({ x: 0, y: 0 }) : _ref$from,
	      _ref$to = _ref.to,
	      to = _ref$to === undefined ? new _point.Point({ x: 1, y: 1 }) : _ref$to,
	      _ref$stroke = _ref.stroke,
	      stroke = _ref$stroke === undefined ? 'black' : _ref$stroke,
	      _ref$strokeWidth = _ref.strokeWidth,
	      strokeWidth = _ref$strokeWidth === undefined ? 1 : _ref$strokeWidth,
	      _ref$strokeDasharray = _ref.strokeDasharray,
	      strokeDasharray = _ref$strokeDasharray === undefined ? '' : _ref$strokeDasharray,
	      _ref$transform = _ref.transform,
	      transform = _ref$transform === undefined ? '' : _ref$transform,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      data = _ref.data,
	      restProps = _objectWithoutProperties(_ref, ['from', 'to', 'stroke', 'strokeWidth', 'strokeDasharray', 'transform', 'className', 'data']);
	
	  return _react2.default.createElement('line', _extends({
	    className: (0, _classnames2.default)('vx-line', className),
	    x1: from.x,
	    y1: from.y,
	    x2: to.x,
	    y2: to.y,
	    stroke: stroke,
	    strokeWidth: strokeWidth,
	    strokeDasharray: strokeDasharray,
	    transform: transform
	  }, (0, _additionalProps2.default)(restProps, data)));
	}

/***/ }),

/***/ "./node_modules/@vx/shape/build/shapes/LinePath.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = LinePath;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _d3Shape = __webpack_require__("./node_modules/d3-shape/build/d3-shape.js");
	
	var _curve = __webpack_require__("./node_modules/@vx/curve/build/index.js");
	
	var _additionalProps = __webpack_require__("./node_modules/@vx/shape/build/util/additionalProps.js");
	
	var _additionalProps2 = _interopRequireDefault(_additionalProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function LinePath(_ref) {
	  var data = _ref.data,
	      xScale = _ref.xScale,
	      yScale = _ref.yScale,
	      x = _ref.x,
	      y = _ref.y,
	      _ref$defined = _ref.defined,
	      defined = _ref$defined === undefined ? function () {
	    return true;
	  } : _ref$defined,
	      className = _ref.className,
	      innerRef = _ref.innerRef,
	      _ref$stroke = _ref.stroke,
	      stroke = _ref$stroke === undefined ? 'steelblue' : _ref$stroke,
	      _ref$strokeWidth = _ref.strokeWidth,
	      strokeWidth = _ref$strokeWidth === undefined ? 2 : _ref$strokeWidth,
	      _ref$strokeDasharray = _ref.strokeDasharray,
	      strokeDasharray = _ref$strokeDasharray === undefined ? '' : _ref$strokeDasharray,
	      _ref$strokeDashoffset = _ref.strokeDashoffset,
	      strokeDashoffset = _ref$strokeDashoffset === undefined ? 0 : _ref$strokeDashoffset,
	      _ref$fill = _ref.fill,
	      fill = _ref$fill === undefined ? 'none' : _ref$fill,
	      _ref$curve = _ref.curve,
	      curve = _ref$curve === undefined ? _curve.curveLinear : _ref$curve,
	      glyph = _ref.glyph,
	      restProps = _objectWithoutProperties(_ref, ['data', 'innerRef', 'xScale', 'yScale', 'x', 'y', 'defined', 'className', 'stroke', 'strokeWidth', 'strokeDasharray', 'strokeDashoffset', 'fill', 'curve', 'glyph']);
	
	  var path = (0, _d3Shape.line)().x(function (d) {
	    return xScale(x(d));
	  }).y(function (d) {
	    return yScale(y(d));
	  }).defined(defined).curve(curve);
	  return _react2.default.createElement(
	    'g',
	    null,
	    _react2.default.createElement('path', _extends({
	      className: (0, _classnames2.default)('vx-linepath', className),
	      d: path(data),
	      ref: innerRef,
	      stroke: stroke,
	      strokeWidth: strokeWidth,
	      strokeDasharray: strokeDasharray,
	      strokeDashoffset: strokeDashoffset,
	      fill: fill
	    }, (0, _additionalProps2.default)(restProps, data))),
	    glyph && _react2.default.createElement(
	      'g',
	      { className: 'vx-linepath-glyphs' },
	      data.map(glyph)
	    )
	  );
	}


/***/ }),

/***/ "./node_modules/@vx/shape/build/shapes/LineRadial.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = LineRadial;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _d3Shape = __webpack_require__("./node_modules/d3-shape/build/d3-shape.js");
	
	var _additionalProps = __webpack_require__("./node_modules/@vx/shape/build/util/additionalProps.js");
	
	var _additionalProps2 = _interopRequireDefault(_additionalProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function LineRadial(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      angle = _ref.angle,
	      radius = _ref.radius,
	      defined = _ref.defined,
	      curve = _ref.curve,
	      data = _ref.data,
	      restProps = _objectWithoutProperties(_ref, ['className', 'angle', 'radius', 'defined', 'curve', 'data']);
	
	  var path = (0, _d3Shape.radialLine)();
	  if (angle) path.angle(angle);
	  if (radius) path.radius(radius);
	  if (defined) path.defined(defined);
	  if (curve) path.curve(curve);
	  return _react2.default.createElement(
	    'g',
	    null,
	    _react2.default.createElement('path', _extends({
	      className: (0, _classnames2.default)('vx-line-radial', className),
	      d: path(data)
	    }, (0, _additionalProps2.default)(restProps, data)))
	  );
	}

/***/ }),

/***/ "./node_modules/@vx/shape/build/shapes/LinkHorizontal.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = LinkHorizontal;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _d3Shape = __webpack_require__("./node_modules/d3-shape/build/d3-shape.js");
	
	var _additionalProps = __webpack_require__("./node_modules/@vx/shape/build/util/additionalProps.js");
	
	var _additionalProps2 = _interopRequireDefault(_additionalProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function LinkHorizontal(_ref) {
	  var className = _ref.className,
	      data = _ref.data,
	      _ref$x = _ref.x,
	      x = _ref$x === undefined ? function (d) {
	    return d.y;
	  } : _ref$x,
	      _ref$y = _ref.y,
	      y = _ref$y === undefined ? function (d) {
	    return d.x;
	  } : _ref$y,
	      restProps = _objectWithoutProperties(_ref, ['className', 'data', 'x', 'y']);
	
	  var link = (0, _d3Shape.linkHorizontal)();
	  link.x(x);
	  link.y(y);
	  return _react2.default.createElement('path', _extends({
	    className: (0, _classnames2.default)('vx-link-horizontal', className),
	    d: link(data)
	  }, (0, _additionalProps2.default)(restProps, data)));
	}

/***/ }),

/***/ "./node_modules/@vx/shape/build/shapes/LinkRadial.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = LinkRadial;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _d3Shape = __webpack_require__("./node_modules/d3-shape/build/d3-shape.js");
	
	var _additionalProps = __webpack_require__("./node_modules/@vx/shape/build/util/additionalProps.js");
	
	var _additionalProps2 = _interopRequireDefault(_additionalProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function LinkRadial(_ref) {
	  var className = _ref.className,
	      data = _ref.data,
	      _ref$angle = _ref.angle,
	      angle = _ref$angle === undefined ? function (d) {
	    return d.x;
	  } : _ref$angle,
	      _ref$radius = _ref.radius,
	      radius = _ref$radius === undefined ? function (d) {
	    return d.y;
	  } : _ref$radius,
	      restProps = _objectWithoutProperties(_ref, ['className', 'data', 'angle', 'radius']);
	
	  var link = (0, _d3Shape.linkRadial)();
	  link.angle(angle);
	  link.radius(radius);
	  return _react2.default.createElement('path', _extends({
	    className: (0, _classnames2.default)('vx-link-radius', className),
	    d: link(data)
	  }, (0, _additionalProps2.default)(restProps, data)));
	}

/***/ }),

/***/ "./node_modules/@vx/shape/build/shapes/LinkVertical.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = LinkVertical;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _d3Shape = __webpack_require__("./node_modules/d3-shape/build/d3-shape.js");
	
	var _additionalProps = __webpack_require__("./node_modules/@vx/shape/build/util/additionalProps.js");
	
	var _additionalProps2 = _interopRequireDefault(_additionalProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function LinkVertical(_ref) {
	  var className = _ref.className,
	      data = _ref.data,
	      _ref$x = _ref.x,
	      x = _ref$x === undefined ? function (d) {
	    return d.x;
	  } : _ref$x,
	      _ref$y = _ref.y,
	      y = _ref$y === undefined ? function (d) {
	    return d.y;
	  } : _ref$y,
	      restProps = _objectWithoutProperties(_ref, ['className', 'data', 'x', 'y']);
	
	  var link = (0, _d3Shape.linkVertical)();
	  link.x(x);
	  link.y(y);
	  return _react2.default.createElement('path', _extends({
	    className: (0, _classnames2.default)('vx-link-vertical', className),
	    d: link(data)
	  }, (0, _additionalProps2.default)(restProps, data)));
	}

/***/ }),

/***/ "./node_modules/@vx/shape/build/util/additionalProps.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = additionalProps;
	
	var _callOrValue = __webpack_require__("./node_modules/@vx/shape/build/util/callOrValue.js");
	
	var _callOrValue2 = _interopRequireDefault(_callOrValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function additionalProps(restProps, data) {
	  return Object.keys(restProps).reduce(function (ret, cur) {
	    ret[cur] = (0, _callOrValue2.default)(restProps[cur], data);
	    return ret;
	  }, {});
	}

/***/ }),

/***/ "./node_modules/@vx/shape/build/util/callOrValue.js":
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = callOrValue;
	function callOrValue(maybeFn, data) {
	  if (typeof maybeFn === 'function') {
	    return maybeFn(data);
	  }
	  return maybeFn;
	}

/***/ }),

/***/ "./node_modules/classnames/index.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),

/***/ "./node_modules/d3-array/build/d3-array.js":
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-array/ Version 1.2.0. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var ascending = function(a, b) {
	  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	};
	
	var bisector = function(compare) {
	  if (compare.length === 1) compare = ascendingComparator(compare);
	  return {
	    left: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) < 0) lo = mid + 1;
	        else hi = mid;
	      }
	      return lo;
	    },
	    right: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) > 0) hi = mid;
	        else lo = mid + 1;
	      }
	      return lo;
	    }
	  };
	};
	
	function ascendingComparator(f) {
	  return function(d, x) {
	    return ascending(f(d), x);
	  };
	}
	
	var ascendingBisect = bisector(ascending);
	var bisectRight = ascendingBisect.right;
	var bisectLeft = ascendingBisect.left;
	
	var pairs = function(array, f) {
	  if (f == null) f = pair;
	  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
	  while (i < n) pairs[i] = f(p, p = array[++i]);
	  return pairs;
	};
	
	function pair(a, b) {
	  return [a, b];
	}
	
	var cross = function(values0, values1, reduce) {
	  var n0 = values0.length,
	      n1 = values1.length,
	      values = new Array(n0 * n1),
	      i0,
	      i1,
	      i,
	      value0;
	
	  if (reduce == null) reduce = pair;
	
	  for (i0 = i = 0; i0 < n0; ++i0) {
	    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
	      values[i] = reduce(value0, values1[i1]);
	    }
	  }
	
	  return values;
	};
	
	var descending = function(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	};
	
	var number = function(x) {
	  return x === null ? NaN : +x;
	};
	
	var variance = function(values, valueof) {
	  var n = values.length,
	      m = 0,
	      i = -1,
	      mean = 0,
	      value,
	      delta,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  if (m > 1) return sum / (m - 1);
	};
	
	var deviation = function(array, f) {
	  var v = variance(array, f);
	  return v ? Math.sqrt(v) : v;
	};
	
	var extent = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return [min, max];
	};
	
	var array = Array.prototype;
	
	var slice = array.slice;
	var map = array.map;
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var identity = function(x) {
	  return x;
	};
	
	var range = function(start, stop, step) {
	  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
	
	  var i = -1,
	      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
	      range = new Array(n);
	
	  while (++i < n) {
	    range[i] = start + i * step;
	  }
	
	  return range;
	};
	
	var e10 = Math.sqrt(50);
	var e5 = Math.sqrt(10);
	var e2 = Math.sqrt(2);
	
	var ticks = function(start, stop, count) {
	  var reverse = stop < start,
	      i = -1,
	      n,
	      ticks,
	      step;
	
	  if (reverse) n = start, start = stop, stop = n;
	
	  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
	
	  if (step > 0) {
	    start = Math.ceil(start / step);
	    stop = Math.floor(stop / step);
	    ticks = new Array(n = Math.ceil(stop - start + 1));
	    while (++i < n) ticks[i] = (start + i) * step;
	  } else {
	    start = Math.floor(start * step);
	    stop = Math.ceil(stop * step);
	    ticks = new Array(n = Math.ceil(start - stop + 1));
	    while (++i < n) ticks[i] = (start - i) / step;
	  }
	
	  if (reverse) ticks.reverse();
	
	  return ticks;
	};
	
	function tickIncrement(start, stop, count) {
	  var step = (stop - start) / Math.max(0, count),
	      power = Math.floor(Math.log(step) / Math.LN10),
	      error = step / Math.pow(10, power);
	  return power >= 0
	      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
	      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
	}
	
	function tickStep(start, stop, count) {
	  var step0 = Math.abs(stop - start) / Math.max(0, count),
	      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
	      error = step0 / step1;
	  if (error >= e10) step1 *= 10;
	  else if (error >= e5) step1 *= 5;
	  else if (error >= e2) step1 *= 2;
	  return stop < start ? -step1 : step1;
	}
	
	var sturges = function(values) {
	  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
	};
	
	var histogram = function() {
	  var value = identity,
	      domain = extent,
	      threshold = sturges;
	
	  function histogram(data) {
	    var i,
	        n = data.length,
	        x,
	        values = new Array(n);
	
	    for (i = 0; i < n; ++i) {
	      values[i] = value(data[i], i, data);
	    }
	
	    var xz = domain(values),
	        x0 = xz[0],
	        x1 = xz[1],
	        tz = threshold(values, x0, x1);
	
	    // Convert number of thresholds into uniform thresholds.
	    if (!Array.isArray(tz)) {
	      tz = tickStep(x0, x1, tz);
	      tz = range(Math.ceil(x0 / tz) * tz, Math.floor(x1 / tz) * tz, tz); // exclusive
	    }
	
	    // Remove any thresholds outside the domain.
	    var m = tz.length;
	    while (tz[0] <= x0) tz.shift(), --m;
	    while (tz[m - 1] > x1) tz.pop(), --m;
	
	    var bins = new Array(m + 1),
	        bin;
	
	    // Initialize bins.
	    for (i = 0; i <= m; ++i) {
	      bin = bins[i] = [];
	      bin.x0 = i > 0 ? tz[i - 1] : x0;
	      bin.x1 = i < m ? tz[i] : x1;
	    }
	
	    // Assign data to bins by value, ignoring any outside the domain.
	    for (i = 0; i < n; ++i) {
	      x = values[i];
	      if (x0 <= x && x <= x1) {
	        bins[bisectRight(tz, x, 0, m)].push(data[i]);
	      }
	    }
	
	    return bins;
	  }
	
	  histogram.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(_), histogram) : value;
	  };
	
	  histogram.domain = function(_) {
	    return arguments.length ? (domain = typeof _ === "function" ? _ : constant([_[0], _[1]]), histogram) : domain;
	  };
	
	  histogram.thresholds = function(_) {
	    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), histogram) : threshold;
	  };
	
	  return histogram;
	};
	
	var quantile = function(values, p, valueof) {
	  if (valueof == null) valueof = number;
	  if (!(n = values.length)) return;
	  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
	  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
	  var n,
	      i = (n - 1) * p,
	      i0 = Math.floor(i),
	      value0 = +valueof(values[i0], i0, values),
	      value1 = +valueof(values[i0 + 1], i0 + 1, values);
	  return value0 + (value1 - value0) * (i - i0);
	};
	
	var freedmanDiaconis = function(values, min, max) {
	  values = map.call(values, number).sort(ascending);
	  return Math.ceil((max - min) / (2 * (quantile(values, 0.75) - quantile(values, 0.25)) * Math.pow(values.length, -1 / 3)));
	};
	
	var scott = function(values, min, max) {
	  return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
	};
	
	var max = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return max;
	};
	
	var mean = function(values, valueof) {
	  var n = values.length,
	      m = n,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) sum += value;
	      else --m;
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) sum += value;
	      else --m;
	    }
	  }
	
	  if (m) return sum / m;
	};
	
	var median = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      numbers = [];
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  return quantile(numbers.sort(ascending), 0.5);
	};
	
	var merge = function(arrays) {
	  var n = arrays.length,
	      m,
	      i = -1,
	      j = 0,
	      merged,
	      array;
	
	  while (++i < n) j += arrays[i].length;
	  merged = new Array(j);
	
	  while (--n >= 0) {
	    array = arrays[n];
	    m = array.length;
	    while (--m >= 0) {
	      merged[--j] = array[m];
	    }
	  }
	
	  return merged;
	};
	
	var min = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  return min;
	};
	
	var permute = function(array, indexes) {
	  var i = indexes.length, permutes = new Array(i);
	  while (i--) permutes[i] = array[indexes[i]];
	  return permutes;
	};
	
	var scan = function(values, compare) {
	  if (!(n = values.length)) return;
	  var n,
	      i = 0,
	      j = 0,
	      xi,
	      xj = values[j];
	
	  if (compare == null) compare = ascending;
	
	  while (++i < n) {
	    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
	      xj = xi, j = i;
	    }
	  }
	
	  if (compare(xj, xj) === 0) return j;
	};
	
	var shuffle = function(array, i0, i1) {
	  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
	      t,
	      i;
	
	  while (m) {
	    i = Math.random() * m-- | 0;
	    t = array[m + i0];
	    array[m + i0] = array[i + i0];
	    array[i + i0] = t;
	  }
	
	  return array;
	};
	
	var sum = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (value = +valueof(values[i], i, values)) sum += value;
	    }
	  }
	
	  return sum;
	};
	
	var transpose = function(matrix) {
	  if (!(n = matrix.length)) return [];
	  for (var i = -1, m = min(matrix, length), transpose = new Array(m); ++i < m;) {
	    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
	      row[j] = matrix[j][i];
	    }
	  }
	  return transpose;
	};
	
	function length(d) {
	  return d.length;
	}
	
	var zip = function() {
	  return transpose(arguments);
	};
	
	exports.bisect = bisectRight;
	exports.bisectRight = bisectRight;
	exports.bisectLeft = bisectLeft;
	exports.ascending = ascending;
	exports.bisector = bisector;
	exports.cross = cross;
	exports.descending = descending;
	exports.deviation = deviation;
	exports.extent = extent;
	exports.histogram = histogram;
	exports.thresholdFreedmanDiaconis = freedmanDiaconis;
	exports.thresholdScott = scott;
	exports.thresholdSturges = sturges;
	exports.max = max;
	exports.mean = mean;
	exports.median = median;
	exports.merge = merge;
	exports.min = min;
	exports.pairs = pairs;
	exports.permute = permute;
	exports.quantile = quantile;
	exports.range = range;
	exports.scan = scan;
	exports.shuffle = shuffle;
	exports.sum = sum;
	exports.ticks = ticks;
	exports.tickIncrement = tickIncrement;
	exports.tickStep = tickStep;
	exports.transpose = transpose;
	exports.variance = variance;
	exports.zip = zip;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),

/***/ "./node_modules/d3-collection/build/d3-collection.js":
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-collection/ Version 1.0.4. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var prefix = "$";
	
	function Map() {}
	
	Map.prototype = map.prototype = {
	  constructor: Map,
	  has: function(key) {
	    return (prefix + key) in this;
	  },
	  get: function(key) {
	    return this[prefix + key];
	  },
	  set: function(key, value) {
	    this[prefix + key] = value;
	    return this;
	  },
	  remove: function(key) {
	    var property = prefix + key;
	    return property in this && delete this[property];
	  },
	  clear: function() {
	    for (var property in this) if (property[0] === prefix) delete this[property];
	  },
	  keys: function() {
	    var keys = [];
	    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
	    return keys;
	  },
	  values: function() {
	    var values = [];
	    for (var property in this) if (property[0] === prefix) values.push(this[property]);
	    return values;
	  },
	  entries: function() {
	    var entries = [];
	    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
	    return entries;
	  },
	  size: function() {
	    var size = 0;
	    for (var property in this) if (property[0] === prefix) ++size;
	    return size;
	  },
	  empty: function() {
	    for (var property in this) if (property[0] === prefix) return false;
	    return true;
	  },
	  each: function(f) {
	    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
	  }
	};
	
	function map(object, f) {
	  var map = new Map;
	
	  // Copy constructor.
	  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });
	
	  // Index array by numeric index or specified key function.
	  else if (Array.isArray(object)) {
	    var i = -1,
	        n = object.length,
	        o;
	
	    if (f == null) while (++i < n) map.set(i, object[i]);
	    else while (++i < n) map.set(f(o = object[i], i, object), o);
	  }
	
	  // Convert object to map.
	  else if (object) for (var key in object) map.set(key, object[key]);
	
	  return map;
	}
	
	var nest = function() {
	  var keys = [],
	      sortKeys = [],
	      sortValues,
	      rollup,
	      nest;
	
	  function apply(array, depth, createResult, setResult) {
	    if (depth >= keys.length) {
	      if (sortValues != null) array.sort(sortValues);
	      return rollup != null ? rollup(array) : array;
	    }
	
	    var i = -1,
	        n = array.length,
	        key = keys[depth++],
	        keyValue,
	        value,
	        valuesByKey = map(),
	        values,
	        result = createResult();
	
	    while (++i < n) {
	      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
	        values.push(value);
	      } else {
	        valuesByKey.set(keyValue, [value]);
	      }
	    }
	
	    valuesByKey.each(function(values, key) {
	      setResult(result, key, apply(values, depth, createResult, setResult));
	    });
	
	    return result;
	  }
	
	  function entries(map$$1, depth) {
	    if (++depth > keys.length) return map$$1;
	    var array, sortKey = sortKeys[depth - 1];
	    if (rollup != null && depth >= keys.length) array = map$$1.entries();
	    else array = [], map$$1.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
	    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
	  }
	
	  return nest = {
	    object: function(array) { return apply(array, 0, createObject, setObject); },
	    map: function(array) { return apply(array, 0, createMap, setMap); },
	    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
	    key: function(d) { keys.push(d); return nest; },
	    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
	    sortValues: function(order) { sortValues = order; return nest; },
	    rollup: function(f) { rollup = f; return nest; }
	  };
	};
	
	function createObject() {
	  return {};
	}
	
	function setObject(object, key, value) {
	  object[key] = value;
	}
	
	function createMap() {
	  return map();
	}
	
	function setMap(map$$1, key, value) {
	  map$$1.set(key, value);
	}
	
	function Set() {}
	
	var proto = map.prototype;
	
	Set.prototype = set.prototype = {
	  constructor: Set,
	  has: proto.has,
	  add: function(value) {
	    value += "";
	    this[prefix + value] = value;
	    return this;
	  },
	  remove: proto.remove,
	  clear: proto.clear,
	  values: proto.keys,
	  size: proto.size,
	  empty: proto.empty,
	  each: proto.each
	};
	
	function set(object, f) {
	  var set = new Set;
	
	  // Copy constructor.
	  if (object instanceof Set) object.each(function(value) { set.add(value); });
	
	  // Otherwise, assume it’s an array.
	  else if (object) {
	    var i = -1, n = object.length;
	    if (f == null) while (++i < n) set.add(object[i]);
	    else while (++i < n) set.add(f(object[i], i, object));
	  }
	
	  return set;
	}
	
	var keys = function(map) {
	  var keys = [];
	  for (var key in map) keys.push(key);
	  return keys;
	};
	
	var values = function(map) {
	  var values = [];
	  for (var key in map) values.push(map[key]);
	  return values;
	};
	
	var entries = function(map) {
	  var entries = [];
	  for (var key in map) entries.push({key: key, value: map[key]});
	  return entries;
	};
	
	exports.nest = nest;
	exports.set = set;
	exports.map = map;
	exports.keys = keys;
	exports.values = values;
	exports.entries = entries;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),

/***/ "./node_modules/d3-color/build/d3-color.js":
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-color/ Version 1.0.3. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var define = function(constructor, factory, prototype) {
	  constructor.prototype = factory.prototype = prototype;
	  prototype.constructor = constructor;
	};
	
	function extend(parent, definition) {
	  var prototype = Object.create(parent.prototype);
	  for (var key in definition) prototype[key] = definition[key];
	  return prototype;
	}
	
	function Color() {}
	
	var darker = 0.7;
	var brighter = 1 / darker;
	
	var reI = "\\s*([+-]?\\d+)\\s*";
	var reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*";
	var reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*";
	var reHex3 = /^#([0-9a-f]{3})$/;
	var reHex6 = /^#([0-9a-f]{6})$/;
	var reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$");
	var reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$");
	var reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$");
	var reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$");
	var reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$");
	var reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");
	
	var named = {
	  aliceblue: 0xf0f8ff,
	  antiquewhite: 0xfaebd7,
	  aqua: 0x00ffff,
	  aquamarine: 0x7fffd4,
	  azure: 0xf0ffff,
	  beige: 0xf5f5dc,
	  bisque: 0xffe4c4,
	  black: 0x000000,
	  blanchedalmond: 0xffebcd,
	  blue: 0x0000ff,
	  blueviolet: 0x8a2be2,
	  brown: 0xa52a2a,
	  burlywood: 0xdeb887,
	  cadetblue: 0x5f9ea0,
	  chartreuse: 0x7fff00,
	  chocolate: 0xd2691e,
	  coral: 0xff7f50,
	  cornflowerblue: 0x6495ed,
	  cornsilk: 0xfff8dc,
	  crimson: 0xdc143c,
	  cyan: 0x00ffff,
	  darkblue: 0x00008b,
	  darkcyan: 0x008b8b,
	  darkgoldenrod: 0xb8860b,
	  darkgray: 0xa9a9a9,
	  darkgreen: 0x006400,
	  darkgrey: 0xa9a9a9,
	  darkkhaki: 0xbdb76b,
	  darkmagenta: 0x8b008b,
	  darkolivegreen: 0x556b2f,
	  darkorange: 0xff8c00,
	  darkorchid: 0x9932cc,
	  darkred: 0x8b0000,
	  darksalmon: 0xe9967a,
	  darkseagreen: 0x8fbc8f,
	  darkslateblue: 0x483d8b,
	  darkslategray: 0x2f4f4f,
	  darkslategrey: 0x2f4f4f,
	  darkturquoise: 0x00ced1,
	  darkviolet: 0x9400d3,
	  deeppink: 0xff1493,
	  deepskyblue: 0x00bfff,
	  dimgray: 0x696969,
	  dimgrey: 0x696969,
	  dodgerblue: 0x1e90ff,
	  firebrick: 0xb22222,
	  floralwhite: 0xfffaf0,
	  forestgreen: 0x228b22,
	  fuchsia: 0xff00ff,
	  gainsboro: 0xdcdcdc,
	  ghostwhite: 0xf8f8ff,
	  gold: 0xffd700,
	  goldenrod: 0xdaa520,
	  gray: 0x808080,
	  green: 0x008000,
	  greenyellow: 0xadff2f,
	  grey: 0x808080,
	  honeydew: 0xf0fff0,
	  hotpink: 0xff69b4,
	  indianred: 0xcd5c5c,
	  indigo: 0x4b0082,
	  ivory: 0xfffff0,
	  khaki: 0xf0e68c,
	  lavender: 0xe6e6fa,
	  lavenderblush: 0xfff0f5,
	  lawngreen: 0x7cfc00,
	  lemonchiffon: 0xfffacd,
	  lightblue: 0xadd8e6,
	  lightcoral: 0xf08080,
	  lightcyan: 0xe0ffff,
	  lightgoldenrodyellow: 0xfafad2,
	  lightgray: 0xd3d3d3,
	  lightgreen: 0x90ee90,
	  lightgrey: 0xd3d3d3,
	  lightpink: 0xffb6c1,
	  lightsalmon: 0xffa07a,
	  lightseagreen: 0x20b2aa,
	  lightskyblue: 0x87cefa,
	  lightslategray: 0x778899,
	  lightslategrey: 0x778899,
	  lightsteelblue: 0xb0c4de,
	  lightyellow: 0xffffe0,
	  lime: 0x00ff00,
	  limegreen: 0x32cd32,
	  linen: 0xfaf0e6,
	  magenta: 0xff00ff,
	  maroon: 0x800000,
	  mediumaquamarine: 0x66cdaa,
	  mediumblue: 0x0000cd,
	  mediumorchid: 0xba55d3,
	  mediumpurple: 0x9370db,
	  mediumseagreen: 0x3cb371,
	  mediumslateblue: 0x7b68ee,
	  mediumspringgreen: 0x00fa9a,
	  mediumturquoise: 0x48d1cc,
	  mediumvioletred: 0xc71585,
	  midnightblue: 0x191970,
	  mintcream: 0xf5fffa,
	  mistyrose: 0xffe4e1,
	  moccasin: 0xffe4b5,
	  navajowhite: 0xffdead,
	  navy: 0x000080,
	  oldlace: 0xfdf5e6,
	  olive: 0x808000,
	  olivedrab: 0x6b8e23,
	  orange: 0xffa500,
	  orangered: 0xff4500,
	  orchid: 0xda70d6,
	  palegoldenrod: 0xeee8aa,
	  palegreen: 0x98fb98,
	  paleturquoise: 0xafeeee,
	  palevioletred: 0xdb7093,
	  papayawhip: 0xffefd5,
	  peachpuff: 0xffdab9,
	  peru: 0xcd853f,
	  pink: 0xffc0cb,
	  plum: 0xdda0dd,
	  powderblue: 0xb0e0e6,
	  purple: 0x800080,
	  rebeccapurple: 0x663399,
	  red: 0xff0000,
	  rosybrown: 0xbc8f8f,
	  royalblue: 0x4169e1,
	  saddlebrown: 0x8b4513,
	  salmon: 0xfa8072,
	  sandybrown: 0xf4a460,
	  seagreen: 0x2e8b57,
	  seashell: 0xfff5ee,
	  sienna: 0xa0522d,
	  silver: 0xc0c0c0,
	  skyblue: 0x87ceeb,
	  slateblue: 0x6a5acd,
	  slategray: 0x708090,
	  slategrey: 0x708090,
	  snow: 0xfffafa,
	  springgreen: 0x00ff7f,
	  steelblue: 0x4682b4,
	  tan: 0xd2b48c,
	  teal: 0x008080,
	  thistle: 0xd8bfd8,
	  tomato: 0xff6347,
	  turquoise: 0x40e0d0,
	  violet: 0xee82ee,
	  wheat: 0xf5deb3,
	  white: 0xffffff,
	  whitesmoke: 0xf5f5f5,
	  yellow: 0xffff00,
	  yellowgreen: 0x9acd32
	};
	
	define(Color, color, {
	  displayable: function() {
	    return this.rgb().displayable();
	  },
	  toString: function() {
	    return this.rgb() + "";
	  }
	});
	
	function color(format) {
	  var m;
	  format = (format + "").trim().toLowerCase();
	  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
	      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
	      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
	      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
	      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
	      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
	      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
	      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
	      : named.hasOwnProperty(format) ? rgbn(named[format])
	      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
	      : null;
	}
	
	function rgbn(n) {
	  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
	}
	
	function rgba(r, g, b, a) {
	  if (a <= 0) r = g = b = NaN;
	  return new Rgb(r, g, b, a);
	}
	
	function rgbConvert(o) {
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Rgb;
	  o = o.rgb();
	  return new Rgb(o.r, o.g, o.b, o.opacity);
	}
	
	function rgb(r, g, b, opacity) {
	  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
	}
	
	function Rgb(r, g, b, opacity) {
	  this.r = +r;
	  this.g = +g;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Rgb, rgb, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  rgb: function() {
	    return this;
	  },
	  displayable: function() {
	    return (0 <= this.r && this.r <= 255)
	        && (0 <= this.g && this.g <= 255)
	        && (0 <= this.b && this.b <= 255)
	        && (0 <= this.opacity && this.opacity <= 1);
	  },
	  toString: function() {
	    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	    return (a === 1 ? "rgb(" : "rgba(")
	        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
	        + (a === 1 ? ")" : ", " + a + ")");
	  }
	}));
	
	function hsla(h, s, l, a) {
	  if (a <= 0) h = s = l = NaN;
	  else if (l <= 0 || l >= 1) h = s = NaN;
	  else if (s <= 0) h = NaN;
	  return new Hsl(h, s, l, a);
	}
	
	function hslConvert(o) {
	  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Hsl;
	  if (o instanceof Hsl) return o;
	  o = o.rgb();
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      h = NaN,
	      s = max - min,
	      l = (max + min) / 2;
	  if (s) {
	    if (r === max) h = (g - b) / s + (g < b) * 6;
	    else if (g === max) h = (b - r) / s + 2;
	    else h = (r - g) / s + 4;
	    s /= l < 0.5 ? max + min : 2 - max - min;
	    h *= 60;
	  } else {
	    s = l > 0 && l < 1 ? 0 : h;
	  }
	  return new Hsl(h, s, l, o.opacity);
	}
	
	function hsl(h, s, l, opacity) {
	  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Hsl(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hsl, hsl, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = this.h % 360 + (this.h < 0) * 360,
	        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
	        l = this.l,
	        m2 = l + (l < 0.5 ? l : 1 - l) * s,
	        m1 = 2 * l - m2;
	    return new Rgb(
	      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
	      hsl2rgb(h, m1, m2),
	      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
	      this.opacity
	    );
	  },
	  displayable: function() {
	    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
	        && (0 <= this.l && this.l <= 1)
	        && (0 <= this.opacity && this.opacity <= 1);
	  }
	}));
	
	/* From FvD 13.37, CSS Color Module Level 3 */
	function hsl2rgb(h, m1, m2) {
	  return (h < 60 ? m1 + (m2 - m1) * h / 60
	      : h < 180 ? m2
	      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
	      : m1) * 255;
	}
	
	var deg2rad = Math.PI / 180;
	var rad2deg = 180 / Math.PI;
	
	var Kn = 18;
	var Xn = 0.950470;
	var Yn = 1;
	var Zn = 1.088830;
	var t0 = 4 / 29;
	var t1 = 6 / 29;
	var t2 = 3 * t1 * t1;
	var t3 = t1 * t1 * t1;
	
	function labConvert(o) {
	  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
	  if (o instanceof Hcl) {
	    var h = o.h * deg2rad;
	    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
	  }
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var b = rgb2xyz(o.r),
	      a = rgb2xyz(o.g),
	      l = rgb2xyz(o.b),
	      x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn),
	      y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / Yn),
	      z = xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / Zn);
	  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
	}
	
	function lab(l, a, b, opacity) {
	  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
	}
	
	function Lab(l, a, b, opacity) {
	  this.l = +l;
	  this.a = +a;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Lab, lab, extend(Color, {
	  brighter: function(k) {
	    return new Lab(this.l + Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  darker: function(k) {
	    return new Lab(this.l - Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  rgb: function() {
	    var y = (this.l + 16) / 116,
	        x = isNaN(this.a) ? y : y + this.a / 500,
	        z = isNaN(this.b) ? y : y - this.b / 200;
	    y = Yn * lab2xyz(y);
	    x = Xn * lab2xyz(x);
	    z = Zn * lab2xyz(z);
	    return new Rgb(
	      xyz2rgb( 3.2404542 * x - 1.5371385 * y - 0.4985314 * z), // D65 -> sRGB
	      xyz2rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z),
	      xyz2rgb( 0.0556434 * x - 0.2040259 * y + 1.0572252 * z),
	      this.opacity
	    );
	  }
	}));
	
	function xyz2lab(t) {
	  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
	}
	
	function lab2xyz(t) {
	  return t > t1 ? t * t * t : t2 * (t - t0);
	}
	
	function xyz2rgb(x) {
	  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
	}
	
	function rgb2xyz(x) {
	  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
	}
	
	function hclConvert(o) {
	  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
	  if (!(o instanceof Lab)) o = labConvert(o);
	  var h = Math.atan2(o.b, o.a) * rad2deg;
	  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
	}
	
	function hcl(h, c, l, opacity) {
	  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function Hcl(h, c, l, opacity) {
	  this.h = +h;
	  this.c = +c;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hcl, hcl, extend(Color, {
	  brighter: function(k) {
	    return new Hcl(this.h, this.c, this.l + Kn * (k == null ? 1 : k), this.opacity);
	  },
	  darker: function(k) {
	    return new Hcl(this.h, this.c, this.l - Kn * (k == null ? 1 : k), this.opacity);
	  },
	  rgb: function() {
	    return labConvert(this).rgb();
	  }
	}));
	
	var A = -0.14861;
	var B = +1.78277;
	var C = -0.29227;
	var D = -0.90649;
	var E = +1.97294;
	var ED = E * D;
	var EB = E * B;
	var BC_DA = B * C - D * A;
	
	function cubehelixConvert(o) {
	  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
	      bl = b - l,
	      k = (E * (g - l) - C * bl) / D,
	      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
	      h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
	  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
	}
	
	function cubehelix(h, s, l, opacity) {
	  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Cubehelix(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Cubehelix, cubehelix, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
	        l = +this.l,
	        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
	        cosh = Math.cos(h),
	        sinh = Math.sin(h);
	    return new Rgb(
	      255 * (l + a * (A * cosh + B * sinh)),
	      255 * (l + a * (C * cosh + D * sinh)),
	      255 * (l + a * (E * cosh)),
	      this.opacity
	    );
	  }
	}));
	
	exports.color = color;
	exports.rgb = rgb;
	exports.hsl = hsl;
	exports.lab = lab;
	exports.hcl = hcl;
	exports.cubehelix = cubehelix;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),

/***/ "./node_modules/d3-format/build/d3-format.js":
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-format/ Version 1.2.0. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	// Computes the decimal coefficient and exponent of the specified number x with
	// significant digits p, where x is positive and p is in [1, 21] or undefined.
	// For example, formatDecimal(1.23) returns ["123", 0].
	var formatDecimal = function(x, p) {
	  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
	  var i, coefficient = x.slice(0, i);
	
	  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
	  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
	  return [
	    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
	    +x.slice(i + 1)
	  ];
	};
	
	var exponent = function(x) {
	  return x = formatDecimal(Math.abs(x)), x ? x[1] : NaN;
	};
	
	var formatGroup = function(grouping, thousands) {
	  return function(value, width) {
	    var i = value.length,
	        t = [],
	        j = 0,
	        g = grouping[0],
	        length = 0;
	
	    while (i > 0 && g > 0) {
	      if (length + g + 1 > width) g = Math.max(1, width - length);
	      t.push(value.substring(i -= g, i + g));
	      if ((length += g + 1) > width) break;
	      g = grouping[j = (j + 1) % grouping.length];
	    }
	
	    return t.reverse().join(thousands);
	  };
	};
	
	var formatNumerals = function(numerals) {
	  return function(value) {
	    return value.replace(/[0-9]/g, function(i) {
	      return numerals[+i];
	    });
	  };
	};
	
	var formatDefault = function(x, p) {
	  x = x.toPrecision(p);
	
	  out: for (var n = x.length, i = 1, i0 = -1, i1; i < n; ++i) {
	    switch (x[i]) {
	      case ".": i0 = i1 = i; break;
	      case "0": if (i0 === 0) i0 = i; i1 = i; break;
	      case "e": break out;
	      default: if (i0 > 0) i0 = 0; break;
	    }
	  }
	
	  return i0 > 0 ? x.slice(0, i0) + x.slice(i1 + 1) : x;
	};
	
	var prefixExponent;
	
	var formatPrefixAuto = function(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1],
	      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
	      n = coefficient.length;
	  return i === n ? coefficient
	      : i > n ? coefficient + new Array(i - n + 1).join("0")
	      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
	      : "0." + new Array(1 - i).join("0") + formatDecimal(x, Math.max(0, p + i - 1))[0]; // less than 1y!
	};
	
	var formatRounded = function(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1];
	  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
	      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
	      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
	};
	
	var formatTypes = {
	  "": formatDefault,
	  "%": function(x, p) { return (x * 100).toFixed(p); },
	  "b": function(x) { return Math.round(x).toString(2); },
	  "c": function(x) { return x + ""; },
	  "d": function(x) { return Math.round(x).toString(10); },
	  "e": function(x, p) { return x.toExponential(p); },
	  "f": function(x, p) { return x.toFixed(p); },
	  "g": function(x, p) { return x.toPrecision(p); },
	  "o": function(x) { return Math.round(x).toString(8); },
	  "p": function(x, p) { return formatRounded(x * 100, p); },
	  "r": formatRounded,
	  "s": formatPrefixAuto,
	  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
	  "x": function(x) { return Math.round(x).toString(16); }
	};
	
	// [[fill]align][sign][symbol][0][width][,][.precision][type]
	var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;
	
	function formatSpecifier(specifier) {
	  return new FormatSpecifier(specifier);
	}
	
	formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
	
	function FormatSpecifier(specifier) {
	  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
	
	  var match,
	      fill = match[1] || " ",
	      align = match[2] || ">",
	      sign = match[3] || "-",
	      symbol = match[4] || "",
	      zero = !!match[5],
	      width = match[6] && +match[6],
	      comma = !!match[7],
	      precision = match[8] && +match[8].slice(1),
	      type = match[9] || "";
	
	  // The "n" type is an alias for ",g".
	  if (type === "n") comma = true, type = "g";
	
	  // Map invalid types to the default format.
	  else if (!formatTypes[type]) type = "";
	
	  // If zero fill is specified, padding goes after sign and before digits.
	  if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";
	
	  this.fill = fill;
	  this.align = align;
	  this.sign = sign;
	  this.symbol = symbol;
	  this.zero = zero;
	  this.width = width;
	  this.comma = comma;
	  this.precision = precision;
	  this.type = type;
	}
	
	FormatSpecifier.prototype.toString = function() {
	  return this.fill
	      + this.align
	      + this.sign
	      + this.symbol
	      + (this.zero ? "0" : "")
	      + (this.width == null ? "" : Math.max(1, this.width | 0))
	      + (this.comma ? "," : "")
	      + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
	      + this.type;
	};
	
	var identity = function(x) {
	  return x;
	};
	
	var prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];
	
	var formatLocale = function(locale) {
	  var group = locale.grouping && locale.thousands ? formatGroup(locale.grouping, locale.thousands) : identity,
	      currency = locale.currency,
	      decimal = locale.decimal,
	      numerals = locale.numerals ? formatNumerals(locale.numerals) : identity,
	      percent = locale.percent || "%";
	
	  function newFormat(specifier) {
	    specifier = formatSpecifier(specifier);
	
	    var fill = specifier.fill,
	        align = specifier.align,
	        sign = specifier.sign,
	        symbol = specifier.symbol,
	        zero = specifier.zero,
	        width = specifier.width,
	        comma = specifier.comma,
	        precision = specifier.precision,
	        type = specifier.type;
	
	    // Compute the prefix and suffix.
	    // For SI-prefix, the suffix is lazily computed.
	    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
	        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";
	
	    // What format function should we use?
	    // Is this an integer type?
	    // Can this type generate exponential notation?
	    var formatType = formatTypes[type],
	        maybeSuffix = !type || /[defgprs%]/.test(type);
	
	    // Set the default precision if not specified,
	    // or clamp the specified precision to the supported range.
	    // For significant precision, it must be in [1, 21].
	    // For fixed precision, it must be in [0, 20].
	    precision = precision == null ? (type ? 6 : 12)
	        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
	        : Math.max(0, Math.min(20, precision));
	
	    function format(value) {
	      var valuePrefix = prefix,
	          valueSuffix = suffix,
	          i, n, c;
	
	      if (type === "c") {
	        valueSuffix = formatType(value) + valueSuffix;
	        value = "";
	      } else {
	        value = +value;
	
	        // Perform the initial formatting.
	        var valueNegative = value < 0;
	        value = formatType(Math.abs(value), precision);
	
	        // If a negative value rounds to zero during formatting, treat as positive.
	        if (valueNegative && +value === 0) valueNegative = false;
	
	        // Compute the prefix and suffix.
	        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
	        valueSuffix = valueSuffix + (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + (valueNegative && sign === "(" ? ")" : "");
	
	        // Break the formatted value into the integer “value” part that can be
	        // grouped, and fractional or exponential “suffix” part that is not.
	        if (maybeSuffix) {
	          i = -1, n = value.length;
	          while (++i < n) {
	            if (c = value.charCodeAt(i), 48 > c || c > 57) {
	              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
	              value = value.slice(0, i);
	              break;
	            }
	          }
	        }
	      }
	
	      // If the fill character is not "0", grouping is applied before padding.
	      if (comma && !zero) value = group(value, Infinity);
	
	      // Compute the padding.
	      var length = valuePrefix.length + value.length + valueSuffix.length,
	          padding = length < width ? new Array(width - length + 1).join(fill) : "";
	
	      // If the fill character is "0", grouping is applied after padding.
	      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
	
	      // Reconstruct the final output based on the desired alignment.
	      switch (align) {
	        case "<": value = valuePrefix + value + valueSuffix + padding; break;
	        case "=": value = valuePrefix + padding + value + valueSuffix; break;
	        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
	        default: value = padding + valuePrefix + value + valueSuffix; break;
	      }
	
	      return numerals(value);
	    }
	
	    format.toString = function() {
	      return specifier + "";
	    };
	
	    return format;
	  }
	
	  function formatPrefix(specifier, value) {
	    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
	        e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
	        k = Math.pow(10, -e),
	        prefix = prefixes[8 + e / 3];
	    return function(value) {
	      return f(k * value) + prefix;
	    };
	  }
	
	  return {
	    format: newFormat,
	    formatPrefix: formatPrefix
	  };
	};
	
	var locale;
	
	
	
	defaultLocale({
	  decimal: ".",
	  thousands: ",",
	  grouping: [3],
	  currency: ["$", ""]
	});
	
	function defaultLocale(definition) {
	  locale = formatLocale(definition);
	  exports.format = locale.format;
	  exports.formatPrefix = locale.formatPrefix;
	  return locale;
	}
	
	var precisionFixed = function(step) {
	  return Math.max(0, -exponent(Math.abs(step)));
	};
	
	var precisionPrefix = function(step, value) {
	  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
	};
	
	var precisionRound = function(step, max) {
	  step = Math.abs(step), max = Math.abs(max) - step;
	  return Math.max(0, exponent(max) - exponent(step)) + 1;
	};
	
	exports.formatDefaultLocale = defaultLocale;
	exports.formatLocale = formatLocale;
	exports.formatSpecifier = formatSpecifier;
	exports.precisionFixed = precisionFixed;
	exports.precisionPrefix = precisionPrefix;
	exports.precisionRound = precisionRound;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),

/***/ "./node_modules/d3-interpolate/build/d3-interpolate.js":
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-interpolate/ Version 1.1.5. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__("./node_modules/d3-color/build/d3-color.js")) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-color'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Color) { 'use strict';
	
	function basis(t1, v0, v1, v2, v3) {
	  var t2 = t1 * t1, t3 = t2 * t1;
	  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
	      + (4 - 6 * t2 + 3 * t3) * v1
	      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
	      + t3 * v3) / 6;
	}
	
	var basis$1 = function(values) {
	  var n = values.length - 1;
	  return function(t) {
	    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
	        v1 = values[i],
	        v2 = values[i + 1],
	        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
	        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	};
	
	var basisClosed = function(values) {
	  var n = values.length;
	  return function(t) {
	    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
	        v0 = values[(i + n - 1) % n],
	        v1 = values[i % n],
	        v2 = values[(i + 1) % n],
	        v3 = values[(i + 2) % n];
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	};
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function linear(a, d) {
	  return function(t) {
	    return a + t * d;
	  };
	}
	
	function exponential(a, b, y) {
	  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
	    return Math.pow(a + t * b, y);
	  };
	}
	
	function hue(a, b) {
	  var d = b - a;
	  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant(isNaN(a) ? b : a);
	}
	
	function gamma(y) {
	  return (y = +y) === 1 ? nogamma : function(a, b) {
	    return b - a ? exponential(a, b, y) : constant(isNaN(a) ? b : a);
	  };
	}
	
	function nogamma(a, b) {
	  var d = b - a;
	  return d ? linear(a, d) : constant(isNaN(a) ? b : a);
	}
	
	var rgb$1 = ((function rgbGamma(y) {
	  var color$$1 = gamma(y);
	
	  function rgb$$1(start, end) {
	    var r = color$$1((start = d3Color.rgb(start)).r, (end = d3Color.rgb(end)).r),
	        g = color$$1(start.g, end.g),
	        b = color$$1(start.b, end.b),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.r = r(t);
	      start.g = g(t);
	      start.b = b(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	
	  rgb$$1.gamma = rgbGamma;
	
	  return rgb$$1;
	}))(1);
	
	function rgbSpline(spline) {
	  return function(colors) {
	    var n = colors.length,
	        r = new Array(n),
	        g = new Array(n),
	        b = new Array(n),
	        i, color$$1;
	    for (i = 0; i < n; ++i) {
	      color$$1 = d3Color.rgb(colors[i]);
	      r[i] = color$$1.r || 0;
	      g[i] = color$$1.g || 0;
	      b[i] = color$$1.b || 0;
	    }
	    r = spline(r);
	    g = spline(g);
	    b = spline(b);
	    color$$1.opacity = 1;
	    return function(t) {
	      color$$1.r = r(t);
	      color$$1.g = g(t);
	      color$$1.b = b(t);
	      return color$$1 + "";
	    };
	  };
	}
	
	var rgbBasis = rgbSpline(basis$1);
	var rgbBasisClosed = rgbSpline(basisClosed);
	
	var array = function(a, b) {
	  var nb = b ? b.length : 0,
	      na = a ? Math.min(nb, a.length) : 0,
	      x = new Array(nb),
	      c = new Array(nb),
	      i;
	
	  for (i = 0; i < na; ++i) x[i] = value(a[i], b[i]);
	  for (; i < nb; ++i) c[i] = b[i];
	
	  return function(t) {
	    for (i = 0; i < na; ++i) c[i] = x[i](t);
	    return c;
	  };
	};
	
	var date = function(a, b) {
	  var d = new Date;
	  return a = +a, b -= a, function(t) {
	    return d.setTime(a + b * t), d;
	  };
	};
	
	var number = function(a, b) {
	  return a = +a, b -= a, function(t) {
	    return a + b * t;
	  };
	};
	
	var object = function(a, b) {
	  var i = {},
	      c = {},
	      k;
	
	  if (a === null || typeof a !== "object") a = {};
	  if (b === null || typeof b !== "object") b = {};
	
	  for (k in b) {
	    if (k in a) {
	      i[k] = value(a[k], b[k]);
	    } else {
	      c[k] = b[k];
	    }
	  }
	
	  return function(t) {
	    for (k in i) c[k] = i[k](t);
	    return c;
	  };
	};
	
	var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g;
	var reB = new RegExp(reA.source, "g");
	
	function zero(b) {
	  return function() {
	    return b;
	  };
	}
	
	function one(b) {
	  return function(t) {
	    return b(t) + "";
	  };
	}
	
	var string = function(a, b) {
	  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
	      am, // current match in a
	      bm, // current match in b
	      bs, // string preceding current number in b, if any
	      i = -1, // index in s
	      s = [], // string constants and placeholders
	      q = []; // number interpolators
	
	  // Coerce inputs to strings.
	  a = a + "", b = b + "";
	
	  // Interpolate pairs of numbers in a & b.
	  while ((am = reA.exec(a))
	      && (bm = reB.exec(b))) {
	    if ((bs = bm.index) > bi) { // a string precedes the next number in b
	      bs = b.slice(bi, bs);
	      if (s[i]) s[i] += bs; // coalesce with previous string
	      else s[++i] = bs;
	    }
	    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
	      if (s[i]) s[i] += bm; // coalesce with previous string
	      else s[++i] = bm;
	    } else { // interpolate non-matching numbers
	      s[++i] = null;
	      q.push({i: i, x: number(am, bm)});
	    }
	    bi = reB.lastIndex;
	  }
	
	  // Add remains of b.
	  if (bi < b.length) {
	    bs = b.slice(bi);
	    if (s[i]) s[i] += bs; // coalesce with previous string
	    else s[++i] = bs;
	  }
	
	  // Special optimization for only a single match.
	  // Otherwise, interpolate each of the numbers and rejoin the string.
	  return s.length < 2 ? (q[0]
	      ? one(q[0].x)
	      : zero(b))
	      : (b = q.length, function(t) {
	          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	          return s.join("");
	        });
	};
	
	var value = function(a, b) {
	  var t = typeof b, c;
	  return b == null || t === "boolean" ? constant(b)
	      : (t === "number" ? number
	      : t === "string" ? ((c = d3Color.color(b)) ? (b = c, rgb$1) : string)
	      : b instanceof d3Color.color ? rgb$1
	      : b instanceof Date ? date
	      : Array.isArray(b) ? array
	      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
	      : number)(a, b);
	};
	
	var round = function(a, b) {
	  return a = +a, b -= a, function(t) {
	    return Math.round(a + b * t);
	  };
	};
	
	var degrees = 180 / Math.PI;
	
	var identity = {
	  translateX: 0,
	  translateY: 0,
	  rotate: 0,
	  skewX: 0,
	  scaleX: 1,
	  scaleY: 1
	};
	
	var decompose = function(a, b, c, d, e, f) {
	  var scaleX, scaleY, skewX;
	  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
	  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
	  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
	  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
	  return {
	    translateX: e,
	    translateY: f,
	    rotate: Math.atan2(b, a) * degrees,
	    skewX: Math.atan(skewX) * degrees,
	    scaleX: scaleX,
	    scaleY: scaleY
	  };
	};
	
	var cssNode;
	var cssRoot;
	var cssView;
	var svgNode;
	
	function parseCss(value) {
	  if (value === "none") return identity;
	  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
	  cssNode.style.transform = value;
	  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
	  cssRoot.removeChild(cssNode);
	  value = value.slice(7, -1).split(",");
	  return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
	}
	
	function parseSvg(value) {
	  if (value == null) return identity;
	  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
	  svgNode.setAttribute("transform", value);
	  if (!(value = svgNode.transform.baseVal.consolidate())) return identity;
	  value = value.matrix;
	  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
	}
	
	function interpolateTransform(parse, pxComma, pxParen, degParen) {
	
	  function pop(s) {
	    return s.length ? s.pop() + " " : "";
	  }
	
	  function translate(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push("translate(", null, pxComma, null, pxParen);
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb || yb) {
	      s.push("translate(" + xb + pxComma + yb + pxParen);
	    }
	  }
	
	  function rotate(a, b, s, q) {
	    if (a !== b) {
	      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
	      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "rotate(" + b + degParen);
	    }
	  }
	
	  function skewX(a, b, s, q) {
	    if (a !== b) {
	      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "skewX(" + b + degParen);
	    }
	  }
	
	  function scale(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb !== 1 || yb !== 1) {
	      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
	    }
	  }
	
	  return function(a, b) {
	    var s = [], // string constants and placeholders
	        q = []; // number interpolators
	    a = parse(a), b = parse(b);
	    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
	    rotate(a.rotate, b.rotate, s, q);
	    skewX(a.skewX, b.skewX, s, q);
	    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
	    a = b = null; // gc
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  };
	}
	
	var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
	var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
	
	var rho = Math.SQRT2;
	var rho2 = 2;
	var rho4 = 4;
	var epsilon2 = 1e-12;
	
	function cosh(x) {
	  return ((x = Math.exp(x)) + 1 / x) / 2;
	}
	
	function sinh(x) {
	  return ((x = Math.exp(x)) - 1 / x) / 2;
	}
	
	function tanh(x) {
	  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	}
	
	// p0 = [ux0, uy0, w0]
	// p1 = [ux1, uy1, w1]
	var zoom = function(p0, p1) {
	  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
	      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
	      dx = ux1 - ux0,
	      dy = uy1 - uy0,
	      d2 = dx * dx + dy * dy,
	      i,
	      S;
	
	  // Special case for u0 ≅ u1.
	  if (d2 < epsilon2) {
	    S = Math.log(w1 / w0) / rho;
	    i = function(t) {
	      return [
	        ux0 + t * dx,
	        uy0 + t * dy,
	        w0 * Math.exp(rho * t * S)
	      ];
	    };
	  }
	
	  // General case.
	  else {
	    var d1 = Math.sqrt(d2),
	        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
	        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
	        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
	        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	    S = (r1 - r0) / rho;
	    i = function(t) {
	      var s = t * S,
	          coshr0 = cosh(r0),
	          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
	      return [
	        ux0 + u * dx,
	        uy0 + u * dy,
	        w0 * coshr0 / cosh(rho * s + r0)
	      ];
	    };
	  }
	
	  i.duration = S * 1000;
	
	  return i;
	};
	
	function hsl$1(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = d3Color.hsl(start)).h, (end = d3Color.hsl(end)).h),
	        s = nogamma(start.s, end.s),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.s = s(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hsl$2 = hsl$1(hue);
	var hslLong = hsl$1(nogamma);
	
	function lab$1(start, end) {
	  var l = nogamma((start = d3Color.lab(start)).l, (end = d3Color.lab(end)).l),
	      a = nogamma(start.a, end.a),
	      b = nogamma(start.b, end.b),
	      opacity = nogamma(start.opacity, end.opacity);
	  return function(t) {
	    start.l = l(t);
	    start.a = a(t);
	    start.b = b(t);
	    start.opacity = opacity(t);
	    return start + "";
	  };
	}
	
	function hcl$1(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = d3Color.hcl(start)).h, (end = d3Color.hcl(end)).h),
	        c = nogamma(start.c, end.c),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.c = c(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hcl$2 = hcl$1(hue);
	var hclLong = hcl$1(nogamma);
	
	function cubehelix$1(hue$$1) {
	  return (function cubehelixGamma(y) {
	    y = +y;
	
	    function cubehelix$$1(start, end) {
	      var h = hue$$1((start = d3Color.cubehelix(start)).h, (end = d3Color.cubehelix(end)).h),
	          s = nogamma(start.s, end.s),
	          l = nogamma(start.l, end.l),
	          opacity = nogamma(start.opacity, end.opacity);
	      return function(t) {
	        start.h = h(t);
	        start.s = s(t);
	        start.l = l(Math.pow(t, y));
	        start.opacity = opacity(t);
	        return start + "";
	      };
	    }
	
	    cubehelix$$1.gamma = cubehelixGamma;
	
	    return cubehelix$$1;
	  })(1);
	}
	
	var cubehelix$2 = cubehelix$1(hue);
	var cubehelixLong = cubehelix$1(nogamma);
	
	var quantize = function(interpolator, n) {
	  var samples = new Array(n);
	  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
	  return samples;
	};
	
	exports.interpolate = value;
	exports.interpolateArray = array;
	exports.interpolateBasis = basis$1;
	exports.interpolateBasisClosed = basisClosed;
	exports.interpolateDate = date;
	exports.interpolateNumber = number;
	exports.interpolateObject = object;
	exports.interpolateRound = round;
	exports.interpolateString = string;
	exports.interpolateTransformCss = interpolateTransformCss;
	exports.interpolateTransformSvg = interpolateTransformSvg;
	exports.interpolateZoom = zoom;
	exports.interpolateRgb = rgb$1;
	exports.interpolateRgbBasis = rgbBasis;
	exports.interpolateRgbBasisClosed = rgbBasisClosed;
	exports.interpolateHsl = hsl$2;
	exports.interpolateHslLong = hslLong;
	exports.interpolateLab = lab$1;
	exports.interpolateHcl = hcl$2;
	exports.interpolateHclLong = hclLong;
	exports.interpolateCubehelix = cubehelix$2;
	exports.interpolateCubehelixLong = cubehelixLong;
	exports.quantize = quantize;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),

/***/ "./node_modules/d3-path/build/d3-path.js":
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-path/ Version 1.0.5. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var pi = Math.PI;
	var tau = 2 * pi;
	var epsilon = 1e-6;
	var tauEpsilon = tau - epsilon;
	
	function Path() {
	  this._x0 = this._y0 = // start of current subpath
	  this._x1 = this._y1 = null; // end of current subpath
	  this._ = "";
	}
	
	function path() {
	  return new Path;
	}
	
	Path.prototype = path.prototype = {
	  constructor: Path,
	  moveTo: function(x, y) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
	  },
	  closePath: function() {
	    if (this._x1 !== null) {
	      this._x1 = this._x0, this._y1 = this._y0;
	      this._ += "Z";
	    }
	  },
	  lineTo: function(x, y) {
	    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  quadraticCurveTo: function(x1, y1, x, y) {
	    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
	    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  arcTo: function(x1, y1, x2, y2, r) {
	    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
	    var x0 = this._x1,
	        y0 = this._y1,
	        x21 = x2 - x1,
	        y21 = y2 - y1,
	        x01 = x0 - x1,
	        y01 = y0 - y1,
	        l01_2 = x01 * x01 + y01 * y01;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x1,y1).
	    if (this._x1 === null) {
	      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
	    else if (!(l01_2 > epsilon)) {}
	
	    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
	    // Equivalently, is (x1,y1) coincident with (x2,y2)?
	    // Or, is the radius zero? Line to (x1,y1).
	    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
	      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Otherwise, draw an arc!
	    else {
	      var x20 = x2 - x0,
	          y20 = y2 - y0,
	          l21_2 = x21 * x21 + y21 * y21,
	          l20_2 = x20 * x20 + y20 * y20,
	          l21 = Math.sqrt(l21_2),
	          l01 = Math.sqrt(l01_2),
	          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
	          t01 = l / l01,
	          t21 = l / l21;
	
	      // If the start tangent is not coincident with (x0,y0), line to.
	      if (Math.abs(t01 - 1) > epsilon) {
	        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
	      }
	
	      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
	    }
	  },
	  arc: function(x, y, r, a0, a1, ccw) {
	    x = +x, y = +y, r = +r;
	    var dx = r * Math.cos(a0),
	        dy = r * Math.sin(a0),
	        x0 = x + dx,
	        y0 = y + dy,
	        cw = 1 ^ ccw,
	        da = ccw ? a0 - a1 : a1 - a0;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x0,y0).
	    if (this._x1 === null) {
	      this._ += "M" + x0 + "," + y0;
	    }
	
	    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
	    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
	      this._ += "L" + x0 + "," + y0;
	    }
	
	    // Is this arc empty? We’re done.
	    if (!r) return;
	
	    // Does the angle go the wrong way? Flip the direction.
	    if (da < 0) da = da % tau + tau;
	
	    // Is this a complete circle? Draw two arcs to complete the circle.
	    if (da > tauEpsilon) {
	      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
	    }
	
	    // Is this arc non-empty? Draw an arc!
	    else if (da > epsilon) {
	      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
	    }
	  },
	  rect: function(x, y, w, h) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
	  },
	  toString: function() {
	    return this._;
	  }
	};
	
	exports.path = path;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),

/***/ "./node_modules/d3-scale/build/d3-scale.js":
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-scale/ Version 1.0.6. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__("./node_modules/d3-array/build/d3-array.js"), __webpack_require__("./node_modules/d3-collection/build/d3-collection.js"), __webpack_require__("./node_modules/d3-interpolate/build/d3-interpolate.js"), __webpack_require__("./node_modules/d3-format/build/d3-format.js"), __webpack_require__("./node_modules/d3-time/build/d3-time.js"), __webpack_require__("./node_modules/d3-time-format/build/d3-time-format.js"), __webpack_require__("./node_modules/d3-color/build/d3-color.js")) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-array', 'd3-collection', 'd3-interpolate', 'd3-format', 'd3-time', 'd3-time-format', 'd3-color'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3,global.d3,global.d3,global.d3,global.d3));
	}(this, (function (exports,d3Array,d3Collection,d3Interpolate,d3Format,d3Time,d3TimeFormat,d3Color) { 'use strict';
	
	var array = Array.prototype;
	
	var map$1 = array.map;
	var slice = array.slice;
	
	var implicit = {name: "implicit"};
	
	function ordinal(range$$1) {
	  var index = d3Collection.map(),
	      domain = [],
	      unknown = implicit;
	
	  range$$1 = range$$1 == null ? [] : slice.call(range$$1);
	
	  function scale(d) {
	    var key = d + "", i = index.get(key);
	    if (!i) {
	      if (unknown !== implicit) return unknown;
	      index.set(key, i = domain.push(d));
	    }
	    return range$$1[(i - 1) % range$$1.length];
	  }
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [], index = d3Collection.map();
	    var i = -1, n = _.length, d, key;
	    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
	    return scale;
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), scale) : range$$1.slice();
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.copy = function() {
	    return ordinal()
	        .domain(domain)
	        .range(range$$1)
	        .unknown(unknown);
	  };
	
	  return scale;
	}
	
	function band() {
	  var scale = ordinal().unknown(undefined),
	      domain = scale.domain,
	      ordinalRange = scale.range,
	      range$$1 = [0, 1],
	      step,
	      bandwidth,
	      round = false,
	      paddingInner = 0,
	      paddingOuter = 0,
	      align = 0.5;
	
	  delete scale.unknown;
	
	  function rescale() {
	    var n = domain().length,
	        reverse = range$$1[1] < range$$1[0],
	        start = range$$1[reverse - 0],
	        stop = range$$1[1 - reverse];
	    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
	    if (round) step = Math.floor(step);
	    start += (stop - start - step * (n - paddingInner)) * align;
	    bandwidth = step * (1 - paddingInner);
	    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
	    var values = d3Array.range(n).map(function(i) { return start + step * i; });
	    return ordinalRange(reverse ? values.reverse() : values);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = [+_[0], +_[1]], rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = [+_[0], +_[1]], round = true, rescale();
	  };
	
	  scale.bandwidth = function() {
	    return bandwidth;
	  };
	
	  scale.step = function() {
	    return step;
	  };
	
	  scale.round = function(_) {
	    return arguments.length ? (round = !!_, rescale()) : round;
	  };
	
	  scale.padding = function(_) {
	    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingInner = function(_) {
	    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingOuter = function(_) {
	    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
	  };
	
	  scale.align = function(_) {
	    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
	  };
	
	  scale.copy = function() {
	    return band()
	        .domain(domain())
	        .range(range$$1)
	        .round(round)
	        .paddingInner(paddingInner)
	        .paddingOuter(paddingOuter)
	        .align(align);
	  };
	
	  return rescale();
	}
	
	function pointish(scale) {
	  var copy = scale.copy;
	
	  scale.padding = scale.paddingOuter;
	  delete scale.paddingInner;
	  delete scale.paddingOuter;
	
	  scale.copy = function() {
	    return pointish(copy());
	  };
	
	  return scale;
	}
	
	function point() {
	  return pointish(band().paddingInner(1));
	}
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var number = function(x) {
	  return +x;
	};
	
	var unit = [0, 1];
	
	function deinterpolateLinear(a, b) {
	  return (b -= (a = +a))
	      ? function(x) { return (x - a) / b; }
	      : constant(b);
	}
	
	function deinterpolateClamp(deinterpolate) {
	  return function(a, b) {
	    var d = deinterpolate(a = +a, b = +b);
	    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
	  };
	}
	
	function reinterpolateClamp(reinterpolate) {
	  return function(a, b) {
	    var r = reinterpolate(a = +a, b = +b);
	    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
	  };
	}
	
	function bimap(domain, range$$1, deinterpolate, reinterpolate) {
	  var d0 = domain[0], d1 = domain[1], r0 = range$$1[0], r1 = range$$1[1];
	  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
	  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
	  return function(x) { return r0(d0(x)); };
	}
	
	function polymap(domain, range$$1, deinterpolate, reinterpolate) {
	  var j = Math.min(domain.length, range$$1.length) - 1,
	      d = new Array(j),
	      r = new Array(j),
	      i = -1;
	
	  // Reverse descending domains.
	  if (domain[j] < domain[0]) {
	    domain = domain.slice().reverse();
	    range$$1 = range$$1.slice().reverse();
	  }
	
	  while (++i < j) {
	    d[i] = deinterpolate(domain[i], domain[i + 1]);
	    r[i] = reinterpolate(range$$1[i], range$$1[i + 1]);
	  }
	
	  return function(x) {
	    var i = d3Array.bisect(domain, x, 1, j) - 1;
	    return r[i](d[i](x));
	  };
	}
	
	function copy(source, target) {
	  return target
	      .domain(source.domain())
	      .range(source.range())
	      .interpolate(source.interpolate())
	      .clamp(source.clamp());
	}
	
	// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
	// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
	function continuous(deinterpolate, reinterpolate) {
	  var domain = unit,
	      range$$1 = unit,
	      interpolate$$1 = d3Interpolate.interpolate,
	      clamp = false,
	      piecewise,
	      output,
	      input;
	
	  function rescale() {
	    piecewise = Math.min(domain.length, range$$1.length) > 2 ? polymap : bimap;
	    output = input = null;
	    return scale;
	  }
	
	  function scale(x) {
	    return (output || (output = piecewise(domain, range$$1, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate$$1)))(+x);
	  }
	
	  scale.invert = function(y) {
	    return (input || (input = piecewise(range$$1, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = map$1.call(_, number), rescale()) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = slice.call(_), interpolate$$1 = d3Interpolate.interpolateRound, rescale();
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, rescale()) : clamp;
	  };
	
	  scale.interpolate = function(_) {
	    return arguments.length ? (interpolate$$1 = _, rescale()) : interpolate$$1;
	  };
	
	  return rescale();
	}
	
	var tickFormat = function(domain, count, specifier) {
	  var start = domain[0],
	      stop = domain[domain.length - 1],
	      step = d3Array.tickStep(start, stop, count == null ? 10 : count),
	      precision;
	  specifier = d3Format.formatSpecifier(specifier == null ? ",f" : specifier);
	  switch (specifier.type) {
	    case "s": {
	      var value = Math.max(Math.abs(start), Math.abs(stop));
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionPrefix(step, value))) specifier.precision = precision;
	      return d3Format.formatPrefix(specifier, value);
	    }
	    case "":
	    case "e":
	    case "g":
	    case "p":
	    case "r": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
	      break;
	    }
	    case "f":
	    case "%": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
	      break;
	    }
	  }
	  return d3Format.format(specifier);
	};
	
	function linearish(scale) {
	  var domain = scale.domain;
	
	  scale.ticks = function(count) {
	    var d = domain();
	    return d3Array.ticks(d[0], d[d.length - 1], count == null ? 10 : count);
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return tickFormat(domain(), count, specifier);
	  };
	
	  scale.nice = function(count) {
	    if (count == null) count = 10;
	
	    var d = domain(),
	        i0 = 0,
	        i1 = d.length - 1,
	        start = d[i0],
	        stop = d[i1],
	        step;
	
	    if (stop < start) {
	      step = start, start = stop, stop = step;
	      step = i0, i0 = i1, i1 = step;
	    }
	
	    step = d3Array.tickIncrement(start, stop, count);
	
	    if (step > 0) {
	      start = Math.floor(start / step) * step;
	      stop = Math.ceil(stop / step) * step;
	      step = d3Array.tickIncrement(start, stop, count);
	    } else if (step < 0) {
	      start = Math.ceil(start * step) / step;
	      stop = Math.floor(stop * step) / step;
	      step = d3Array.tickIncrement(start, stop, count);
	    }
	
	    if (step > 0) {
	      d[i0] = Math.floor(start / step) * step;
	      d[i1] = Math.ceil(stop / step) * step;
	      domain(d);
	    } else if (step < 0) {
	      d[i0] = Math.ceil(start * step) / step;
	      d[i1] = Math.floor(stop * step) / step;
	      domain(d);
	    }
	
	    return scale;
	  };
	
	  return scale;
	}
	
	function linear() {
	  var scale = continuous(deinterpolateLinear, d3Interpolate.interpolateNumber);
	
	  scale.copy = function() {
	    return copy(scale, linear());
	  };
	
	  return linearish(scale);
	}
	
	function identity() {
	  var domain = [0, 1];
	
	  function scale(x) {
	    return +x;
	  }
	
	  scale.invert = scale;
	
	  scale.domain = scale.range = function(_) {
	    return arguments.length ? (domain = map$1.call(_, number), scale) : domain.slice();
	  };
	
	  scale.copy = function() {
	    return identity().domain(domain);
	  };
	
	  return linearish(scale);
	}
	
	var nice = function(domain, interval) {
	  domain = domain.slice();
	
	  var i0 = 0,
	      i1 = domain.length - 1,
	      x0 = domain[i0],
	      x1 = domain[i1],
	      t;
	
	  if (x1 < x0) {
	    t = i0, i0 = i1, i1 = t;
	    t = x0, x0 = x1, x1 = t;
	  }
	
	  domain[i0] = interval.floor(x0);
	  domain[i1] = interval.ceil(x1);
	  return domain;
	};
	
	function deinterpolate(a, b) {
	  return (b = Math.log(b / a))
	      ? function(x) { return Math.log(x / a) / b; }
	      : constant(b);
	}
	
	function reinterpolate(a, b) {
	  return a < 0
	      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
	      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
	}
	
	function pow10(x) {
	  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
	}
	
	function powp(base) {
	  return base === 10 ? pow10
	      : base === Math.E ? Math.exp
	      : function(x) { return Math.pow(base, x); };
	}
	
	function logp(base) {
	  return base === Math.E ? Math.log
	      : base === 10 && Math.log10
	      || base === 2 && Math.log2
	      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
	}
	
	function reflect(f) {
	  return function(x) {
	    return -f(-x);
	  };
	}
	
	function log() {
	  var scale = continuous(deinterpolate, reinterpolate).domain([1, 10]),
	      domain = scale.domain,
	      base = 10,
	      logs = logp(10),
	      pows = powp(10);
	
	  function rescale() {
	    logs = logp(base), pows = powp(base);
	    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
	    return scale;
	  }
	
	  scale.base = function(_) {
	    return arguments.length ? (base = +_, rescale()) : base;
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.ticks = function(count) {
	    var d = domain(),
	        u = d[0],
	        v = d[d.length - 1],
	        r;
	
	    if (r = v < u) i = u, u = v, v = i;
	
	    var i = logs(u),
	        j = logs(v),
	        p,
	        k,
	        t,
	        n = count == null ? 10 : +count,
	        z = [];
	
	    if (!(base % 1) && j - i < n) {
	      i = Math.round(i) - 1, j = Math.round(j) + 1;
	      if (u > 0) for (; i < j; ++i) {
	        for (k = 1, p = pows(i); k < base; ++k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      } else for (; i < j; ++i) {
	        for (k = base - 1, p = pows(i); k >= 1; --k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      }
	    } else {
	      z = d3Array.ticks(i, j, Math.min(j - i, n)).map(pows);
	    }
	
	    return r ? z.reverse() : z;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
	    if (typeof specifier !== "function") specifier = d3Format.format(specifier);
	    if (count === Infinity) return specifier;
	    if (count == null) count = 10;
	    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
	    return function(d) {
	      var i = d / pows(Math.round(logs(d)));
	      if (i * base < base - 0.5) i *= base;
	      return i <= k ? specifier(d) : "";
	    };
	  };
	
	  scale.nice = function() {
	    return domain(nice(domain(), {
	      floor: function(x) { return pows(Math.floor(logs(x))); },
	      ceil: function(x) { return pows(Math.ceil(logs(x))); }
	    }));
	  };
	
	  scale.copy = function() {
	    return copy(scale, log().base(base));
	  };
	
	  return scale;
	}
	
	function raise(x, exponent) {
	  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
	}
	
	function pow() {
	  var exponent = 1,
	      scale = continuous(deinterpolate, reinterpolate),
	      domain = scale.domain;
	
	  function deinterpolate(a, b) {
	    return (b = raise(b, exponent) - (a = raise(a, exponent)))
	        ? function(x) { return (raise(x, exponent) - a) / b; }
	        : constant(b);
	  }
	
	  function reinterpolate(a, b) {
	    b = raise(b, exponent) - (a = raise(a, exponent));
	    return function(t) { return raise(a + b * t, 1 / exponent); };
	  }
	
	  scale.exponent = function(_) {
	    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
	  };
	
	  scale.copy = function() {
	    return copy(scale, pow().exponent(exponent));
	  };
	
	  return linearish(scale);
	}
	
	function sqrt() {
	  return pow().exponent(0.5);
	}
	
	function quantile$1() {
	  var domain = [],
	      range$$1 = [],
	      thresholds = [];
	
	  function rescale() {
	    var i = 0, n = Math.max(1, range$$1.length);
	    thresholds = new Array(n - 1);
	    while (++i < n) thresholds[i - 1] = d3Array.quantile(domain, i / n);
	    return scale;
	  }
	
	  function scale(x) {
	    if (!isNaN(x = +x)) return range$$1[d3Array.bisect(thresholds, x)];
	  }
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN] : [
	      i > 0 ? thresholds[i - 1] : domain[0],
	      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
	    ];
	  };
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [];
	    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
	    domain.sort(d3Array.ascending);
	    return rescale();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.quantiles = function() {
	    return thresholds.slice();
	  };
	
	  scale.copy = function() {
	    return quantile$1()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	function quantize() {
	  var x0 = 0,
	      x1 = 1,
	      n = 1,
	      domain = [0.5],
	      range$$1 = [0, 1];
	
	  function scale(x) {
	    if (x <= x) return range$$1[d3Array.bisect(domain, x, 0, n)];
	  }
	
	  function rescale() {
	    var i = -1;
	    domain = new Array(n);
	    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
	    return scale;
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (n = (range$$1 = slice.call(_)).length - 1, rescale()) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN]
	        : i < 1 ? [x0, domain[0]]
	        : i >= n ? [domain[n - 1], x1]
	        : [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return quantize()
	        .domain([x0, x1])
	        .range(range$$1);
	  };
	
	  return linearish(scale);
	}
	
	function threshold() {
	  var domain = [0.5],
	      range$$1 = [0, 1],
	      n = 1;
	
	  function scale(x) {
	    if (x <= x) return range$$1[d3Array.bisect(domain, x, 0, n)];
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = slice.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return threshold()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	var durationSecond = 1000;
	var durationMinute = durationSecond * 60;
	var durationHour = durationMinute * 60;
	var durationDay = durationHour * 24;
	var durationWeek = durationDay * 7;
	var durationMonth = durationDay * 30;
	var durationYear = durationDay * 365;
	
	function date(t) {
	  return new Date(t);
	}
	
	function number$1(t) {
	  return t instanceof Date ? +t : +new Date(+t);
	}
	
	function calendar(year, month, week, day, hour, minute, second, millisecond, format$$1) {
	  var scale = continuous(deinterpolateLinear, d3Interpolate.interpolateNumber),
	      invert = scale.invert,
	      domain = scale.domain;
	
	  var formatMillisecond = format$$1(".%L"),
	      formatSecond = format$$1(":%S"),
	      formatMinute = format$$1("%I:%M"),
	      formatHour = format$$1("%I %p"),
	      formatDay = format$$1("%a %d"),
	      formatWeek = format$$1("%b %d"),
	      formatMonth = format$$1("%B"),
	      formatYear = format$$1("%Y");
	
	  var tickIntervals = [
	    [second,  1,      durationSecond],
	    [second,  5,  5 * durationSecond],
	    [second, 15, 15 * durationSecond],
	    [second, 30, 30 * durationSecond],
	    [minute,  1,      durationMinute],
	    [minute,  5,  5 * durationMinute],
	    [minute, 15, 15 * durationMinute],
	    [minute, 30, 30 * durationMinute],
	    [  hour,  1,      durationHour  ],
	    [  hour,  3,  3 * durationHour  ],
	    [  hour,  6,  6 * durationHour  ],
	    [  hour, 12, 12 * durationHour  ],
	    [   day,  1,      durationDay   ],
	    [   day,  2,  2 * durationDay   ],
	    [  week,  1,      durationWeek  ],
	    [ month,  1,      durationMonth ],
	    [ month,  3,  3 * durationMonth ],
	    [  year,  1,      durationYear  ]
	  ];
	
	  function tickFormat(date) {
	    return (second(date) < date ? formatMillisecond
	        : minute(date) < date ? formatSecond
	        : hour(date) < date ? formatMinute
	        : day(date) < date ? formatHour
	        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
	        : year(date) < date ? formatMonth
	        : formatYear)(date);
	  }
	
	  function tickInterval(interval, start, stop, step) {
	    if (interval == null) interval = 10;
	
	    // If a desired tick count is specified, pick a reasonable tick interval
	    // based on the extent of the domain and a rough estimate of tick size.
	    // Otherwise, assume interval is already a time interval and use it.
	    if (typeof interval === "number") {
	      var target = Math.abs(stop - start) / interval,
	          i = d3Array.bisector(function(i) { return i[2]; }).right(tickIntervals, target);
	      if (i === tickIntervals.length) {
	        step = d3Array.tickStep(start / durationYear, stop / durationYear, interval);
	        interval = year;
	      } else if (i) {
	        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
	        step = i[1];
	        interval = i[0];
	      } else {
	        step = d3Array.tickStep(start, stop, interval);
	        interval = millisecond;
	      }
	    }
	
	    return step == null ? interval : interval.every(step);
	  }
	
	  scale.invert = function(y) {
	    return new Date(invert(y));
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? domain(map$1.call(_, number$1)) : domain().map(date);
	  };
	
	  scale.ticks = function(interval, step) {
	    var d = domain(),
	        t0 = d[0],
	        t1 = d[d.length - 1],
	        r = t1 < t0,
	        t;
	    if (r) t = t0, t0 = t1, t1 = t;
	    t = tickInterval(interval, t0, t1, step);
	    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
	    return r ? t.reverse() : t;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return specifier == null ? tickFormat : format$$1(specifier);
	  };
	
	  scale.nice = function(interval, step) {
	    var d = domain();
	    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
	        ? domain(nice(d, interval))
	        : scale;
	  };
	
	  scale.copy = function() {
	    return copy(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format$$1));
	  };
	
	  return scale;
	}
	
	var time = function() {
	  return calendar(d3Time.timeYear, d3Time.timeMonth, d3Time.timeWeek, d3Time.timeDay, d3Time.timeHour, d3Time.timeMinute, d3Time.timeSecond, d3Time.timeMillisecond, d3TimeFormat.timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
	};
	
	var utcTime = function() {
	  return calendar(d3Time.utcYear, d3Time.utcMonth, d3Time.utcWeek, d3Time.utcDay, d3Time.utcHour, d3Time.utcMinute, d3Time.utcSecond, d3Time.utcMillisecond, d3TimeFormat.utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
	};
	
	var colors = function(s) {
	  return s.match(/.{6}/g).map(function(x) {
	    return "#" + x;
	  });
	};
	
	var category10 = colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");
	
	var category20b = colors("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6");
	
	var category20c = colors("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9");
	
	var category20 = colors("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5");
	
	var cubehelix$1 = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(300, 0.5, 0.0), d3Color.cubehelix(-240, 0.5, 1.0));
	
	var warm = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(-100, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	var cool = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(260, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	var rainbow = d3Color.cubehelix();
	
	var rainbow$1 = function(t) {
	  if (t < 0 || t > 1) t -= Math.floor(t);
	  var ts = Math.abs(t - 0.5);
	  rainbow.h = 360 * t - 100;
	  rainbow.s = 1.5 - 1.5 * ts;
	  rainbow.l = 0.8 - 0.9 * ts;
	  return rainbow + "";
	};
	
	function ramp(range$$1) {
	  var n = range$$1.length;
	  return function(t) {
	    return range$$1[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
	  };
	}
	
	var viridis = ramp(colors("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
	
	var magma = ramp(colors("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
	
	var inferno = ramp(colors("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
	
	var plasma = ramp(colors("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
	
	function sequential(interpolator) {
	  var x0 = 0,
	      x1 = 1,
	      clamp = false;
	
	  function scale(x) {
	    var t = (x - x0) / (x1 - x0);
	    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, scale) : clamp;
	  };
	
	  scale.interpolator = function(_) {
	    return arguments.length ? (interpolator = _, scale) : interpolator;
	  };
	
	  scale.copy = function() {
	    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
	  };
	
	  return linearish(scale);
	}
	
	exports.scaleBand = band;
	exports.scalePoint = point;
	exports.scaleIdentity = identity;
	exports.scaleLinear = linear;
	exports.scaleLog = log;
	exports.scaleOrdinal = ordinal;
	exports.scaleImplicit = implicit;
	exports.scalePow = pow;
	exports.scaleSqrt = sqrt;
	exports.scaleQuantile = quantile$1;
	exports.scaleQuantize = quantize;
	exports.scaleThreshold = threshold;
	exports.scaleTime = time;
	exports.scaleUtc = utcTime;
	exports.schemeCategory10 = category10;
	exports.schemeCategory20b = category20b;
	exports.schemeCategory20c = category20c;
	exports.schemeCategory20 = category20;
	exports.interpolateCubehelixDefault = cubehelix$1;
	exports.interpolateRainbow = rainbow$1;
	exports.interpolateWarm = warm;
	exports.interpolateCool = cool;
	exports.interpolateViridis = viridis;
	exports.interpolateMagma = magma;
	exports.interpolateInferno = inferno;
	exports.interpolatePlasma = plasma;
	exports.scaleSequential = sequential;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),

/***/ "./node_modules/d3-shape/build/d3-shape.js":
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-shape/ Version 1.2.0. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__("./node_modules/d3-path/build/d3-path.js")) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-path'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Path) { 'use strict';
	
	var constant = function(x) {
	  return function constant() {
	    return x;
	  };
	};
	
	var abs = Math.abs;
	var atan2 = Math.atan2;
	var cos = Math.cos;
	var max = Math.max;
	var min = Math.min;
	var sin = Math.sin;
	var sqrt = Math.sqrt;
	
	var epsilon = 1e-12;
	var pi = Math.PI;
	var halfPi = pi / 2;
	var tau = 2 * pi;
	
	function acos(x) {
	  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
	}
	
	function asin(x) {
	  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
	}
	
	function arcInnerRadius(d) {
	  return d.innerRadius;
	}
	
	function arcOuterRadius(d) {
	  return d.outerRadius;
	}
	
	function arcStartAngle(d) {
	  return d.startAngle;
	}
	
	function arcEndAngle(d) {
	  return d.endAngle;
	}
	
	function arcPadAngle(d) {
	  return d && d.padAngle; // Note: optional!
	}
	
	function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
	  var x10 = x1 - x0, y10 = y1 - y0,
	      x32 = x3 - x2, y32 = y3 - y2,
	      t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
	  return [x0 + t * x10, y0 + t * y10];
	}
	
	// Compute perpendicular offset line of length rc.
	// http://mathworld.wolfram.com/Circle-LineIntersection.html
	function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
	  var x01 = x0 - x1,
	      y01 = y0 - y1,
	      lo = (cw ? rc : -rc) / sqrt(x01 * x01 + y01 * y01),
	      ox = lo * y01,
	      oy = -lo * x01,
	      x11 = x0 + ox,
	      y11 = y0 + oy,
	      x10 = x1 + ox,
	      y10 = y1 + oy,
	      x00 = (x11 + x10) / 2,
	      y00 = (y11 + y10) / 2,
	      dx = x10 - x11,
	      dy = y10 - y11,
	      d2 = dx * dx + dy * dy,
	      r = r1 - rc,
	      D = x11 * y10 - x10 * y11,
	      d = (dy < 0 ? -1 : 1) * sqrt(max(0, r * r * d2 - D * D)),
	      cx0 = (D * dy - dx * d) / d2,
	      cy0 = (-D * dx - dy * d) / d2,
	      cx1 = (D * dy + dx * d) / d2,
	      cy1 = (-D * dx + dy * d) / d2,
	      dx0 = cx0 - x00,
	      dy0 = cy0 - y00,
	      dx1 = cx1 - x00,
	      dy1 = cy1 - y00;
	
	  // Pick the closer of the two intersection points.
	  // TODO Is there a faster way to determine which intersection to use?
	  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	
	  return {
	    cx: cx0,
	    cy: cy0,
	    x01: -ox,
	    y01: -oy,
	    x11: cx0 * (r1 / r - 1),
	    y11: cy0 * (r1 / r - 1)
	  };
	}
	
	var arc = function() {
	  var innerRadius = arcInnerRadius,
	      outerRadius = arcOuterRadius,
	      cornerRadius = constant(0),
	      padRadius = null,
	      startAngle = arcStartAngle,
	      endAngle = arcEndAngle,
	      padAngle = arcPadAngle,
	      context = null;
	
	  function arc() {
	    var buffer,
	        r,
	        r0 = +innerRadius.apply(this, arguments),
	        r1 = +outerRadius.apply(this, arguments),
	        a0 = startAngle.apply(this, arguments) - halfPi,
	        a1 = endAngle.apply(this, arguments) - halfPi,
	        da = abs(a1 - a0),
	        cw = a1 > a0;
	
	    if (!context) context = buffer = d3Path.path();
	
	    // Ensure that the outer radius is always larger than the inner radius.
	    if (r1 < r0) r = r1, r1 = r0, r0 = r;
	
	    // Is it a point?
	    if (!(r1 > epsilon)) context.moveTo(0, 0);
	
	    // Or is it a circle or annulus?
	    else if (da > tau - epsilon) {
	      context.moveTo(r1 * cos(a0), r1 * sin(a0));
	      context.arc(0, 0, r1, a0, a1, !cw);
	      if (r0 > epsilon) {
	        context.moveTo(r0 * cos(a1), r0 * sin(a1));
	        context.arc(0, 0, r0, a1, a0, cw);
	      }
	    }
	
	    // Or is it a circular or annular sector?
	    else {
	      var a01 = a0,
	          a11 = a1,
	          a00 = a0,
	          a10 = a1,
	          da0 = da,
	          da1 = da,
	          ap = padAngle.apply(this, arguments) / 2,
	          rp = (ap > epsilon) && (padRadius ? +padRadius.apply(this, arguments) : sqrt(r0 * r0 + r1 * r1)),
	          rc = min(abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
	          rc0 = rc,
	          rc1 = rc,
	          t0,
	          t1;
	
	      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
	      if (rp > epsilon) {
	        var p0 = asin(rp / r0 * sin(ap)),
	            p1 = asin(rp / r1 * sin(ap));
	        if ((da0 -= p0 * 2) > epsilon) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
	        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
	        if ((da1 -= p1 * 2) > epsilon) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
	        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
	      }
	
	      var x01 = r1 * cos(a01),
	          y01 = r1 * sin(a01),
	          x10 = r0 * cos(a10),
	          y10 = r0 * sin(a10);
	
	      // Apply rounded corners?
	      if (rc > epsilon) {
	        var x11 = r1 * cos(a11),
	            y11 = r1 * sin(a11),
	            x00 = r0 * cos(a00),
	            y00 = r0 * sin(a00);
	
	        // Restrict the corner radius according to the sector angle.
	        if (da < pi) {
	          var oc = da0 > epsilon ? intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10],
	              ax = x01 - oc[0],
	              ay = y01 - oc[1],
	              bx = x11 - oc[0],
	              by = y11 - oc[1],
	              kc = 1 / sin(acos((ax * bx + ay * by) / (sqrt(ax * ax + ay * ay) * sqrt(bx * bx + by * by))) / 2),
	              lc = sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = min(rc, (r0 - lc) / (kc - 1));
	          rc1 = min(rc, (r1 - lc) / (kc + 1));
	        }
	      }
	
	      // Is the sector collapsed to a line?
	      if (!(da1 > epsilon)) context.moveTo(x01, y01);
	
	      // Does the sector’s outer ring have rounded corners?
	      else if (rc1 > epsilon) {
	        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
	        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
	
	        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r1, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
	          context.arc(t1.cx, t1.cy, rc1, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the outer ring just a circular arc?
	      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
	
	      // Is there no inner ring, and it’s a circular sector?
	      // Or perhaps it’s an annular sector collapsed due to padding?
	      if (!(r0 > epsilon) || !(da0 > epsilon)) context.lineTo(x10, y10);
	
	      // Does the sector’s inner ring (or point) have rounded corners?
	      else if (rc0 > epsilon) {
	        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
	        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
	
	        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r0, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
	          context.arc(t1.cx, t1.cy, rc0, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the inner ring just a circular arc?
	      else context.arc(0, 0, r0, a10, a00, cw);
	    }
	
	    context.closePath();
	
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  arc.centroid = function() {
	    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
	        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi / 2;
	    return [cos(a) * r, sin(a) * r];
	  };
	
	  arc.innerRadius = function(_) {
	    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant(+_), arc) : innerRadius;
	  };
	
	  arc.outerRadius = function(_) {
	    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant(+_), arc) : outerRadius;
	  };
	
	  arc.cornerRadius = function(_) {
	    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant(+_), arc) : cornerRadius;
	  };
	
	  arc.padRadius = function(_) {
	    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant(+_), arc) : padRadius;
	  };
	
	  arc.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), arc) : startAngle;
	  };
	
	  arc.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), arc) : endAngle;
	  };
	
	  arc.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), arc) : padAngle;
	  };
	
	  arc.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
	  };
	
	  return arc;
	};
	
	function Linear(context) {
	  this._context = context;
	}
	
	Linear.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: this._context.lineTo(x, y); break;
	    }
	  }
	};
	
	var curveLinear = function(context) {
	  return new Linear(context);
	};
	
	function x(p) {
	  return p[0];
	}
	
	function y(p) {
	  return p[1];
	}
	
	var line = function() {
	  var x$$1 = x,
	      y$$1 = y,
	      defined = constant(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function line(data) {
	    var i,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer;
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) output.lineStart();
	        else output.lineEnd();
	      }
	      if (defined0) output.point(+x$$1(d, i, data), +y$$1(d, i, data));
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  line.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant(+_), line) : x$$1;
	  };
	
	  line.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant(+_), line) : y$$1;
	  };
	
	  line.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), line) : defined;
	  };
	
	  line.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
	  };
	
	  line.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
	  };
	
	  return line;
	};
	
	var area = function() {
	  var x0 = x,
	      x1 = null,
	      y0 = constant(0),
	      y1 = y,
	      defined = constant(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function area(data) {
	    var i,
	        j,
	        k,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer,
	        x0z = new Array(n),
	        y0z = new Array(n);
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) {
	          j = i;
	          output.areaStart();
	          output.lineStart();
	        } else {
	          output.lineEnd();
	          output.lineStart();
	          for (k = i - 1; k >= j; --k) {
	            output.point(x0z[k], y0z[k]);
	          }
	          output.lineEnd();
	          output.areaEnd();
	        }
	      }
	      if (defined0) {
	        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
	        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
	      }
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  function arealine() {
	    return line().defined(defined).curve(curve).context(context);
	  }
	
	  area.x = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), x1 = null, area) : x0;
	  };
	
	  area.x0 = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), area) : x0;
	  };
	
	  area.x1 = function(_) {
	    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : x1;
	  };
	
	  area.y = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), y1 = null, area) : y0;
	  };
	
	  area.y0 = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), area) : y0;
	  };
	
	  area.y1 = function(_) {
	    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : y1;
	  };
	
	  area.lineX0 =
	  area.lineY0 = function() {
	    return arealine().x(x0).y(y0);
	  };
	
	  area.lineY1 = function() {
	    return arealine().x(x0).y(y1);
	  };
	
	  area.lineX1 = function() {
	    return arealine().x(x1).y(y0);
	  };
	
	  area.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), area) : defined;
	  };
	
	  area.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
	  };
	
	  area.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
	  };
	
	  return area;
	};
	
	var descending = function(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	};
	
	var identity = function(d) {
	  return d;
	};
	
	var pie = function() {
	  var value = identity,
	      sortValues = descending,
	      sort = null,
	      startAngle = constant(0),
	      endAngle = constant(tau),
	      padAngle = constant(0);
	
	  function pie(data) {
	    var i,
	        n = data.length,
	        j,
	        k,
	        sum = 0,
	        index = new Array(n),
	        arcs = new Array(n),
	        a0 = +startAngle.apply(this, arguments),
	        da = Math.min(tau, Math.max(-tau, endAngle.apply(this, arguments) - a0)),
	        a1,
	        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
	        pa = p * (da < 0 ? -1 : 1),
	        v;
	
	    for (i = 0; i < n; ++i) {
	      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
	        sum += v;
	      }
	    }
	
	    // Optionally sort the arcs by previously-computed values or by data.
	    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
	    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });
	
	    // Compute the arcs! They are stored in the original data's order.
	    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
	      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
	        data: data[j],
	        index: i,
	        value: v,
	        startAngle: a0,
	        endAngle: a1,
	        padAngle: p
	      };
	    }
	
	    return arcs;
	  }
	
	  pie.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), pie) : value;
	  };
	
	  pie.sortValues = function(_) {
	    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
	  };
	
	  pie.sort = function(_) {
	    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
	  };
	
	  pie.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), pie) : startAngle;
	  };
	
	  pie.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), pie) : endAngle;
	  };
	
	  pie.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), pie) : padAngle;
	  };
	
	  return pie;
	};
	
	var curveRadialLinear = curveRadial(curveLinear);
	
	function Radial(curve) {
	  this._curve = curve;
	}
	
	Radial.prototype = {
	  areaStart: function() {
	    this._curve.areaStart();
	  },
	  areaEnd: function() {
	    this._curve.areaEnd();
	  },
	  lineStart: function() {
	    this._curve.lineStart();
	  },
	  lineEnd: function() {
	    this._curve.lineEnd();
	  },
	  point: function(a, r) {
	    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
	  }
	};
	
	function curveRadial(curve) {
	
	  function radial(context) {
	    return new Radial(curve(context));
	  }
	
	  radial._curve = curve;
	
	  return radial;
	}
	
	function lineRadial(l) {
	  var c = l.curve;
	
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	
	  l.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return l;
	}
	
	var lineRadial$1 = function() {
	  return lineRadial(line().curve(curveRadialLinear));
	};
	
	var areaRadial = function() {
	  var a = area().curve(curveRadialLinear),
	      c = a.curve,
	      x0 = a.lineX0,
	      x1 = a.lineX1,
	      y0 = a.lineY0,
	      y1 = a.lineY1;
	
	  a.angle = a.x, delete a.x;
	  a.startAngle = a.x0, delete a.x0;
	  a.endAngle = a.x1, delete a.x1;
	  a.radius = a.y, delete a.y;
	  a.innerRadius = a.y0, delete a.y0;
	  a.outerRadius = a.y1, delete a.y1;
	  a.lineStartAngle = function() { return lineRadial(x0()); }, delete a.lineX0;
	  a.lineEndAngle = function() { return lineRadial(x1()); }, delete a.lineX1;
	  a.lineInnerRadius = function() { return lineRadial(y0()); }, delete a.lineY0;
	  a.lineOuterRadius = function() { return lineRadial(y1()); }, delete a.lineY1;
	
	  a.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return a;
	};
	
	var pointRadial = function(x, y) {
	  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
	};
	
	var slice = Array.prototype.slice;
	
	function linkSource(d) {
	  return d.source;
	}
	
	function linkTarget(d) {
	  return d.target;
	}
	
	function link(curve) {
	  var source = linkSource,
	      target = linkTarget,
	      x$$1 = x,
	      y$$1 = y,
	      context = null;
	
	  function link() {
	    var buffer, argv = slice.call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
	    if (!context) context = buffer = d3Path.path();
	    curve(context, +x$$1.apply(this, (argv[0] = s, argv)), +y$$1.apply(this, argv), +x$$1.apply(this, (argv[0] = t, argv)), +y$$1.apply(this, argv));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  link.source = function(_) {
	    return arguments.length ? (source = _, link) : source;
	  };
	
	  link.target = function(_) {
	    return arguments.length ? (target = _, link) : target;
	  };
	
	  link.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant(+_), link) : x$$1;
	  };
	
	  link.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant(+_), link) : y$$1;
	  };
	
	  link.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), link) : context;
	  };
	
	  return link;
	}
	
	function curveHorizontal(context, x0, y0, x1, y1) {
	  context.moveTo(x0, y0);
	  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
	}
	
	function curveVertical(context, x0, y0, x1, y1) {
	  context.moveTo(x0, y0);
	  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
	}
	
	function curveRadial$1(context, x0, y0, x1, y1) {
	  var p0 = pointRadial(x0, y0),
	      p1 = pointRadial(x0, y0 = (y0 + y1) / 2),
	      p2 = pointRadial(x1, y0),
	      p3 = pointRadial(x1, y1);
	  context.moveTo(p0[0], p0[1]);
	  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
	}
	
	function linkHorizontal() {
	  return link(curveHorizontal);
	}
	
	function linkVertical() {
	  return link(curveVertical);
	}
	
	function linkRadial() {
	  var l = link(curveRadial$1);
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	  return l;
	}
	
	var circle = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / pi);
	    context.moveTo(r, 0);
	    context.arc(0, 0, r, 0, tau);
	  }
	};
	
	var cross = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / 5) / 2;
	    context.moveTo(-3 * r, -r);
	    context.lineTo(-r, -r);
	    context.lineTo(-r, -3 * r);
	    context.lineTo(r, -3 * r);
	    context.lineTo(r, -r);
	    context.lineTo(3 * r, -r);
	    context.lineTo(3 * r, r);
	    context.lineTo(r, r);
	    context.lineTo(r, 3 * r);
	    context.lineTo(-r, 3 * r);
	    context.lineTo(-r, r);
	    context.lineTo(-3 * r, r);
	    context.closePath();
	  }
	};
	
	var tan30 = Math.sqrt(1 / 3);
	var tan30_2 = tan30 * 2;
	
	var diamond = {
	  draw: function(context, size) {
	    var y = Math.sqrt(size / tan30_2),
	        x = y * tan30;
	    context.moveTo(0, -y);
	    context.lineTo(x, 0);
	    context.lineTo(0, y);
	    context.lineTo(-x, 0);
	    context.closePath();
	  }
	};
	
	var ka = 0.89081309152928522810;
	var kr = Math.sin(pi / 10) / Math.sin(7 * pi / 10);
	var kx = Math.sin(tau / 10) * kr;
	var ky = -Math.cos(tau / 10) * kr;
	
	var star = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size * ka),
	        x = kx * r,
	        y = ky * r;
	    context.moveTo(0, -r);
	    context.lineTo(x, y);
	    for (var i = 1; i < 5; ++i) {
	      var a = tau * i / 5,
	          c = Math.cos(a),
	          s = Math.sin(a);
	      context.lineTo(s * r, -c * r);
	      context.lineTo(c * x - s * y, s * x + c * y);
	    }
	    context.closePath();
	  }
	};
	
	var square = {
	  draw: function(context, size) {
	    var w = Math.sqrt(size),
	        x = -w / 2;
	    context.rect(x, x, w, w);
	  }
	};
	
	var sqrt3 = Math.sqrt(3);
	
	var triangle = {
	  draw: function(context, size) {
	    var y = -Math.sqrt(size / (sqrt3 * 3));
	    context.moveTo(0, y * 2);
	    context.lineTo(-sqrt3 * y, -y);
	    context.lineTo(sqrt3 * y, -y);
	    context.closePath();
	  }
	};
	
	var c = -0.5;
	var s = Math.sqrt(3) / 2;
	var k = 1 / Math.sqrt(12);
	var a = (k / 2 + 1) * 3;
	
	var wye = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / a),
	        x0 = r / 2,
	        y0 = r * k,
	        x1 = x0,
	        y1 = r * k + r,
	        x2 = -x1,
	        y2 = y1;
	    context.moveTo(x0, y0);
	    context.lineTo(x1, y1);
	    context.lineTo(x2, y2);
	    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
	    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
	    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
	    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
	    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
	    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
	    context.closePath();
	  }
	};
	
	var symbols = [
	  circle,
	  cross,
	  diamond,
	  square,
	  star,
	  triangle,
	  wye
	];
	
	var symbol = function() {
	  var type = constant(circle),
	      size = constant(64),
	      context = null;
	
	  function symbol() {
	    var buffer;
	    if (!context) context = buffer = d3Path.path();
	    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  symbol.type = function(_) {
	    return arguments.length ? (type = typeof _ === "function" ? _ : constant(_), symbol) : type;
	  };
	
	  symbol.size = function(_) {
	    return arguments.length ? (size = typeof _ === "function" ? _ : constant(+_), symbol) : size;
	  };
	
	  symbol.context = function(_) {
	    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
	  };
	
	  return symbol;
	};
	
	var noop = function() {};
	
	function point(that, x, y) {
	  that._context.bezierCurveTo(
	    (2 * that._x0 + that._x1) / 3,
	    (2 * that._y0 + that._y1) / 3,
	    (that._x0 + 2 * that._x1) / 3,
	    (that._y0 + 2 * that._y1) / 3,
	    (that._x0 + 4 * that._x1 + x) / 6,
	    (that._y0 + 4 * that._y1 + y) / 6
	  );
	}
	
	function Basis(context) {
	  this._context = context;
	}
	
	Basis.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 3: point(this, this._x1, this._y1); // proceed
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basis = function(context) {
	  return new Basis(context);
	};
	
	function BasisClosed(context) {
	  this._context = context;
	}
	
	BasisClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x2, this._y2);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
	        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x2, this._y2);
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
	      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
	      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basisClosed = function(context) {
	  return new BasisClosed(context);
	};
	
	function BasisOpen(context) {
	  this._context = context;
	}
	
	BasisOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
	      case 3: this._point = 4; // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basisOpen = function(context) {
	  return new BasisOpen(context);
	};
	
	function Bundle(context, beta) {
	  this._basis = new Basis(context);
	  this._beta = beta;
	}
	
	Bundle.prototype = {
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	    this._basis.lineStart();
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        j = x.length - 1;
	
	    if (j > 0) {
	      var x0 = x[0],
	          y0 = y[0],
	          dx = x[j] - x0,
	          dy = y[j] - y0,
	          i = -1,
	          t;
	
	      while (++i <= j) {
	        t = i / j;
	        this._basis.point(
	          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
	          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
	        );
	      }
	    }
	
	    this._x = this._y = null;
	    this._basis.lineEnd();
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	var bundle = ((function custom(beta) {
	
	  function bundle(context) {
	    return beta === 1 ? new Basis(context) : new Bundle(context, beta);
	  }
	
	  bundle.beta = function(beta) {
	    return custom(+beta);
	  };
	
	  return bundle;
	}))(0.85);
	
	function point$1(that, x, y) {
	  that._context.bezierCurveTo(
	    that._x1 + that._k * (that._x2 - that._x0),
	    that._y1 + that._k * (that._y2 - that._y0),
	    that._x2 + that._k * (that._x1 - x),
	    that._y2 + that._k * (that._y1 - y),
	    that._x2,
	    that._y2
	  );
	}
	
	function Cardinal(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	Cardinal.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: point$1(this, this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
	      case 2: this._point = 3; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinal = ((function custom(tension) {
	
	  function cardinal(context) {
	    return new Cardinal(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	}))(0);
	
	function CardinalClosed(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalClosed = ((function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalClosed(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	}))(0);
	
	function CardinalOpen(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalOpen = ((function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalOpen(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	}))(0);
	
	function point$2(that, x, y) {
	  var x1 = that._x1,
	      y1 = that._y1,
	      x2 = that._x2,
	      y2 = that._y2;
	
	  if (that._l01_a > epsilon) {
	    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
	        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
	    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
	    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
	  }
	
	  if (that._l23_a > epsilon) {
	    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
	        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
	    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
	    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
	  }
	
	  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
	}
	
	function CatmullRom(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRom.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: this.point(this._x2, this._y2); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRom = ((function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	}))(0.5);
	
	function CatmullRomClosed(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomClosed = ((function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	}))(0.5);
	
	function CatmullRomOpen(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomOpen = ((function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	}))(0.5);
	
	function LinearClosed(context) {
	  this._context = context;
	}
	
	LinearClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._point) this._context.closePath();
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    if (this._point) this._context.lineTo(x, y);
	    else this._point = 1, this._context.moveTo(x, y);
	  }
	};
	
	var linearClosed = function(context) {
	  return new LinearClosed(context);
	};
	
	function sign(x) {
	  return x < 0 ? -1 : 1;
	}
	
	// Calculate the slopes of the tangents (Hermite-type interpolation) based on
	// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
	// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
	// NOV(II), P. 443, 1990.
	function slope3(that, x2, y2) {
	  var h0 = that._x1 - that._x0,
	      h1 = x2 - that._x1,
	      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
	      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
	      p = (s0 * h1 + s1 * h0) / (h0 + h1);
	  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
	}
	
	// Calculate a one-sided slope.
	function slope2(that, t) {
	  var h = that._x1 - that._x0;
	  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
	}
	
	// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
	// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
	// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
	function point$3(that, t0, t1) {
	  var x0 = that._x0,
	      y0 = that._y0,
	      x1 = that._x1,
	      y1 = that._y1,
	      dx = (x1 - x0) / 3;
	  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
	}
	
	function MonotoneX(context) {
	  this._context = context;
	}
	
	MonotoneX.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 =
	    this._t0 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	      case 3: point$3(this, this._t0, slope2(this, this._t0)); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    var t1 = NaN;
	
	    x = +x, y = +y;
	    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; point$3(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
	      default: point$3(this, this._t0, t1 = slope3(this, x, y)); break;
	    }
	
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	    this._t0 = t1;
	  }
	};
	
	function MonotoneY(context) {
	  this._context = new ReflectContext(context);
	}
	
	(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
	  MonotoneX.prototype.point.call(this, y, x);
	};
	
	function ReflectContext(context) {
	  this._context = context;
	}
	
	ReflectContext.prototype = {
	  moveTo: function(x, y) { this._context.moveTo(y, x); },
	  closePath: function() { this._context.closePath(); },
	  lineTo: function(x, y) { this._context.lineTo(y, x); },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
	};
	
	function monotoneX(context) {
	  return new MonotoneX(context);
	}
	
	function monotoneY(context) {
	  return new MonotoneY(context);
	}
	
	function Natural(context) {
	  this._context = context;
	}
	
	Natural.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        n = x.length;
	
	    if (n) {
	      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
	      if (n === 2) {
	        this._context.lineTo(x[1], y[1]);
	      } else {
	        var px = controlPoints(x),
	            py = controlPoints(y);
	        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
	          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
	        }
	      }
	    }
	
	    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	    this._x = this._y = null;
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
	function controlPoints(x) {
	  var i,
	      n = x.length - 1,
	      m,
	      a = new Array(n),
	      b = new Array(n),
	      r = new Array(n);
	  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
	  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
	  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
	  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
	  a[n - 1] = r[n - 1] / b[n - 1];
	  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
	  b[n - 1] = (x[n] + a[n - 1]) / 2;
	  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
	  return [a, b];
	}
	
	var natural = function(context) {
	  return new Natural(context);
	};
	
	function Step(context, t) {
	  this._context = context;
	  this._t = t;
	}
	
	Step.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = this._y = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: {
	        if (this._t <= 0) {
	          this._context.lineTo(this._x, y);
	          this._context.lineTo(x, y);
	        } else {
	          var x1 = this._x * (1 - this._t) + x * this._t;
	          this._context.lineTo(x1, this._y);
	          this._context.lineTo(x1, y);
	        }
	        break;
	      }
	    }
	    this._x = x, this._y = y;
	  }
	};
	
	var step = function(context) {
	  return new Step(context, 0.5);
	};
	
	function stepBefore(context) {
	  return new Step(context, 0);
	}
	
	function stepAfter(context) {
	  return new Step(context, 1);
	}
	
	var none = function(series, order) {
	  if (!((n = series.length) > 1)) return;
	  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
	    s0 = s1, s1 = series[order[i]];
	    for (j = 0; j < m; ++j) {
	      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
	    }
	  }
	};
	
	var none$1 = function(series) {
	  var n = series.length, o = new Array(n);
	  while (--n >= 0) o[n] = n;
	  return o;
	};
	
	function stackValue(d, key) {
	  return d[key];
	}
	
	var stack = function() {
	  var keys = constant([]),
	      order = none$1,
	      offset = none,
	      value = stackValue;
	
	  function stack(data) {
	    var kz = keys.apply(this, arguments),
	        i,
	        m = data.length,
	        n = kz.length,
	        sz = new Array(n),
	        oz;
	
	    for (i = 0; i < n; ++i) {
	      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
	        si[j] = sij = [0, +value(data[j], ki, j, data)];
	        sij.data = data[j];
	      }
	      si.key = ki;
	    }
	
	    for (i = 0, oz = order(sz); i < n; ++i) {
	      sz[oz[i]].index = i;
	    }
	
	    offset(sz, oz);
	    return sz;
	  }
	
	  stack.keys = function(_) {
	    return arguments.length ? (keys = typeof _ === "function" ? _ : constant(slice.call(_)), stack) : keys;
	  };
	
	  stack.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), stack) : value;
	  };
	
	  stack.order = function(_) {
	    return arguments.length ? (order = _ == null ? none$1 : typeof _ === "function" ? _ : constant(slice.call(_)), stack) : order;
	  };
	
	  stack.offset = function(_) {
	    return arguments.length ? (offset = _ == null ? none : _, stack) : offset;
	  };
	
	  return stack;
	};
	
	var expand = function(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
	    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
	    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
	  }
	  none(series, order);
	};
	
	var diverging = function(series, order) {
	  if (!((n = series.length) > 1)) return;
	  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
	    for (yp = yn = 0, i = 0; i < n; ++i) {
	      if ((dy = (d = series[order[i]][j])[1] - d[0]) >= 0) {
	        d[0] = yp, d[1] = yp += dy;
	      } else if (dy < 0) {
	        d[1] = yn, d[0] = yn += dy;
	      } else {
	        d[0] = yp;
	      }
	    }
	  }
	};
	
	var silhouette = function(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
	    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
	    s0[j][1] += s0[j][0] = -y / 2;
	  }
	  none(series, order);
	};
	
	var wiggle = function(series, order) {
	  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
	  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
	    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
	      var si = series[order[i]],
	          sij0 = si[j][1] || 0,
	          sij1 = si[j - 1][1] || 0,
	          s3 = (sij0 - sij1) / 2;
	      for (var k = 0; k < i; ++k) {
	        var sk = series[order[k]],
	            skj0 = sk[j][1] || 0,
	            skj1 = sk[j - 1][1] || 0;
	        s3 += skj0 - skj1;
	      }
	      s1 += sij0, s2 += s3 * sij0;
	    }
	    s0[j - 1][1] += s0[j - 1][0] = y;
	    if (s1) y -= s2 / s1;
	  }
	  s0[j - 1][1] += s0[j - 1][0] = y;
	  none(series, order);
	};
	
	var ascending = function(series) {
	  var sums = series.map(sum);
	  return none$1(series).sort(function(a, b) { return sums[a] - sums[b]; });
	};
	
	function sum(series) {
	  var s = 0, i = -1, n = series.length, v;
	  while (++i < n) if (v = +series[i][1]) s += v;
	  return s;
	}
	
	var descending$1 = function(series) {
	  return ascending(series).reverse();
	};
	
	var insideOut = function(series) {
	  var n = series.length,
	      i,
	      j,
	      sums = series.map(sum),
	      order = none$1(series).sort(function(a, b) { return sums[b] - sums[a]; }),
	      top = 0,
	      bottom = 0,
	      tops = [],
	      bottoms = [];
	
	  for (i = 0; i < n; ++i) {
	    j = order[i];
	    if (top < bottom) {
	      top += sums[j];
	      tops.push(j);
	    } else {
	      bottom += sums[j];
	      bottoms.push(j);
	    }
	  }
	
	  return bottoms.reverse().concat(tops);
	};
	
	var reverse = function(series) {
	  return none$1(series).reverse();
	};
	
	exports.arc = arc;
	exports.area = area;
	exports.line = line;
	exports.pie = pie;
	exports.areaRadial = areaRadial;
	exports.radialArea = areaRadial;
	exports.lineRadial = lineRadial$1;
	exports.radialLine = lineRadial$1;
	exports.pointRadial = pointRadial;
	exports.linkHorizontal = linkHorizontal;
	exports.linkVertical = linkVertical;
	exports.linkRadial = linkRadial;
	exports.symbol = symbol;
	exports.symbols = symbols;
	exports.symbolCircle = circle;
	exports.symbolCross = cross;
	exports.symbolDiamond = diamond;
	exports.symbolSquare = square;
	exports.symbolStar = star;
	exports.symbolTriangle = triangle;
	exports.symbolWye = wye;
	exports.curveBasisClosed = basisClosed;
	exports.curveBasisOpen = basisOpen;
	exports.curveBasis = basis;
	exports.curveBundle = bundle;
	exports.curveCardinalClosed = cardinalClosed;
	exports.curveCardinalOpen = cardinalOpen;
	exports.curveCardinal = cardinal;
	exports.curveCatmullRomClosed = catmullRomClosed;
	exports.curveCatmullRomOpen = catmullRomOpen;
	exports.curveCatmullRom = catmullRom;
	exports.curveLinearClosed = linearClosed;
	exports.curveLinear = curveLinear;
	exports.curveMonotoneX = monotoneX;
	exports.curveMonotoneY = monotoneY;
	exports.curveNatural = natural;
	exports.curveStep = step;
	exports.curveStepAfter = stepAfter;
	exports.curveStepBefore = stepBefore;
	exports.stack = stack;
	exports.stackOffsetExpand = expand;
	exports.stackOffsetDiverging = diverging;
	exports.stackOffsetNone = none;
	exports.stackOffsetSilhouette = silhouette;
	exports.stackOffsetWiggle = wiggle;
	exports.stackOrderAscending = ascending;
	exports.stackOrderDescending = descending$1;
	exports.stackOrderInsideOut = insideOut;
	exports.stackOrderNone = none$1;
	exports.stackOrderReverse = reverse;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),

/***/ "./node_modules/d3-time-format/build/d3-time-format.js":
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time-format/ Version 2.0.5. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__("./node_modules/d3-time/build/d3-time.js")) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-time'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Time) { 'use strict';
	
	function localDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
	    date.setFullYear(d.y);
	    return date;
	  }
	  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
	}
	
	function utcDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
	    date.setUTCFullYear(d.y);
	    return date;
	  }
	  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
	}
	
	function newYear(y) {
	  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
	}
	
	function formatLocale(locale) {
	  var locale_dateTime = locale.dateTime,
	      locale_date = locale.date,
	      locale_time = locale.time,
	      locale_periods = locale.periods,
	      locale_weekdays = locale.days,
	      locale_shortWeekdays = locale.shortDays,
	      locale_months = locale.months,
	      locale_shortMonths = locale.shortMonths;
	
	  var periodRe = formatRe(locale_periods),
	      periodLookup = formatLookup(locale_periods),
	      weekdayRe = formatRe(locale_weekdays),
	      weekdayLookup = formatLookup(locale_weekdays),
	      shortWeekdayRe = formatRe(locale_shortWeekdays),
	      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
	      monthRe = formatRe(locale_months),
	      monthLookup = formatLookup(locale_months),
	      shortMonthRe = formatRe(locale_shortMonths),
	      shortMonthLookup = formatLookup(locale_shortMonths);
	
	  var formats = {
	    "a": formatShortWeekday,
	    "A": formatWeekday,
	    "b": formatShortMonth,
	    "B": formatMonth,
	    "c": null,
	    "d": formatDayOfMonth,
	    "e": formatDayOfMonth,
	    "H": formatHour24,
	    "I": formatHour12,
	    "j": formatDayOfYear,
	    "L": formatMilliseconds,
	    "m": formatMonthNumber,
	    "M": formatMinutes,
	    "p": formatPeriod,
	    "S": formatSeconds,
	    "U": formatWeekNumberSunday,
	    "w": formatWeekdayNumber,
	    "W": formatWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatYear,
	    "Y": formatFullYear,
	    "Z": formatZone,
	    "%": formatLiteralPercent
	  };
	
	  var utcFormats = {
	    "a": formatUTCShortWeekday,
	    "A": formatUTCWeekday,
	    "b": formatUTCShortMonth,
	    "B": formatUTCMonth,
	    "c": null,
	    "d": formatUTCDayOfMonth,
	    "e": formatUTCDayOfMonth,
	    "H": formatUTCHour24,
	    "I": formatUTCHour12,
	    "j": formatUTCDayOfYear,
	    "L": formatUTCMilliseconds,
	    "m": formatUTCMonthNumber,
	    "M": formatUTCMinutes,
	    "p": formatUTCPeriod,
	    "S": formatUTCSeconds,
	    "U": formatUTCWeekNumberSunday,
	    "w": formatUTCWeekdayNumber,
	    "W": formatUTCWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatUTCYear,
	    "Y": formatUTCFullYear,
	    "Z": formatUTCZone,
	    "%": formatLiteralPercent
	  };
	
	  var parses = {
	    "a": parseShortWeekday,
	    "A": parseWeekday,
	    "b": parseShortMonth,
	    "B": parseMonth,
	    "c": parseLocaleDateTime,
	    "d": parseDayOfMonth,
	    "e": parseDayOfMonth,
	    "H": parseHour24,
	    "I": parseHour24,
	    "j": parseDayOfYear,
	    "L": parseMilliseconds,
	    "m": parseMonthNumber,
	    "M": parseMinutes,
	    "p": parsePeriod,
	    "S": parseSeconds,
	    "U": parseWeekNumberSunday,
	    "w": parseWeekdayNumber,
	    "W": parseWeekNumberMonday,
	    "x": parseLocaleDate,
	    "X": parseLocaleTime,
	    "y": parseYear,
	    "Y": parseFullYear,
	    "Z": parseZone,
	    "%": parseLiteralPercent
	  };
	
	  // These recursive directive definitions must be deferred.
	  formats.x = newFormat(locale_date, formats);
	  formats.X = newFormat(locale_time, formats);
	  formats.c = newFormat(locale_dateTime, formats);
	  utcFormats.x = newFormat(locale_date, utcFormats);
	  utcFormats.X = newFormat(locale_time, utcFormats);
	  utcFormats.c = newFormat(locale_dateTime, utcFormats);
	
	  function newFormat(specifier, formats) {
	    return function(date) {
	      var string = [],
	          i = -1,
	          j = 0,
	          n = specifier.length,
	          c,
	          pad,
	          format;
	
	      if (!(date instanceof Date)) date = new Date(+date);
	
	      while (++i < n) {
	        if (specifier.charCodeAt(i) === 37) {
	          string.push(specifier.slice(j, i));
	          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
	          else pad = c === "e" ? " " : "0";
	          if (format = formats[c]) c = format(date, pad);
	          string.push(c);
	          j = i + 1;
	        }
	      }
	
	      string.push(specifier.slice(j, i));
	      return string.join("");
	    };
	  }
	
	  function newParse(specifier, newDate) {
	    return function(string) {
	      var d = newYear(1900),
	          i = parseSpecifier(d, specifier, string += "", 0);
	      if (i != string.length) return null;
	
	      // The am-pm flag is 0 for AM, and 1 for PM.
	      if ("p" in d) d.H = d.H % 12 + d.p * 12;
	
	      // Convert day-of-week and week-of-year to day-of-year.
	      if ("W" in d || "U" in d) {
	        if (!("w" in d)) d.w = "W" in d ? 1 : 0;
	        var day = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
	        d.m = 0;
	        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
	      }
	
	      // If a time zone is specified, all fields are interpreted as UTC and then
	      // offset according to the specified time zone.
	      if ("Z" in d) {
	        d.H += d.Z / 100 | 0;
	        d.M += d.Z % 100;
	        return utcDate(d);
	      }
	
	      // Otherwise, all fields are in local time.
	      return newDate(d);
	    };
	  }
	
	  function parseSpecifier(d, specifier, string, j) {
	    var i = 0,
	        n = specifier.length,
	        m = string.length,
	        c,
	        parse;
	
	    while (i < n) {
	      if (j >= m) return -1;
	      c = specifier.charCodeAt(i++);
	      if (c === 37) {
	        c = specifier.charAt(i++);
	        parse = parses[c in pads ? specifier.charAt(i++) : c];
	        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
	      } else if (c != string.charCodeAt(j++)) {
	        return -1;
	      }
	    }
	
	    return j;
	  }
	
	  function parsePeriod(d, string, i) {
	    var n = periodRe.exec(string.slice(i));
	    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortWeekday(d, string, i) {
	    var n = shortWeekdayRe.exec(string.slice(i));
	    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseWeekday(d, string, i) {
	    var n = weekdayRe.exec(string.slice(i));
	    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortMonth(d, string, i) {
	    var n = shortMonthRe.exec(string.slice(i));
	    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseMonth(d, string, i) {
	    var n = monthRe.exec(string.slice(i));
	    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseLocaleDateTime(d, string, i) {
	    return parseSpecifier(d, locale_dateTime, string, i);
	  }
	
	  function parseLocaleDate(d, string, i) {
	    return parseSpecifier(d, locale_date, string, i);
	  }
	
	  function parseLocaleTime(d, string, i) {
	    return parseSpecifier(d, locale_time, string, i);
	  }
	
	  function formatShortWeekday(d) {
	    return locale_shortWeekdays[d.getDay()];
	  }
	
	  function formatWeekday(d) {
	    return locale_weekdays[d.getDay()];
	  }
	
	  function formatShortMonth(d) {
	    return locale_shortMonths[d.getMonth()];
	  }
	
	  function formatMonth(d) {
	    return locale_months[d.getMonth()];
	  }
	
	  function formatPeriod(d) {
	    return locale_periods[+(d.getHours() >= 12)];
	  }
	
	  function formatUTCShortWeekday(d) {
	    return locale_shortWeekdays[d.getUTCDay()];
	  }
	
	  function formatUTCWeekday(d) {
	    return locale_weekdays[d.getUTCDay()];
	  }
	
	  function formatUTCShortMonth(d) {
	    return locale_shortMonths[d.getUTCMonth()];
	  }
	
	  function formatUTCMonth(d) {
	    return locale_months[d.getUTCMonth()];
	  }
	
	  function formatUTCPeriod(d) {
	    return locale_periods[+(d.getUTCHours() >= 12)];
	  }
	
	  return {
	    format: function(specifier) {
	      var f = newFormat(specifier += "", formats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    parse: function(specifier) {
	      var p = newParse(specifier += "", localDate);
	      p.toString = function() { return specifier; };
	      return p;
	    },
	    utcFormat: function(specifier) {
	      var f = newFormat(specifier += "", utcFormats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    utcParse: function(specifier) {
	      var p = newParse(specifier, utcDate);
	      p.toString = function() { return specifier; };
	      return p;
	    }
	  };
	}
	
	var pads = {"-": "", "_": " ", "0": "0"};
	var numberRe = /^\s*\d+/;
	var percentRe = /^%/;
	var requoteRe = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	
	function pad(value, fill, width) {
	  var sign = value < 0 ? "-" : "",
	      string = (sign ? -value : value) + "",
	      length = string.length;
	  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	}
	
	function requote(s) {
	  return s.replace(requoteRe, "\\$&");
	}
	
	function formatRe(names) {
	  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
	}
	
	function formatLookup(names) {
	  var map = {}, i = -1, n = names.length;
	  while (++i < n) map[names[i].toLowerCase()] = i;
	  return map;
	}
	
	function parseWeekdayNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.w = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.U = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.W = +n[0], i + n[0].length) : -1;
	}
	
	function parseFullYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 4));
	  return n ? (d.y = +n[0], i + n[0].length) : -1;
	}
	
	function parseYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
	}
	
	function parseZone(d, string, i) {
	  var n = /^(Z)|([+-]\d\d)(?:\:?(\d\d))?/.exec(string.slice(i, i + 6));
	  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
	}
	
	function parseMonthNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
	}
	
	function parseDayOfMonth(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseDayOfYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseHour24(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.H = +n[0], i + n[0].length) : -1;
	}
	
	function parseMinutes(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.M = +n[0], i + n[0].length) : -1;
	}
	
	function parseSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.S = +n[0], i + n[0].length) : -1;
	}
	
	function parseMilliseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.L = +n[0], i + n[0].length) : -1;
	}
	
	function parseLiteralPercent(d, string, i) {
	  var n = percentRe.exec(string.slice(i, i + 1));
	  return n ? i + n[0].length : -1;
	}
	
	function formatDayOfMonth(d, p) {
	  return pad(d.getDate(), p, 2);
	}
	
	function formatHour24(d, p) {
	  return pad(d.getHours(), p, 2);
	}
	
	function formatHour12(d, p) {
	  return pad(d.getHours() % 12 || 12, p, 2);
	}
	
	function formatDayOfYear(d, p) {
	  return pad(1 + d3Time.timeDay.count(d3Time.timeYear(d), d), p, 3);
	}
	
	function formatMilliseconds(d, p) {
	  return pad(d.getMilliseconds(), p, 3);
	}
	
	function formatMonthNumber(d, p) {
	  return pad(d.getMonth() + 1, p, 2);
	}
	
	function formatMinutes(d, p) {
	  return pad(d.getMinutes(), p, 2);
	}
	
	function formatSeconds(d, p) {
	  return pad(d.getSeconds(), p, 2);
	}
	
	function formatWeekNumberSunday(d, p) {
	  return pad(d3Time.timeSunday.count(d3Time.timeYear(d), d), p, 2);
	}
	
	function formatWeekdayNumber(d) {
	  return d.getDay();
	}
	
	function formatWeekNumberMonday(d, p) {
	  return pad(d3Time.timeMonday.count(d3Time.timeYear(d), d), p, 2);
	}
	
	function formatYear(d, p) {
	  return pad(d.getFullYear() % 100, p, 2);
	}
	
	function formatFullYear(d, p) {
	  return pad(d.getFullYear() % 10000, p, 4);
	}
	
	function formatZone(d) {
	  var z = d.getTimezoneOffset();
	  return (z > 0 ? "-" : (z *= -1, "+"))
	      + pad(z / 60 | 0, "0", 2)
	      + pad(z % 60, "0", 2);
	}
	
	function formatUTCDayOfMonth(d, p) {
	  return pad(d.getUTCDate(), p, 2);
	}
	
	function formatUTCHour24(d, p) {
	  return pad(d.getUTCHours(), p, 2);
	}
	
	function formatUTCHour12(d, p) {
	  return pad(d.getUTCHours() % 12 || 12, p, 2);
	}
	
	function formatUTCDayOfYear(d, p) {
	  return pad(1 + d3Time.utcDay.count(d3Time.utcYear(d), d), p, 3);
	}
	
	function formatUTCMilliseconds(d, p) {
	  return pad(d.getUTCMilliseconds(), p, 3);
	}
	
	function formatUTCMonthNumber(d, p) {
	  return pad(d.getUTCMonth() + 1, p, 2);
	}
	
	function formatUTCMinutes(d, p) {
	  return pad(d.getUTCMinutes(), p, 2);
	}
	
	function formatUTCSeconds(d, p) {
	  return pad(d.getUTCSeconds(), p, 2);
	}
	
	function formatUTCWeekNumberSunday(d, p) {
	  return pad(d3Time.utcSunday.count(d3Time.utcYear(d), d), p, 2);
	}
	
	function formatUTCWeekdayNumber(d) {
	  return d.getUTCDay();
	}
	
	function formatUTCWeekNumberMonday(d, p) {
	  return pad(d3Time.utcMonday.count(d3Time.utcYear(d), d), p, 2);
	}
	
	function formatUTCYear(d, p) {
	  return pad(d.getUTCFullYear() % 100, p, 2);
	}
	
	function formatUTCFullYear(d, p) {
	  return pad(d.getUTCFullYear() % 10000, p, 4);
	}
	
	function formatUTCZone() {
	  return "+0000";
	}
	
	function formatLiteralPercent() {
	  return "%";
	}
	
	var locale$1;
	
	
	
	
	
	defaultLocale({
	  dateTime: "%x, %X",
	  date: "%-m/%-d/%Y",
	  time: "%-I:%M:%S %p",
	  periods: ["AM", "PM"],
	  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
	});
	
	function defaultLocale(definition) {
	  locale$1 = formatLocale(definition);
	  exports.timeFormat = locale$1.format;
	  exports.timeParse = locale$1.parse;
	  exports.utcFormat = locale$1.utcFormat;
	  exports.utcParse = locale$1.utcParse;
	  return locale$1;
	}
	
	var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
	
	function formatIsoNative(date) {
	  return date.toISOString();
	}
	
	var formatIso = Date.prototype.toISOString
	    ? formatIsoNative
	    : exports.utcFormat(isoSpecifier);
	
	function parseIsoNative(string) {
	  var date = new Date(string);
	  return isNaN(date) ? null : date;
	}
	
	var parseIso = +new Date("2000-01-01T00:00:00.000Z")
	    ? parseIsoNative
	    : exports.utcParse(isoSpecifier);
	
	exports.timeFormatDefaultLocale = defaultLocale;
	exports.timeFormatLocale = formatLocale;
	exports.isoFormat = formatIso;
	exports.isoParse = parseIso;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),

/***/ "./node_modules/d3-time/build/d3-time.js":
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time/ Version 1.0.7. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var t0 = new Date;
	var t1 = new Date;
	
	function newInterval(floori, offseti, count, field) {
	
	  function interval(date) {
	    return floori(date = new Date(+date)), date;
	  }
	
	  interval.floor = interval;
	
	  interval.ceil = function(date) {
	    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
	  };
	
	  interval.round = function(date) {
	    var d0 = interval(date),
	        d1 = interval.ceil(date);
	    return date - d0 < d1 - date ? d0 : d1;
	  };
	
	  interval.offset = function(date, step) {
	    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
	  };
	
	  interval.range = function(start, stop, step) {
	    var range = [];
	    start = interval.ceil(start);
	    step = step == null ? 1 : Math.floor(step);
	    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
	    do range.push(new Date(+start)); while (offseti(start, step), floori(start), start < stop)
	    return range;
	  };
	
	  interval.filter = function(test) {
	    return newInterval(function(date) {
	      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
	    }, function(date, step) {
	      if (date >= date) {
	        if (step < 0) while (++step <= 0) {
	          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
	        } else while (--step >= 0) {
	          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
	        }
	      }
	    });
	  };
	
	  if (count) {
	    interval.count = function(start, end) {
	      t0.setTime(+start), t1.setTime(+end);
	      floori(t0), floori(t1);
	      return Math.floor(count(t0, t1));
	    };
	
	    interval.every = function(step) {
	      step = Math.floor(step);
	      return !isFinite(step) || !(step > 0) ? null
	          : !(step > 1) ? interval
	          : interval.filter(field
	              ? function(d) { return field(d) % step === 0; }
	              : function(d) { return interval.count(0, d) % step === 0; });
	    };
	  }
	
	  return interval;
	}
	
	var millisecond = newInterval(function() {
	  // noop
	}, function(date, step) {
	  date.setTime(+date + step);
	}, function(start, end) {
	  return end - start;
	});
	
	// An optimized implementation for this simple case.
	millisecond.every = function(k) {
	  k = Math.floor(k);
	  if (!isFinite(k) || !(k > 0)) return null;
	  if (!(k > 1)) return millisecond;
	  return newInterval(function(date) {
	    date.setTime(Math.floor(date / k) * k);
	  }, function(date, step) {
	    date.setTime(+date + step * k);
	  }, function(start, end) {
	    return (end - start) / k;
	  });
	};
	
	var milliseconds = millisecond.range;
	
	var durationSecond = 1e3;
	var durationMinute = 6e4;
	var durationHour = 36e5;
	var durationDay = 864e5;
	var durationWeek = 6048e5;
	
	var second = newInterval(function(date) {
	  date.setTime(Math.floor(date / durationSecond) * durationSecond);
	}, function(date, step) {
	  date.setTime(+date + step * durationSecond);
	}, function(start, end) {
	  return (end - start) / durationSecond;
	}, function(date) {
	  return date.getUTCSeconds();
	});
	
	var seconds = second.range;
	
	var minute = newInterval(function(date) {
	  date.setTime(Math.floor(date / durationMinute) * durationMinute);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getMinutes();
	});
	
	var minutes = minute.range;
	
	var hour = newInterval(function(date) {
	  var offset = date.getTimezoneOffset() * durationMinute % durationHour;
	  if (offset < 0) offset += durationHour;
	  date.setTime(Math.floor((+date - offset) / durationHour) * durationHour + offset);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getHours();
	});
	
	var hours = hour.range;
	
	var day = newInterval(function(date) {
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setDate(date.getDate() + step);
	}, function(start, end) {
	  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay;
	}, function(date) {
	  return date.getDate() - 1;
	});
	
	var days = day.range;
	
	function weekday(i) {
	  return newInterval(function(date) {
	    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setDate(date.getDate() + step * 7);
	  }, function(start, end) {
	    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
	  });
	}
	
	var sunday = weekday(0);
	var monday = weekday(1);
	var tuesday = weekday(2);
	var wednesday = weekday(3);
	var thursday = weekday(4);
	var friday = weekday(5);
	var saturday = weekday(6);
	
	var sundays = sunday.range;
	var mondays = monday.range;
	var tuesdays = tuesday.range;
	var wednesdays = wednesday.range;
	var thursdays = thursday.range;
	var fridays = friday.range;
	var saturdays = saturday.range;
	
	var month = newInterval(function(date) {
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setMonth(date.getMonth() + step);
	}, function(start, end) {
	  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
	}, function(date) {
	  return date.getMonth();
	});
	
	var months = month.range;
	
	var year = newInterval(function(date) {
	  date.setMonth(0, 1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setFullYear(date.getFullYear() + step);
	}, function(start, end) {
	  return end.getFullYear() - start.getFullYear();
	}, function(date) {
	  return date.getFullYear();
	});
	
	// An optimized implementation for this simple case.
	year.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
	    date.setMonth(0, 1);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setFullYear(date.getFullYear() + step * k);
	  });
	};
	
	var years = year.range;
	
	var utcMinute = newInterval(function(date) {
	  date.setUTCSeconds(0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getUTCMinutes();
	});
	
	var utcMinutes = utcMinute.range;
	
	var utcHour = newInterval(function(date) {
	  date.setUTCMinutes(0, 0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getUTCHours();
	});
	
	var utcHours = utcHour.range;
	
	var utcDay = newInterval(function(date) {
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCDate(date.getUTCDate() + step);
	}, function(start, end) {
	  return (end - start) / durationDay;
	}, function(date) {
	  return date.getUTCDate() - 1;
	});
	
	var utcDays = utcDay.range;
	
	function utcWeekday(i) {
	  return newInterval(function(date) {
	    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCDate(date.getUTCDate() + step * 7);
	  }, function(start, end) {
	    return (end - start) / durationWeek;
	  });
	}
	
	var utcSunday = utcWeekday(0);
	var utcMonday = utcWeekday(1);
	var utcTuesday = utcWeekday(2);
	var utcWednesday = utcWeekday(3);
	var utcThursday = utcWeekday(4);
	var utcFriday = utcWeekday(5);
	var utcSaturday = utcWeekday(6);
	
	var utcSundays = utcSunday.range;
	var utcMondays = utcMonday.range;
	var utcTuesdays = utcTuesday.range;
	var utcWednesdays = utcWednesday.range;
	var utcThursdays = utcThursday.range;
	var utcFridays = utcFriday.range;
	var utcSaturdays = utcSaturday.range;
	
	var utcMonth = newInterval(function(date) {
	  date.setUTCDate(1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCMonth(date.getUTCMonth() + step);
	}, function(start, end) {
	  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
	}, function(date) {
	  return date.getUTCMonth();
	});
	
	var utcMonths = utcMonth.range;
	
	var utcYear = newInterval(function(date) {
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCFullYear(date.getUTCFullYear() + step);
	}, function(start, end) {
	  return end.getUTCFullYear() - start.getUTCFullYear();
	}, function(date) {
	  return date.getUTCFullYear();
	});
	
	// An optimized implementation for this simple case.
	utcYear.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
	    date.setUTCMonth(0, 1);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCFullYear(date.getUTCFullYear() + step * k);
	  });
	};
	
	var utcYears = utcYear.range;
	
	exports.timeInterval = newInterval;
	exports.timeMillisecond = millisecond;
	exports.timeMilliseconds = milliseconds;
	exports.utcMillisecond = millisecond;
	exports.utcMilliseconds = milliseconds;
	exports.timeSecond = second;
	exports.timeSeconds = seconds;
	exports.utcSecond = second;
	exports.utcSeconds = seconds;
	exports.timeMinute = minute;
	exports.timeMinutes = minutes;
	exports.timeHour = hour;
	exports.timeHours = hours;
	exports.timeDay = day;
	exports.timeDays = days;
	exports.timeWeek = sunday;
	exports.timeWeeks = sundays;
	exports.timeSunday = sunday;
	exports.timeSundays = sundays;
	exports.timeMonday = monday;
	exports.timeMondays = mondays;
	exports.timeTuesday = tuesday;
	exports.timeTuesdays = tuesdays;
	exports.timeWednesday = wednesday;
	exports.timeWednesdays = wednesdays;
	exports.timeThursday = thursday;
	exports.timeThursdays = thursdays;
	exports.timeFriday = friday;
	exports.timeFridays = fridays;
	exports.timeSaturday = saturday;
	exports.timeSaturdays = saturdays;
	exports.timeMonth = month;
	exports.timeMonths = months;
	exports.timeYear = year;
	exports.timeYears = years;
	exports.utcMinute = utcMinute;
	exports.utcMinutes = utcMinutes;
	exports.utcHour = utcHour;
	exports.utcHours = utcHours;
	exports.utcDay = utcDay;
	exports.utcDays = utcDays;
	exports.utcWeek = utcSunday;
	exports.utcWeeks = utcSundays;
	exports.utcSunday = utcSunday;
	exports.utcSundays = utcSundays;
	exports.utcMonday = utcMonday;
	exports.utcMondays = utcMondays;
	exports.utcTuesday = utcTuesday;
	exports.utcTuesdays = utcTuesdays;
	exports.utcWednesday = utcWednesday;
	exports.utcWednesdays = utcWednesdays;
	exports.utcThursday = utcThursday;
	exports.utcThursdays = utcThursdays;
	exports.utcFriday = utcFriday;
	exports.utcFridays = utcFridays;
	exports.utcSaturday = utcSaturday;
	exports.utcSaturdays = utcSaturdays;
	exports.utcMonth = utcMonth;
	exports.utcMonths = utcMonths;
	exports.utcYear = utcYear;
	exports.utcYears = utcYears;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),

/***/ "./node_modules/glamorous-grid/lib/Col.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _glamorous = __webpack_require__("./node_modules/glamorous/dist/glamorous.cjs.js");
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _shallowEqual = __webpack_require__("./node_modules/fbjs/lib/shallowEqual.js");
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _getTheme = __webpack_require__("./node_modules/glamorous-grid/lib/getTheme.js");
	
	var _getTheme2 = _interopRequireDefault(_getTheme);
	
	var _breakpoints = __webpack_require__("./node_modules/glamorous-grid/lib/breakpoints.js");
	
	var _breakpoints2 = _interopRequireDefault(_breakpoints);
	
	var _withSpacing = __webpack_require__("./node_modules/glamorous-grid/lib/withSpacing.js");
	
	var _withSpacing2 = _interopRequireDefault(_withSpacing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var alignMap = {
	  start: 'flex-start',
	  end: 'flex-end'
	};
	
	var isNil = function isNil(val) {
	  return val === undefined || val === null;
	};
	
	var Col = (0, _glamorous2.default)('div', {
	  shouldClassNameUpdate: function shouldClassNameUpdate(props, nextProps, context, nextContext) {
	    return !(0, _shallowEqual2.default)(context.theme, nextContext.theme) || !(0, _shallowEqual2.default)(props.span, nextProps.span) || !(0, _shallowEqual2.default)(props.equalWidth, nextProps.equalWidth) || !(0, _shallowEqual2.default)(props.auto, nextProps.auto) || !(0, _shallowEqual2.default)(props.offset, nextProps.offset) || !(0, _shallowEqual2.default)(props.alignSelf, nextProps.alignSelf) || !(0, _shallowEqual2.default)(props.textAlign, nextProps.textAlign);
	  }
	})({
	  position: 'relative',
	  width: '100%',
	  minHeight: 1,
	  boxSizing: 'border-box'
	}, function (props) {
	  var gridTheme = (0, _getTheme2.default)(props);
	  var gutters = gridTheme.column_gutter;
	
	  return (0, _breakpoints2.default)(gutters, gridTheme, function (size) {
	    return !isNil(size) && {
	      paddingLeft: parseFloat(size) / 2,
	      paddingRight: parseFloat(size) / 2
	    };
	  });
	}, function (props) {
	  var gridTheme = (0, _getTheme2.default)(props);
	
	  return (0, _breakpoints2.default)(props.span, gridTheme, function (span) {
	    return span && {
	      flex: '0 0 ' + span * 100 + '%',
	      maxWidth: span * 100 + '%'
	    };
	  });
	}, function (props) {
	  var gridTheme = (0, _getTheme2.default)(props);
	
	  return (0, _breakpoints2.default)(props.equalWidth, gridTheme, function () {
	    var equalWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    if (equalWidth || !props.equalWidth && !props.span) {
	      return {
	        flexBasis: 0,
	        flexGrow: 1,
	        maxWidth: '100%'
	      };
	    }
	  });
	}, function (props) {
	  var gridTheme = (0, _getTheme2.default)(props);
	
	  return (0, _breakpoints2.default)(props.auto, gridTheme, function () {
	    var auto = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    return auto && {
	      flex: '0 0 auto',
	      width: 'auto'
	    };
	  });
	}, function (props) {
	  var gridTheme = (0, _getTheme2.default)(props);
	
	  return (0, _breakpoints2.default)(props.offset, gridTheme, function (offset) {
	    return !isNil(offset) && {
	      marginLeft: offset * 100 + '%'
	    };
	  });
	}, function (props) {
	  var gridTheme = (0, _getTheme2.default)(props);
	
	  return (0, _breakpoints2.default)(props.alignSelf, gridTheme, function (align) {
	    return align && {
	      alignSelf: '' + (alignMap[align] || align)
	    };
	  });
	}, function (props) {
	  var gridTheme = (0, _getTheme2.default)(props);
	
	  return (0, _breakpoints2.default)(props.textAlign, gridTheme, function (align) {
	    return align && {
	      textAlign: align
	    };
	  });
	});
	
	exports.default = (0, _withSpacing2.default)(Col);

/***/ }),

/***/ "./node_modules/glamorous-grid/lib/Container.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _glamorous = __webpack_require__("./node_modules/glamorous/dist/glamorous.cjs.js");
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _shallowEqual = __webpack_require__("./node_modules/fbjs/lib/shallowEqual.js");
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _getTheme = __webpack_require__("./node_modules/glamorous-grid/lib/getTheme.js");
	
	var _getTheme2 = _interopRequireDefault(_getTheme);
	
	var _breakpoints = __webpack_require__("./node_modules/glamorous-grid/lib/breakpoints.js");
	
	var _breakpoints2 = _interopRequireDefault(_breakpoints);
	
	var _withSpacing = __webpack_require__("./node_modules/glamorous-grid/lib/withSpacing.js");
	
	var _withSpacing2 = _interopRequireDefault(_withSpacing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Container = (0, _glamorous2.default)('div', {
	  shouldClassNameUpdate: function shouldClassNameUpdate(props, nextProps, context, nextContext) {
	    return props.fluid !== nextProps.fluid || !(0, _shallowEqual2.default)(context.theme, nextContext.theme);
	  }
	})({
	  width: '100%',
	  position: 'relative',
	  marginLeft: 'auto',
	  marginRight: 'auto',
	  boxSizing: 'border-box'
	}, function (props) {
	  var gridTheme = (0, _getTheme2.default)(props);
	
	  return (0, _breakpoints2.default)(gridTheme.outer_gutter, gridTheme, function (size) {
	    return size && {
	      paddingLeft: size,
	      paddingRight: size
	    };
	  });
	}, function (props) {
	  if (props.fluid) return;
	
	  var gridTheme = (0, _getTheme2.default)(props);
	  var containerWidths = gridTheme.max_container_width;
	
	  return (0, _breakpoints2.default)(containerWidths, gridTheme, function (size) {
	    return size && {
	      width: size,
	      maxWidth: '100%'
	    };
	  });
	});
	
	exports.default = (0, _withSpacing2.default)(Container);

/***/ }),

/***/ "./node_modules/glamorous-grid/lib/Row.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _glamorous = __webpack_require__("./node_modules/glamorous/dist/glamorous.cjs.js");
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _shallowEqual = __webpack_require__("./node_modules/fbjs/lib/shallowEqual.js");
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _getTheme = __webpack_require__("./node_modules/glamorous-grid/lib/getTheme.js");
	
	var _getTheme2 = _interopRequireDefault(_getTheme);
	
	var _breakpoints = __webpack_require__("./node_modules/glamorous-grid/lib/breakpoints.js");
	
	var _breakpoints2 = _interopRequireDefault(_breakpoints);
	
	var _withSpacing = __webpack_require__("./node_modules/glamorous-grid/lib/withSpacing.js");
	
	var _withSpacing2 = _interopRequireDefault(_withSpacing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var justifyMap = {
	  start: 'flex-start',
	  end: 'flex-end',
	  between: 'space-between',
	  around: 'space-around'
	};
	
	var alignMap = {
	  start: 'flex-start',
	  end: 'flex-end',
	  stretch: 'stretch'
	};
	
	var isNil = function isNil(val) {
	  return val === undefined || val === null;
	};
	
	var Row = (0, _glamorous2.default)('div', {
	  shouldClassNameUpdate: function shouldClassNameUpdate(props, nextProps, context, nextContext) {
	    return !(0, _shallowEqual2.default)(context.theme, nextContext.theme) || !(0, _shallowEqual2.default)(props.wrap, nextProps.wrap) || !(0, _shallowEqual2.default)(props.justifyContent, nextProps.justifyContent) || !(0, _shallowEqual2.default)(props.alignItems, nextProps.alignItems) || !(0, _shallowEqual2.default)(props.flexDirection, nextProps.flexDirection) || !(0, _shallowEqual2.default)(props.noGutters, nextProps.noGutters);
	  }
	})({
	  display: 'flex',
	  boxSizing: 'border-box'
	}, function (props) {
	  var gridTheme = (0, _getTheme2.default)(props);
	  var gutters = gridTheme.column_gutter;
	
	  return (0, _breakpoints2.default)(gutters, gridTheme, function (size) {
	    return !isNil(size) && {
	      marginLeft: parseFloat(size) / -2,
	      marginRight: parseFloat(size) / -2
	    };
	  });
	}, function (props) {
	  var gridTheme = (0, _getTheme2.default)(props);
	
	  return (0, _breakpoints2.default)(props.wrap, gridTheme, function () {
	    var wrap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'wrap';
	    return {
	      flexWrap: wrap
	    };
	  });
	}, function (props) {
	  var gridTheme = (0, _getTheme2.default)(props);
	  var justifyContent = props.justifyContent;
	
	  return (0, _breakpoints2.default)(justifyContent, gridTheme, function () {
	    var justify = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'start';
	    return {
	      justifyContent: justifyMap[justify] || justify
	    };
	  });
	}, function (props) {
	  var gridTheme = (0, _getTheme2.default)(props);
	  var alignItems = props.alignItems;
	
	  return (0, _breakpoints2.default)(alignItems, gridTheme, function () {
	    var align = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'stretch';
	    return {
	      alignItems: alignMap[align] || align
	    };
	  });
	}, function (props) {
	  var gridTheme = (0, _getTheme2.default)(props);
	
	  return (0, _breakpoints2.default)(props.direction, gridTheme, function () {
	    var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'row';
	    return {
	      flexDirection: direction
	    };
	  });
	}, function (props) {
	  var gridTheme = (0, _getTheme2.default)(props);
	
	  return (0, _breakpoints2.default)(props.noGutters, gridTheme, function () {
	    var noGutters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    return noGutters && {
	      marginRight: '0 !important',
	      marginLeft: '0 !important',
	      '& > div': {
	        paddingRight: 0,
	        paddingLeft: 0
	      }
	    };
	  });
	});
	
	exports.default = (0, _withSpacing2.default)(Row);

/***/ }),

/***/ "./node_modules/glamorous-grid/lib/breakpoints.js":
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = breakpoints;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * Returns an object of media queries with their respective styles.
	 *
	 * @param value - The prop, either a value, like 20, or an object for breakpoints,
	 *                    such as { sm: 20, md: 50, xl: 80 }
	 * @param theme - The theme object
	 * @param mapFn - Function that will be called with the value (20), or multiple times with
	 *                each individual value. Should return a style object or falsy for no styles.
	 */
	function breakpoints(value, theme, mapFn) {
	  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	    var cssValues = Object.keys(value).reduce(function (acc, key) {
	      return _extends({}, acc, breakpoint(key, mapFn(value[key]), theme));
	    }, {});
	
	    return _extends({}, mapFn(undefined), cssValues);
	  }
	
	  return mapFn(value);
	}
	
	function breakpoint(name, styles, theme) {
	  var breakpointValue = theme.grid_breakpoints[name];
	  var bp = '' + breakpointValue + (typeof breakpointValue === 'number' ? 'px' : '');
	
	  return _defineProperty({}, '@media (min-width: ' + bp + ')', styles);
	}

/***/ }),

/***/ "./node_modules/glamorous-grid/lib/defaultTheme.js":
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  grid_breakpoints: {
	    xs: 0,
	    sm: 576,
	    md: 768,
	    lg: 992,
	    xl: 1200
	  },
	  max_container_width: {
	    sm: 540,
	    md: 720,
	    lg: 960,
	    xl: 1140
	  },
	  column_gutter: {
	    xs: 24,
	    sm: 24,
	    md: 24,
	    lg: 24,
	    xl: 24
	  },
	  outer_gutter: {
	    xs: 24,
	    sm: 24,
	    md: 24,
	    lg: 24,
	    xl: 24
	  }
	};

/***/ }),

/***/ "./node_modules/glamorous-grid/lib/getTheme.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getTheme;
	
	var _defaultTheme = __webpack_require__("./node_modules/glamorous-grid/lib/defaultTheme.js");
	
	var _defaultTheme2 = _interopRequireDefault(_defaultTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getTheme(props) {
	  if (props && props.theme && props.theme.grid) {
	    return props.theme.grid;
	  }
	
	  return _defaultTheme2.default;
	}

/***/ }),

/***/ "./node_modules/glamorous-grid/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Container = __webpack_require__("./node_modules/glamorous-grid/lib/Container.js");
	
	Object.defineProperty(exports, 'Container', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Container).default;
	  }
	});
	
	var _Row = __webpack_require__("./node_modules/glamorous-grid/lib/Row.js");
	
	Object.defineProperty(exports, 'Row', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Row).default;
	  }
	});
	
	var _Col = __webpack_require__("./node_modules/glamorous-grid/lib/Col.js");
	
	Object.defineProperty(exports, 'Col', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Col).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "./node_modules/glamorous-grid/lib/withSpacing.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withSpacing;
	
	var _glamorous = __webpack_require__("./node_modules/glamorous/dist/glamorous.cjs.js");
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _shallowEqual = __webpack_require__("./node_modules/fbjs/lib/shallowEqual.js");
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _breakpoints = __webpack_require__("./node_modules/glamorous-grid/lib/breakpoints.js");
	
	var _breakpoints2 = _interopRequireDefault(_breakpoints);
	
	var _getTheme = __webpack_require__("./node_modules/glamorous-grid/lib/getTheme.js");
	
	var _getTheme2 = _interopRequireDefault(_getTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var spacingProps = {
	  p: ['padding'],
	  m: ['margin'],
	  pt: ['paddingTop'],
	  pr: ['paddingRight'],
	  pb: ['paddingBottom'],
	  pl: ['paddingLeft'],
	  mt: ['marginTop'],
	  mr: ['marginRight'],
	  mb: ['marginBottom'],
	  ml: ['marginLeft'],
	  py: ['paddingTop', 'paddingBottom'],
	  px: ['paddingLeft', 'paddingRight'],
	  my: ['marginTop', 'marginBottom'],
	  mx: ['marginLeft', 'marginRight']
	};
	
	var propKeys = Object.keys(spacingProps);
	var pick = function pick(obj) {
	  return propKeys.reduce(function (acc, key) {
	    return _extends({}, acc, _defineProperty({}, key, obj[key]));
	  }, {});
	};
	
	var withSpacingArgs = propKeys.map(function (prop) {
	  return function (props, theme) {
	    return (0, _breakpoints2.default)(props[prop], theme, function (arg) {
	      return arg && spacingProps[prop].reduce(function (acc, cssProp) {
	        return _extends({}, acc, _defineProperty({}, cssProp, arg));
	      }, {});
	    });
	  };
	});
	
	var getSpacingStyles = function getSpacingStyles(props, theme) {
	  return withSpacingArgs.reduce(function (acc, fn) {
	    return _extends({}, acc, fn(props, theme));
	  }, {}) // noop needed otherwise glamor throws a cache-miss error...
	  ;
	};
	
	function withSpacing(Component) {
	  return (0, _glamorous2.default)(Component, {
	    shouldClassNameUpdate: function shouldClassNameUpdate(props, nextProps) {
	      return !(0, _shallowEqual2.default)(pick(props), pick(nextProps));
	    }
	  })(function (props) {
	    return getSpacingStyles(props, (0, _getTheme2.default)(props));
	  });
	}

/***/ }),

/***/ "./node_modules/glamorous/dist/glamorous.cjs.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__("./node_modules/react/react.js");
	var React__default = _interopDefault(React);
	var glamor = __webpack_require__("./node_modules/glamor/lib/index.js");
	
	var htmlTagNames = [
	  "a",
	  "abbr",
	  "acronym",
	  "address",
	  "applet",
	  "area",
	  "article",
	  "aside",
	  "audio",
	  "b",
	  "base",
	  "basefont",
	  "bdi",
	  "bdo",
	  "bgsound",
	  "big",
	  "blink",
	  "blockquote",
	  "body",
	  "br",
	  "button",
	  "canvas",
	  "caption",
	  "center",
	  "cite",
	  "code",
	  "col",
	  "colgroup",
	  "command",
	  "content",
	  "data",
	  "datalist",
	  "dd",
	  "del",
	  "details",
	  "dfn",
	  "dialog",
	  "dir",
	  "div",
	  "dl",
	  "dt",
	  "element",
	  "em",
	  "embed",
	  "fieldset",
	  "figcaption",
	  "figure",
	  "font",
	  "footer",
	  "form",
	  "frame",
	  "frameset",
	  "h1",
	  "h2",
	  "h3",
	  "h4",
	  "h5",
	  "h6",
	  "head",
	  "header",
	  "hgroup",
	  "hr",
	  "html",
	  "i",
	  "iframe",
	  "image",
	  "img",
	  "input",
	  "ins",
	  "isindex",
	  "kbd",
	  "keygen",
	  "label",
	  "legend",
	  "li",
	  "link",
	  "listing",
	  "main",
	  "map",
	  "mark",
	  "marquee",
	  "math",
	  "menu",
	  "menuitem",
	  "meta",
	  "meter",
	  "multicol",
	  "nav",
	  "nextid",
	  "nobr",
	  "noembed",
	  "noframes",
	  "noscript",
	  "object",
	  "ol",
	  "optgroup",
	  "option",
	  "output",
	  "p",
	  "param",
	  "picture",
	  "plaintext",
	  "pre",
	  "progress",
	  "q",
	  "rb",
	  "rbc",
	  "rp",
	  "rt",
	  "rtc",
	  "ruby",
	  "s",
	  "samp",
	  "script",
	  "section",
	  "select",
	  "shadow",
	  "slot",
	  "small",
	  "source",
	  "spacer",
	  "span",
	  "strike",
	  "strong",
	  "style",
	  "sub",
	  "summary",
	  "sup",
	  "svg",
	  "table",
	  "tbody",
	  "td",
	  "template",
	  "textarea",
	  "tfoot",
	  "th",
	  "thead",
	  "time",
	  "title",
	  "tr",
	  "track",
	  "tt",
	  "u",
	  "ul",
	  "var",
	  "video",
	  "wbr",
	  "xmp"
	]
	;
	
	var svgTagNames = [
	  "a",
	  "altGlyph",
	  "altGlyphDef",
	  "altGlyphItem",
	  "animate",
	  "animateColor",
	  "animateMotion",
	  "animateTransform",
	  "animation",
	  "audio",
	  "canvas",
	  "circle",
	  "clipPath",
	  "color-profile",
	  "cursor",
	  "defs",
	  "desc",
	  "discard",
	  "ellipse",
	  "feBlend",
	  "feColorMatrix",
	  "feComponentTransfer",
	  "feComposite",
	  "feConvolveMatrix",
	  "feDiffuseLighting",
	  "feDisplacementMap",
	  "feDistantLight",
	  "feDropShadow",
	  "feFlood",
	  "feFuncA",
	  "feFuncB",
	  "feFuncG",
	  "feFuncR",
	  "feGaussianBlur",
	  "feImage",
	  "feMerge",
	  "feMergeNode",
	  "feMorphology",
	  "feOffset",
	  "fePointLight",
	  "feSpecularLighting",
	  "feSpotLight",
	  "feTile",
	  "feTurbulence",
	  "filter",
	  "font",
	  "font-face",
	  "font-face-format",
	  "font-face-name",
	  "font-face-src",
	  "font-face-uri",
	  "foreignObject",
	  "g",
	  "glyph",
	  "glyphRef",
	  "handler",
	  "hatch",
	  "hatchpath",
	  "hkern",
	  "iframe",
	  "image",
	  "line",
	  "linearGradient",
	  "listener",
	  "marker",
	  "mask",
	  "mesh",
	  "meshgradient",
	  "meshpatch",
	  "meshrow",
	  "metadata",
	  "missing-glyph",
	  "mpath",
	  "path",
	  "pattern",
	  "polygon",
	  "polyline",
	  "prefetch",
	  "radialGradient",
	  "rect",
	  "script",
	  "set",
	  "solidColor",
	  "solidcolor",
	  "stop",
	  "style",
	  "svg",
	  "switch",
	  "symbol",
	  "tbreak",
	  "text",
	  "textArea",
	  "textPath",
	  "title",
	  "tref",
	  "tspan",
	  "unknown",
	  "use",
	  "video",
	  "view",
	  "vkern"
	]
	;
	
	var domElements = htmlTagNames.concat(svgTagNames).filter(function (tag, index, array) {
	  return array.indexOf(tag) === index;
	});
	
	var CHANNEL = '__glamorous__';
	
	var PropTypes = void 0;
	
	/* istanbul ignore next */
	if (parseFloat(React__default.version.slice(0, 4)) >= 15.5) {
	  /* istanbul ignore next */
	  try {
	    PropTypes = __webpack_require__("./node_modules/prop-types/index.js");
	    /* istanbul ignore next */
	  } catch (error) {
	    // ignore
	  }
	}
	/* istanbul ignore next */
	PropTypes = PropTypes || React__default.PropTypes;
	
	
	
	/*
	eslint
	  import/no-mutable-exports:0,
	  import/prefer-default-export:0,
	  react/no-deprecated:0
	 */
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	
	
	
	
	
	
	
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var toConsumableArray = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	    return arr2;
	  } else {
	    return Array.from(arr);
	  }
	};
	
	function generateWarningMessage(Comp) {
	  var componentName = Comp.displayName || Comp.name || 'FunctionComponent';
	  // eslint-disable-next-line max-len
	  return 'glamorous warning: Expected component called "' + componentName + '" which uses withTheme to be within a ThemeProvider but none was found.';
	}
	
	function withTheme(ComponentToTheme) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$noWarn = _ref.noWarn,
	      noWarn = _ref$noWarn === undefined ? false : _ref$noWarn,
	      _ref$createElement = _ref.createElement,
	      createElement = _ref$createElement === undefined ? true : _ref$createElement;
	
	  var ThemedComponent = function (_Component) {
	    inherits(ThemedComponent, _Component);
	
	    function ThemedComponent() {
	      var _ref2;
	
	      var _temp, _this, _ret;
	
	      classCallCheck(this, ThemedComponent);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref2 = ThemedComponent.__proto__ || Object.getPrototypeOf(ThemedComponent)).call.apply(_ref2, [this].concat(args))), _this), _this.warned = noWarn, _this.state = { theme: {} }, _this.setTheme = function (theme) {
	        return _this.setState({ theme: theme });
	      }, _temp), possibleConstructorReturn(_this, _ret);
	    }
	
	    createClass(ThemedComponent, [{
	      key: 'componentWillMount',
	
	
	      // eslint-disable-next-line complexity
	      value: function componentWillMount() {
	        if (!this.context[CHANNEL]) {
	          if (false) {
	            this.warned = true;
	            // eslint-disable-next-line no-console
	            console.warn(generateWarningMessage(ComponentToTheme));
	          }
	        }
	        var theme = this.props.theme;
	
	        if (this.context[CHANNEL]) {
	          // if a theme is provided via props,
	          // it takes precedence over context
	          this.setTheme(theme ? theme : this.context[CHANNEL].getState());
	        } else {
	          this.setTheme(theme || {});
	        }
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (this.props.theme !== nextProps.theme) {
	          this.setTheme(nextProps.theme);
	        }
	      }
	    }, {
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        if (this.context[CHANNEL] && !this.props.theme) {
	          // subscribe to future theme changes
	          this.subscriptionId = this.context[CHANNEL].subscribe(this.setTheme);
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        // cleanup subscription
	        this.subscriptionId && this.context[CHANNEL].unsubscribe(this.subscriptionId);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        if (createElement) {
	          return React__default.createElement(ComponentToTheme, _extends({}, this.props, this.state));
	        } else {
	          // this allows us to effectively use the GlamorousComponent
	          // as our `render` method without going through lifecycle hooks.
	          // Also allows us to forward the context in the scenario where
	          // a user wants to add more context.
	          // eslint-disable-next-line babel/new-cap
	          return ComponentToTheme.call(this, _extends({}, this.props, this.state), this.context);
	        }
	      }
	    }]);
	    return ThemedComponent;
	  }(React.Component);
	
	  ThemedComponent.propTypes = {
	    theme: PropTypes.object
	  };
	
	
	  var defaultContextTypes = defineProperty({}, CHANNEL, PropTypes.object);
	
	  var userDefinedContextTypes = null;
	
	  // configure the contextTypes to be settable by the user,
	  // however also retaining the glamorous channel.
	  Object.defineProperty(ThemedComponent, 'contextTypes', {
	    enumerable: true,
	    configurable: true,
	    set: function set$$1(value) {
	      userDefinedContextTypes = value;
	    },
	    get: function get$$1() {
	      // if the user has provided a contextTypes definition,
	      // merge the default context types with the provided ones.
	      if (userDefinedContextTypes) {
	        return _extends({}, defaultContextTypes, userDefinedContextTypes);
	      }
	      return defaultContextTypes;
	    }
	  });
	
	  return ThemedComponent;
	}
	
	var index$1 = isFunction;
	
	var toString = Object.prototype.toString;
	
	function isFunction (fn) {
	  var string = toString.call(fn);
	  return string === '[object Function]' ||
	    (typeof fn === 'function' && string !== '[object RegExp]') ||
	    (typeof window !== 'undefined' &&
	     // IE8 and below
	     (fn === window.setTimeout ||
	      fn === window.alert ||
	      fn === window.confirm ||
	      fn === window.prompt))
	}
	
	/*!
	 * isobject <https://github.com/jonschlinkert/isobject>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */
	
	var index$3 = function isObject(val) {
	  return val != null && typeof val === 'object' && Array.isArray(val) === false;
	};
	
	function isObjectObject(o) {
	  return index$3(o) === true
	    && Object.prototype.toString.call(o) === '[object Object]';
	}
	
	var index$2 = function isPlainObject(o) {
	  var ctor,prot;
	
	  if (isObjectObject(o) === false) return false;
	
	  // If has modified constructor
	  ctor = o.constructor;
	  if (typeof ctor !== 'function') return false;
	
	  // If has modified prototype
	  prot = ctor.prototype;
	  if (isObjectObject(prot) === false) return false;
	
	  // If constructor does not have an Object-specific method
	  if (prot.hasOwnProperty('isPrototypeOf') === false) {
	    return false;
	  }
	
	  // Most likely a plain Object
	  return true;
	};
	
	function createBroadcast (initialState) {
	  var listeners = {};
	  var id = 1;
	  var _state = initialState;
	
	  function getState () {
	    return _state
	  }
	
	  function setState (state) {
	    _state = state;
	    var keys = Object.keys(listeners);
	    var i = 0;
	    var len = keys.length;
	    for (; i < len; i++) {
	      // if a listener gets unsubscribed during setState we just skip it
	      if (listeners[keys[i]]) { listeners[keys[i]](state); }
	    }
	  }
	
	  // subscribe to changes and return the subscriptionId
	  function subscribe (listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('listener must be a function.')
	    }
	    var currentId = id;
	    listeners[currentId] = listener;
	    id += 1;
	    return currentId
	  }
	
	  // remove subscription by removing the listener function
	  function unsubscribe (id) {
	    listeners[id] = undefined;
	  }
	
	  return { getState: getState, setState: setState, subscribe: subscribe, unsubscribe: unsubscribe }
	}
	
	/**
	 * This is a component which will provide a theme to the entire tree
	 * via context and event listener
	 * (because pure components block context updates)
	 * inspired by the styled-components implementation
	 * https://github.com/styled-components/styled-components
	 * @param {Object} theme the theme object..
	 */
	
	var ThemeProvider = function (_Component) {
	  inherits(ThemeProvider, _Component);
	
	  function ThemeProvider() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    classCallCheck(this, ThemeProvider);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ThemeProvider.__proto__ || Object.getPrototypeOf(ThemeProvider)).call.apply(_ref, [this].concat(args))), _this), _this.broadcast = createBroadcast(_this.props.theme), _this.setOuterTheme = function (theme) {
	      _this.outerTheme = theme;
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  createClass(ThemeProvider, [{
	    key: 'getTheme',
	
	
	    // create theme, by merging with outer theme, if present
	    value: function getTheme(passedTheme) {
	      var theme = passedTheme || this.props.theme;
	      if (index$1(theme)) {
	        var mergedTheme = theme(this.outerTheme);
	        if (!index$2(mergedTheme)) {
	          throw new Error('[ThemeProvider] Please return an object from your theme function, ' + 'i.e. theme={() => ({})}!');
	        }
	        return mergedTheme;
	      }
	      return _extends({}, this.outerTheme, theme);
	    }
	  }, {
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return defineProperty({}, CHANNEL, this.broadcast);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // create a new subscription for keeping track of outer theme, if present
	      if (this.context[CHANNEL]) {
	        this.subscriptionId = this.context[CHANNEL].subscribe(this.setOuterTheme);
	      }
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      // set broadcast state by merging outer theme with own
	      if (this.context[CHANNEL]) {
	        this.setOuterTheme(this.context[CHANNEL].getState());
	        this.broadcast.setState(this.getTheme());
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.theme !== nextProps.theme) {
	        this.broadcast.setState(this.getTheme(nextProps.theme));
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.subscriptionId && this.context[CHANNEL].unsubscribe(this.subscriptionId);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children ? React__default.Children.only(this.props.children) : null;
	    }
	  }]);
	  return ThemeProvider;
	}(React.Component);
	
	ThemeProvider.childContextTypes = defineProperty({}, CHANNEL, PropTypes.object.isRequired);
	
	ThemeProvider.contextTypes = defineProperty({}, CHANNEL, PropTypes.object);
	
	ThemeProvider.propTypes = {
	  theme: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
	  children: PropTypes.node
	};
	
	/**
	 * This function takes a className string and gets all the
	 * associated glamor styles. It's used to merge glamor styles
	 * from a className to make sure that specificity is not
	 * a problem when passing a className to a component.
	 * @param {String} [className=''] the className string
	 * @return {Object} { glamorStyles, glamorlessClassName }
	 *   - glamorStyles is an array of all the glamor styles objects
	 *   - glamorlessClassName is the rest of the className string
	 *     without the glamor classNames
	 */
	function extractGlamorStyles(className) {
	  var glamorlessClassName = [];
	  var glamorStyles = [];
	  className.toString().split(' ').forEach(function (name) {
	    if (name.indexOf('css-') === 0) {
	      var style = buildGlamorSrcFromClassName(name);
	      glamorStyles.push(style);
	    } else {
	      glamorlessClassName.push(name);
	    }
	  });
	
	  return { glamorlessClassName: glamorlessClassName, glamorStyles: glamorStyles };
	}
	
	/** Glamor's css function returns an object with the shape
	 *
	 * {
	 *   [`data-css-${hash}`]: '',
	 *   toString() { return `css-${hash}` }
	 * }
	 *
	 * Whenever glamor's build function encounters an object with
	 * this shape it just pulls the resulting styles from the cache.
	 *
	 * note: the toString method is not needed to qualify the shape
	**/
	function buildGlamorSrcFromClassName(className) {
	  return defineProperty({}, 'data-' + className, '');
	}
	
	function getGlamorClassName$1(_ref2) {
	  var styles = _ref2.styles,
	      props = _ref2.props,
	      cssOverrides = _ref2.cssOverrides,
	      cssProp = _ref2.cssProp,
	      context = _ref2.context,
	      displayName = _ref2.displayName;
	
	  var _handleStyles = handleStyles([].concat(toConsumableArray(styles), [props.className, cssOverrides, cssProp]), props, context),
	      mappedArgs = _handleStyles.mappedArgs,
	      nonGlamorClassNames = _handleStyles.nonGlamorClassNames;
	  // eslint-disable-next-line max-len
	
	
	  var isDev = ("production") === 'development' || !("production");
	  var devRules = isDev ? { label: displayName } : null;
	  var glamorClassName = glamor.css.apply(undefined, [devRules].concat(toConsumableArray(mappedArgs))).toString();
	  var extras = nonGlamorClassNames.join(' ').trim();
	  return (glamorClassName + ' ' + extras).trim();
	}
	
	// this next function is on a "hot" code-path
	// so it's pretty complex to make sure it's fast.
	// eslint-disable-next-line complexity
	function handleStyles(styles, props, context) {
	  var current = void 0;
	  var mappedArgs = [];
	  var nonGlamorClassNames = [];
	  for (var i = 0; i < styles.length; i++) {
	    current = styles[i];
	    if (typeof current === 'function') {
	      var result = current(props, context);
	      if (typeof result === 'string') {
	        var _extractGlamorStyles = extractGlamorStyles(result),
	            glamorStyles = _extractGlamorStyles.glamorStyles,
	            glamorlessClassName = _extractGlamorStyles.glamorlessClassName;
	
	        mappedArgs.push.apply(mappedArgs, toConsumableArray(glamorStyles));
	        nonGlamorClassNames.push.apply(nonGlamorClassNames, toConsumableArray(glamorlessClassName));
	      } else {
	        mappedArgs.push(result);
	      }
	    } else if (typeof current === 'string') {
	      var _extractGlamorStyles2 = extractGlamorStyles(current),
	          _glamorStyles = _extractGlamorStyles2.glamorStyles,
	          _glamorlessClassName = _extractGlamorStyles2.glamorlessClassName;
	
	      mappedArgs.push.apply(mappedArgs, toConsumableArray(_glamorStyles));
	      nonGlamorClassNames.push.apply(nonGlamorClassNames, toConsumableArray(_glamorlessClassName));
	    } else if (Array.isArray(current)) {
	      var recursed = handleStyles(current, props, context);
	      mappedArgs.push.apply(mappedArgs, toConsumableArray(recursed.mappedArgs));
	      nonGlamorClassNames.push.apply(nonGlamorClassNames, toConsumableArray(recursed.nonGlamorClassNames));
	    } else {
	      mappedArgs.push(current);
	    }
	  }
	  return { mappedArgs: mappedArgs, nonGlamorClassNames: nonGlamorClassNames };
	}
	
	/*
	 * This is a relatively small abstraction that's ripe for open sourcing.
	 * Documentation is in the README.md
	 */
	function createGlamorous$1(splitProps) {
	  return glamorous;
	
	  /**
	  * This is the main export and the function that people
	  * interact with most directly.
	  *
	  * It accepts a component which can be a string or
	  * a React Component and returns
	  * a "glamorousComponentFactory"
	  * @param {String|ReactComponent} comp the component to render
	  * @param {Object} options helpful info for the GlamorousComponents
	  * @return {Function} the glamorousComponentFactory
	  */
	  function glamorous(comp) {
	    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var rootEl = config.rootEl,
	        displayName = config.displayName,
	        shouldClassNameUpdate = config.shouldClassNameUpdate,
	        _config$forwardProps = config.forwardProps,
	        forwardProps = _config$forwardProps === undefined ? [] : _config$forwardProps,
	        _config$propsAreCssOv = config.propsAreCssOverrides,
	        propsAreCssOverrides = _config$propsAreCssOv === undefined ? comp.propsAreCssOverrides : _config$propsAreCssOv,
	        basePropsToApply = config.withProps;
	
	    Object.assign(glamorousComponentFactory, { withConfig: withConfig });
	    return glamorousComponentFactory;
	
	    function withConfig(newConfig) {
	      return glamorous(comp, _extends({}, config, newConfig));
	    }
	
	    /**
	     * This returns a React Component that renders the comp (closure)
	     * with a className based on the given glamor styles object(s)
	     * @param {...Object|Function} styles the styles to create with glamor.
	     *   If any of these are functions, they are invoked with the component
	     *   props and the return value is used.
	     * @return {ReactComponent} the ReactComponent function
	     */
	    function glamorousComponentFactory() {
	      for (var _len = arguments.length, styles = Array(_len), _key = 0; _key < _len; _key++) {
	        styles[_key] = arguments[_key];
	      }
	
	      /**
	       * This is a component which will render the comp (closure)
	       * with the glamorous styles (closure). Forwards any valid
	       * props to the underlying component.
	       */
	      var GlamorousComponent = withTheme(function GlamorousInnerComponent(props, context) {
	        props = getPropsToApply(GlamorousComponent.propsToApply, {}, props, context);
	        var updateClassName = shouldUpdate(props, context, this.previous);
	
	        if (shouldClassNameUpdate) {
	          this.previous = { props: props, context: context };
	        }
	
	        var _splitProps = splitProps(props, GlamorousComponent),
	            toForward = _splitProps.toForward,
	            cssOverrides = _splitProps.cssOverrides,
	            cssProp = _splitProps.cssProp;
	
	        // create className to apply
	
	
	        this.className = updateClassName ? getGlamorClassName$1({
	          styles: GlamorousComponent.styles,
	          props: props,
	          cssOverrides: cssOverrides,
	          cssProp: cssProp,
	          context: context,
	          displayName: GlamorousComponent.displayName
	        }) : this.className;
	
	        return React__default.createElement(GlamorousComponent.comp, _extends({
	          ref: props.innerRef
	        }, toForward, {
	          className: this.className
	        }));
	      }, { noWarn: true, createElement: false });
	
	      GlamorousComponent.propTypes = {
	        className: PropTypes.string,
	        cssOverrides: PropTypes.object,
	        innerRef: PropTypes.func,
	        glam: PropTypes.object
	      };
	
	      function withComponent(newComp) {
	        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        var fp = GlamorousComponent.forwardProps,
	            componentProperties = objectWithoutProperties(GlamorousComponent, ['forwardProps']);
	
	        return glamorous(_extends({}, componentProperties, {
	          comp: newComp
	        }), _extends({
	          // allows the forwardProps to be overridden
	          forwardProps: fp
	        }, options))();
	      }
	
	      function withProps() {
	        for (var _len2 = arguments.length, propsToApply = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	          propsToApply[_key2] = arguments[_key2];
	        }
	
	        return glamorous(GlamorousComponent, { withProps: propsToApply })();
	      }
	
	      function shouldUpdate(props, context, previous) {
	        // exiting early so components which do not use this
	        // optimization are not penalized by hanging onto
	        // references to previous props and context
	        if (!shouldClassNameUpdate) {
	          return true;
	        }
	        var update = true;
	        if (previous) {
	          if (!shouldClassNameUpdate(previous.props, props, previous.context, context)) {
	            update = false;
	          }
	        }
	
	        return update;
	      }
	
	      Object.assign(GlamorousComponent, getGlamorousComponentMetadata({
	        comp: comp,
	        styles: styles,
	        rootEl: rootEl,
	        forwardProps: forwardProps,
	        displayName: displayName,
	        propsToApply: basePropsToApply
	      }), {
	        isGlamorousComponent: true,
	        propsAreCssOverrides: propsAreCssOverrides,
	        withComponent: withComponent,
	        withProps: withProps,
	        withConfig: withConfig
	      });
	      return GlamorousComponent;
	    }
	  }
	
	  function getGlamorousComponentMetadata(_ref) {
	    var comp = _ref.comp,
	        styles = _ref.styles,
	        rootEl = _ref.rootEl,
	        forwardProps = _ref.forwardProps,
	        displayName = _ref.displayName,
	        basePropsToApply = _ref.propsToApply;
	
	    var componentsComp = comp.comp ? comp.comp : comp;
	    var propsToApply = comp.propsToApply ? [].concat(toConsumableArray(comp.propsToApply), toConsumableArray(arrayify(basePropsToApply))) : arrayify(basePropsToApply);
	    return {
	      // join styles together (for anyone doing: glamorous(glamorous.a({}), {}))
	      styles: when(comp.styles, styles),
	      // keep track of the ultimate rootEl to render (we never
	      // actually render anything but
	      // the base component, even when people wrap a glamorous
	      // component in glamorous
	      comp: componentsComp,
	      rootEl: rootEl || componentsComp,
	      // join forwardProps (for anyone doing: glamorous(glamorous.a({}), {}))
	      forwardProps: when(comp.forwardProps, forwardProps),
	      // set the displayName to something that's slightly more
	      // helpful than `GlamorousComponent` :)
	      displayName: displayName || 'glamorous(' + getDisplayName(comp) + ')',
	      // these are props that should be applied to the component at render time
	      propsToApply: propsToApply
	    };
	  }
	}
	
	/**
	 * reduces the propsToApply given to a single props object
	 * @param {Array} propsToApply an array of propsToApply objects:
	 *   - object
	 *   - array of propsToApply items
	 *   - function that accepts the accumulated props and the context
	 * @param {Object} accumulator an object to apply props onto
	 * @param {Object} props the props that should ultimately take precedence
	 * @param {*} context the context object
	 * @return {Object} the reduced props
	 */
	function getPropsToApply(propsToApply, accumulator, props, context) {
	  // using forEach rather than reduce here because the reduce solution
	  // effectively did the same thing because we manipulate the `accumulator`
	  propsToApply.forEach(function (propsToApplyItem) {
	    if (typeof propsToApplyItem === 'function') {
	      return Object.assign(accumulator, propsToApplyItem(Object.assign({}, accumulator, props), context));
	    } else if (Array.isArray(propsToApplyItem)) {
	      return Object.assign(accumulator, getPropsToApply(propsToApplyItem, accumulator, props, context));
	    }
	    return Object.assign(accumulator, propsToApplyItem);
	  });
	  // props wins
	  return Object.assign(accumulator, props);
	}
	
	function arrayify() {
	  var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  return Array.isArray(x) ? x : [x];
	}
	
	function when(comp, prop) {
	  return comp ? comp.concat(prop) : prop;
	}
	
	function getDisplayName(comp) {
	  return typeof comp === 'string' ? comp : comp.displayName || comp.name || 'unknown';
	}
	
	//
	// Main
	//
	
	function memoize (fn, options) {
	  var cache = options && options.cache
	    ? options.cache
	    : cacheDefault;
	
	  var serializer = options && options.serializer
	    ? options.serializer
	    : serializerDefault;
	
	  var strategy = options && options.strategy
	    ? options.strategy
	    : strategyDefault;
	
	  return strategy(fn, {
	    cache: cache,
	    serializer: serializer
	  })
	}
	
	//
	// Strategy
	//
	
	function isPrimitive (value) {
	  return value == null || (typeof value !== 'function' && typeof value !== 'object')
	}
	
	function monadic (fn, cache, serializer, arg) {
	  var cacheKey = isPrimitive(arg) ? arg : serializer(arg);
	
	  if (!cache.has(cacheKey)) {
	    var computedValue = fn.call(this, arg);
	    cache.set(cacheKey, computedValue);
	    return computedValue
	  }
	
	  return cache.get(cacheKey)
	}
	
	function variadic (fn, cache, serializer) {
	  var args = Array.prototype.slice.call(arguments, 3);
	  var cacheKey = serializer(args);
	
	  if (!cache.has(cacheKey)) {
	    var computedValue = fn.apply(this, args);
	    cache.set(cacheKey, computedValue);
	    return computedValue
	  }
	
	  return cache.get(cacheKey)
	}
	
	function assemble (fn, context, strategy, cache, serialize) {
	  return strategy.bind(
	    context,
	    fn,
	    cache,
	    serialize
	  )
	}
	
	function strategyDefault (fn, options) {
	  var strategy = fn.length === 1 ? monadic : variadic;
	
	  return assemble(
	    fn,
	    this,
	    strategy,
	    options.cache.create(),
	    options.serializer
	  )
	}
	
	function strategyVariadic (fn, options) {
	  var strategy = variadic;
	
	  return assemble(
	    fn,
	    this,
	    strategy,
	    options.cache.create(),
	    options.serializer
	  )
	}
	
	function strategyMonadic (fn, options) {
	  var strategy = monadic;
	
	  return assemble(
	    fn,
	    this,
	    strategy,
	    options.cache.create(),
	    options.serializer
	  )
	}
	
	//
	// Serializer
	//
	
	function serializerDefault () {
	  return JSON.stringify(arguments)
	}
	
	//
	// Cache
	//
	
	function ObjectWithoutPrototypeCache () {
	  this.cache = Object.create(null);
	}
	
	ObjectWithoutPrototypeCache.prototype.has = function (key) {
	  return (key in this.cache)
	};
	
	ObjectWithoutPrototypeCache.prototype.get = function (key) {
	  return this.cache[key]
	};
	
	ObjectWithoutPrototypeCache.prototype.set = function (key, value) {
	  this.cache[key] = value;
	};
	
	var cacheDefault = {
	  create: function create () {
	    return new ObjectWithoutPrototypeCache()
	  }
	};
	
	//
	// API
	//
	
	var index$5 = memoize;
	var strategies = {
	  variadic: strategyVariadic,
	  monadic: strategyMonadic
	};
	
	index$5.strategies = strategies;
	
	function unwrapExports (x) {
		return x && x.__esModule ? x['default'] : x;
	}
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	var a = ["coords","download","href","name","rel","shape","target","type"];
	var abbr = ["title"];
	var applet = ["alt","height","name","width"];
	var area = ["alt","coords","download","href","rel","shape","target","type"];
	var audio = ["controls","loop","muted","preload","src"];
	var base = ["href","target"];
	var basefont = ["size"];
	var bdo = ["dir"];
	var blockquote = ["cite"];
	var button = ["disabled","form","name","type","value"];
	var canvas = ["height","width"];
	var col = ["span","width"];
	var colgroup = ["span","width"];
	var data = ["value"];
	var del = ["cite"];
	var details = ["open"];
	var dfn = ["title"];
	var dialog = ["open"];
	var embed = ["height","src","type","width"];
	var fieldset = ["disabled","form","name"];
	var font = ["size"];
	var form = ["accept","action","method","name","target"];
	var frame = ["name","scrolling","src"];
	var frameset = ["cols","rows"];
	var head = ["profile"];
	var hr = ["size","width"];
	var html = ["manifest"];
	var iframe = ["height","name","sandbox","scrolling","src","width"];
	var img = ["alt","height","name","sizes","src","width"];
	var input = ["accept","alt","autoCapitalize","autoCorrect","autoSave","checked","defaultChecked","defaultValue","disabled","form","height","list","max","min","multiple","name","onChange","pattern","placeholder","required","results","size","src","step","title","type","value","width"];
	var ins = ["cite"];
	var keygen = ["challenge","disabled","form","name"];
	var label = ["form"];
	var li = ["type","value"];
	var link = ["color","href","integrity","media","nonce","rel","scope","sizes","target","title","type"];
	var map = ["name"];
	var meta = ["content","name"];
	var meter = ["high","low","max","min","optimum","value"];
	var object = ["data","form","height","name","type","width"];
	var ol = ["reversed","start","type"];
	var optgroup = ["disabled","label"];
	var option = ["disabled","label","selected","value"];
	var output = ["form","name"];
	var param = ["name","type","value"];
	var pre = ["width"];
	var progress = ["max","value"];
	var q = ["cite"];
	var script = ["async","defer","integrity","nonce","src","type"];
	var select = ["defaultValue","disabled","form","multiple","name","onChange","required","size","value"];
	var slot = ["name"];
	var source = ["media","sizes","src","type"];
	var style = ["media","nonce","title","type"];
	var table = ["summary","width"];
	var td = ["headers","height","scope","width"];
	var textarea = ["autoCapitalize","autoCorrect","cols","defaultValue","disabled","form","name","onChange","placeholder","required","rows","value","wrap"];
	var th = ["headers","height","scope","width"];
	var track = ["default","kind","label","src"];
	var ul = ["type"];
	var video = ["controls","height","loop","muted","poster","preload","src","width"];
	var svg = ["accentHeight","accumulate","additive","alignmentBaseline","allowReorder","alphabetic","amplitude","arabicForm","ascent","attributeName","attributeType","autoReverse","azimuth","baseFrequency","baseProfile","baselineShift","bbox","begin","bias","by","calcMode","capHeight","clip","clipPath","clipPathUnits","clipRule","color","colorInterpolation","colorInterpolationFilters","colorProfile","colorRendering","contentScriptType","contentStyleType","cursor","cx","cy","d","decelerate","descent","diffuseConstant","direction","display","divisor","dominantBaseline","dur","dx","dy","edgeMode","elevation","enableBackground","end","exponent","externalResourcesRequired","fill","fillOpacity","fillRule","filter","filterRes","filterUnits","floodColor","floodOpacity","focusable","fontFamily","fontSize","fontSizeAdjust","fontStretch","fontStyle","fontVariant","fontWeight","format","from","fx","fy","g1","g2","glyphName","glyphOrientationHorizontal","glyphOrientationVertical","glyphRef","gradientTransform","gradientUnits","hanging","height","horizAdvX","horizOriginX","ideographic","imageRendering","in","in2","intercept","k","k1","k2","k3","k4","kernelMatrix","kernelUnitLength","kerning","keyPoints","keySplines","keyTimes","lengthAdjust","letterSpacing","lightingColor","limitingConeAngle","local","markerEnd","markerHeight","markerMid","markerStart","markerUnits","markerWidth","mask","maskContentUnits","maskUnits","mathematical","mode","numOctaves","offset","opacity","operator","order","orient","orientation","origin","overflow","overlinePosition","overlineThickness","paintOrder","panose1","pathLength","patternContentUnits","patternTransform","patternUnits","pointerEvents","points","pointsAtX","pointsAtY","pointsAtZ","preserveAlpha","preserveAspectRatio","primitiveUnits","r","radius","refX","refY","renderingIntent","repeatCount","repeatDur","requiredExtensions","requiredFeatures","restart","result","rotate","rx","ry","scale","seed","shapeRendering","slope","spacing","specularConstant","specularExponent","speed","spreadMethod","startOffset","stdDeviation","stemh","stemv","stitchTiles","stopColor","stopOpacity","strikethroughPosition","strikethroughThickness","string","stroke","strokeDasharray","strokeDashoffset","strokeLinecap","strokeLinejoin","strokeMiterlimit","strokeOpacity","strokeWidth","surfaceScale","systemLanguage","tableValues","targetX","targetY","textAnchor","textDecoration","textLength","textRendering","to","transform","u1","u2","underlinePosition","underlineThickness","unicode","unicodeBidi","unicodeRange","unitsPerEm","vAlphabetic","vHanging","vIdeographic","vMathematical","values","vectorEffect","version","vertAdvY","vertOriginX","vertOriginY","viewBox","viewTarget","visibility","width","widths","wordSpacing","writingMode","x","x1","x2","xChannelSelector","xHeight","xlinkActuate","xlinkArcrole","xlinkHref","xlinkRole","xlinkShow","xlinkTitle","xlinkType","xmlBase","xmlLang","xmlSpace","xmlns","xmlnsXlink","y","y1","y2","yChannelSelector","z","zoomAndPan"];
	var elements = {"html":["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","math","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rb","rp","rt","rtc","ruby","s","samp","script","section","select","slot","small","source","span","strong","style","sub","summary","sup","svg","table","tbody","td","template","textarea","tfoot","th","thead","time","title","tr","track","u","ul","var","video","wbr"],"svg":["a","altGlyph","altGlyphDef","altGlyphItem","animate","animateColor","animateMotion","animateTransform","circle","clipPath","color-profile","cursor","defs","desc","ellipse","feBlend","feColorMatrix","feComponentTransfer","feComposite","feConvolveMatrix","feDiffuseLighting","feDisplacementMap","feDistantLight","feFlood","feFuncA","feFuncB","feFuncG","feFuncR","feGaussianBlur","feImage","feMerge","feMergeNode","feMorphology","feOffset","fePointLight","feSpecularLighting","feSpotLight","feTile","feTurbulence","filter","font","font-face","font-face-format","font-face-name","font-face-src","font-face-uri","foreignObject","g","glyph","glyphRef","hkern","image","line","linearGradient","marker","mask","metadata","missing-glyph","mpath","path","pattern","polygon","polyline","radialGradient","rect","script","set","stop","style","svg","switch","symbol","text","textPath","title","tref","tspan","use","view","vkern"]};
	var reactHtmlAttributes = {
		a: a,
		abbr: abbr,
		applet: applet,
		area: area,
		audio: audio,
		base: base,
		basefont: basefont,
		bdo: bdo,
		blockquote: blockquote,
		button: button,
		canvas: canvas,
		col: col,
		colgroup: colgroup,
		data: data,
		del: del,
		details: details,
		dfn: dfn,
		dialog: dialog,
		embed: embed,
		fieldset: fieldset,
		font: font,
		form: form,
		frame: frame,
		frameset: frameset,
		head: head,
		hr: hr,
		html: html,
		iframe: iframe,
		img: img,
		input: input,
		ins: ins,
		keygen: keygen,
		label: label,
		li: li,
		link: link,
		map: map,
		meta: meta,
		meter: meter,
		object: object,
		ol: ol,
		optgroup: optgroup,
		option: option,
		output: output,
		param: param,
		pre: pre,
		progress: progress,
		q: q,
		script: script,
		select: select,
		slot: slot,
		source: source,
		style: style,
		table: table,
		td: td,
		textarea: textarea,
		th: th,
		track: track,
		ul: ul,
		video: video,
		svg: svg,
		elements: elements,
		"*": ["about","acceptCharset","accessKey","allowFullScreen","allowTransparency","autoComplete","autoFocus","autoPlay","capture","cellPadding","cellSpacing","charSet","classID","className","colSpan","contentEditable","contextMenu","crossOrigin","dangerouslySetInnerHTML","datatype","dateTime","dir","draggable","encType","formAction","formEncType","formMethod","formNoValidate","formTarget","frameBorder","hidden","hrefLang","htmlFor","httpEquiv","icon","id","inlist","inputMode","is","itemID","itemProp","itemRef","itemScope","itemType","keyParams","keyType","lang","marginHeight","marginWidth","maxLength","mediaGroup","minLength","noValidate","prefix","property","radioGroup","readOnly","resource","role","rowSpan","scoped","seamless","security","spellCheck","srcDoc","srcLang","srcSet","style","suppressContentEditableWarning","tabIndex","title","typeof","unselectable","useMap","vocab","wmode"]
	};
	
	var reactHtmlAttributes$1 = Object.freeze({
		a: a,
		abbr: abbr,
		applet: applet,
		area: area,
		audio: audio,
		base: base,
		basefont: basefont,
		bdo: bdo,
		blockquote: blockquote,
		button: button,
		canvas: canvas,
		col: col,
		colgroup: colgroup,
		data: data,
		del: del,
		details: details,
		dfn: dfn,
		dialog: dialog,
		embed: embed,
		fieldset: fieldset,
		font: font,
		form: form,
		frame: frame,
		frameset: frameset,
		head: head,
		hr: hr,
		html: html,
		iframe: iframe,
		img: img,
		input: input,
		ins: ins,
		keygen: keygen,
		label: label,
		li: li,
		link: link,
		map: map,
		meta: meta,
		meter: meter,
		object: object,
		ol: ol,
		optgroup: optgroup,
		option: option,
		output: output,
		param: param,
		pre: pre,
		progress: progress,
		q: q,
		script: script,
		select: select,
		slot: slot,
		source: source,
		style: style,
		table: table,
		td: td,
		textarea: textarea,
		th: th,
		track: track,
		ul: ul,
		video: video,
		svg: svg,
		elements: elements,
		default: reactHtmlAttributes
	});
	
	var reactHtmlAttributes$2 = ( reactHtmlAttributes$1 && reactHtmlAttributes ) || reactHtmlAttributes$1;
	
	var index$6 = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	exports.default = reactHtmlAttributes$2;
	
	module.exports = reactHtmlAttributes$2; // for CommonJS compatibility
	});
	
	var reactHTMLAttributes = unwrapExports(index$6);
	
	/*
	 * This is used to check if a property name is one of the React-specific
	 * properties and determine if that property should be forwarded
	 * to the React component
	 */
	
	/* Logic copied from ReactDOMUnknownPropertyHook */
	var reactProps = ['children', 'dangerouslySetInnerHTML', 'key', 'ref', 'autoFocus', 'defaultValue', 'valueLink', 'defaultChecked', 'checkedLink', 'innerHTML', 'suppressContentEditableWarning', 'onFocusIn', 'onFocusOut', 'className',
	
	/* List copied from https://facebook.github.io/react/docs/events.html */
	'onCopy', 'onCut', 'onPaste', 'onCompositionEnd', 'onCompositionStart', 'onCompositionUpdate', 'onKeyDown', 'onKeyPress', 'onKeyUp', 'onFocus', 'onBlur', 'onChange', 'onInput', 'onSubmit', 'onClick', 'onContextMenu', 'onDoubleClick', 'onDrag', 'onDragEnd', 'onDragEnter', 'onDragExit', 'onDragLeave', 'onDragOver', 'onDragStart', 'onDrop', 'onMouseDown', 'onMouseEnter', 'onMouseLeave', 'onMouseMove', 'onMouseOut', 'onMouseOver', 'onMouseUp', 'onSelect', 'onTouchCancel', 'onTouchEnd', 'onTouchMove', 'onTouchStart', 'onScroll', 'onWheel', 'onAbort', 'onCanPlay', 'onCanPlayThrough', 'onDurationChange', 'onEmptied', 'onEncrypted', 'onEnded', 'onError', 'onLoadedData', 'onLoadedMetadata', 'onLoadStart', 'onPause', 'onPlay', 'onPlaying', 'onProgress', 'onRateChange', 'onSeeked', 'onSeeking', 'onStalled', 'onSuspend', 'onTimeUpdate', 'onVolumeChange', 'onWaiting', 'onLoad', 'onAnimationStart', 'onAnimationEnd', 'onAnimationIteration', 'onTransitionEnd', 'onCopyCapture', 'onCutCapture', 'onPasteCapture', 'onCompositionEndCapture', 'onCompositionStartCapture', 'onCompositionUpdateCapture', 'onKeyDownCapture', 'onKeyPressCapture', 'onKeyUpCapture', 'onFocusCapture', 'onBlurCapture', 'onChangeCapture', 'onInputCapture', 'onSubmitCapture', 'onClickCapture', 'onContextMenuCapture', 'onDoubleClickCapture', 'onDragCapture', 'onDragEndCapture', 'onDragEnterCapture', 'onDragExitCapture', 'onDragLeaveCapture', 'onDragOverCapture', 'onDragStartCapture', 'onDropCapture', 'onMouseDownCapture', 'onMouseEnterCapture', 'onMouseLeaveCapture', 'onMouseMoveCapture', 'onMouseOutCapture', 'onMouseOverCapture', 'onMouseUpCapture', 'onSelectCapture', 'onTouchCancelCapture', 'onTouchEndCapture', 'onTouchMoveCapture', 'onTouchStartCapture', 'onScrollCapture', 'onWheelCapture', 'onAbortCapture', 'onCanPlayCapture', 'onCanPlayThroughCapture', 'onDurationChangeCapture', 'onEmptiedCapture', 'onEncryptedCapture', 'onEndedCapture', 'onErrorCapture', 'onLoadedDataCapture', 'onLoadedMetadataCapture', 'onLoadStartCapture', 'onPauseCapture', 'onPlayCapture', 'onPlayingCapture', 'onProgressCapture', 'onRateChangeCapture', 'onSeekedCapture', 'onSeekingCapture', 'onStalledCapture', 'onSuspendCapture', 'onTimeUpdateCapture', 'onVolumeChangeCapture', 'onWaitingCapture', 'onLoadCapture', 'onAnimationStartCapture', 'onAnimationEndCapture', 'onAnimationIterationCapture', 'onTransitionEndCapture'];
	
	/* eslint max-lines:0, func-style:0 */
	// copied from:
	// https://github.com/styled-components/styled-components/tree/
	// 956e8210b6277860c89404f9cb08735f97eaa7e1/src/utils/validAttr.js
	/* Trying to avoid the unknown-prop errors on glamorous components
	 by filtering by React's attribute whitelist.
	 */
	
	var globalReactHtmlProps = reactHTMLAttributes['*'];
	var supportedSVGTagNames = reactHTMLAttributes.elements.svg;
	var supportedHtmlTagNames = reactHTMLAttributes.elements.html;
	
	// these are valid attributes that have the
	// same name as CSS properties, and is used
	// for css overrides API
	var cssProps = ['color', 'height', 'width'];
	
	/* From DOMProperty */
	var ATTRIBUTE_NAME_START_CHAR =
	// eslint-disable-next-line max-len
	':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	// eslint-disable-next-line max-len
	var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
	var isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));
	
	var isSvgTag = function isSvgTag(tagName) {
	  return (
	    // in our context, we only say that SVG tags are SVG
	    // if they are not also HTML.
	    // See https://github.com/paypal/glamorous/issues/245
	    // the svg tag will always be treated as svg for
	    // er... obvious reasons
	    tagName === 'svg' || supportedHtmlTagNames.indexOf(tagName) === -1 && supportedSVGTagNames.indexOf(tagName) !== -1
	  );
	};
	var isHtmlProp = function isHtmlProp(name, tagName) {
	  var elementAttributes = void 0;
	
	  if (isSvgTag(tagName)) {
	    // all SVG attributes supported by React are grouped under 'svg'
	    elementAttributes = reactHTMLAttributes.svg;
	  } else {
	    elementAttributes = reactHTMLAttributes[tagName] || [];
	  }
	
	  return globalReactHtmlProps.indexOf(name) !== -1 || elementAttributes.indexOf(name) !== -1;
	};
	var isCssProp = function isCssProp(name) {
	  return cssProps.indexOf(name) !== -1;
	};
	var isReactProp = function isReactProp(name) {
	  return reactProps.indexOf(name) !== -1;
	};
	
	// eslint-disable-next-line complexity
	var shouldForwardProperty = function shouldForwardProperty(tagName, name) {
	  return typeof tagName !== 'string' || (isHtmlProp(name, tagName) || isReactProp(name) || isCustomAttribute(name.toLowerCase())) && (!isCssProp(name) || isSvgTag(tagName));
	};
	
	var shouldForwardProperty$1 = index$5(shouldForwardProperty);
	
	function splitProps(_ref, _ref2) {
	  var propsAreCssOverrides = _ref2.propsAreCssOverrides,
	      rootEl = _ref2.rootEl,
	      forwardProps = _ref2.forwardProps;
	  var cssProp = _ref.css,
	      theme = _ref.theme,
	      className = _ref.className,
	      innerRef = _ref.innerRef,
	      glam = _ref.glam,
	      rest = objectWithoutProperties(_ref, ['css', 'theme', 'className', 'innerRef', 'glam']);
	
	  var returnValue = { toForward: {}, cssProp: cssProp, cssOverrides: {} };
	  if (!propsAreCssOverrides) {
	    if (typeof rootEl !== 'string') {
	      // if it's not a string, then we can forward everything
	      // (because it's a component)
	      returnValue.toForward = rest;
	      return returnValue;
	    }
	  }
	  return Object.keys(rest).reduce(function (split, propName) {
	    if (forwardProps.indexOf(propName) !== -1 || shouldForwardProperty$1(rootEl, propName)) {
	      split.toForward[propName] = rest[propName];
	    } else if (propsAreCssOverrides) {
	      split.cssOverrides[propName] = rest[propName];
	    }
	    return split;
	  }, returnValue);
	}
	
	/* eslint no-unused-vars:0 */
	
	var glamorous$2 = createGlamorous$1(splitProps);
	
	/*
	 * This creates a glamorousComponentFactory for every DOM element so you can
	 * simply do:
	 * const GreenButton = glamorous.button({
	 *   backgroundColor: 'green',
	 *   padding: 20,
	 * })
	 * <GreenButton>Click Me!</GreenButton>
	 */
	Object.assign(glamorous$2, domElements.reduce(function (getters, tag) {
	  // TODO: next breaking change, let's make
	  // the `displayName` be: `glamorous.${tag}`
	  getters[tag] = glamorous$2(tag);
	  return getters;
	}, {}));
	
	/*
	 * This creates a glamorous component for each DOM element so you can
	 * simply do:
	 * <glamorous.Div
	 *   color="green"
	 *   marginLeft={20}
	 * >
	 *   I'm green!
	 * </glamorous.Div>
	 */
	Object.assign(glamorous$2, domElements.reduce(function (comps, tag) {
	  var capitalTag = capitalize(tag);
	  comps[capitalTag] = glamorous$2[tag]();
	  comps[capitalTag].displayName = 'glamorous.' + capitalTag;
	  comps[capitalTag].propsAreCssOverrides = true;
	  return comps;
	}, {}));
	
	function capitalize(s) {
	  return s.slice(0, 1).toUpperCase() + s.slice(1);
	}
	
	/*
	 * Fix importing in typescript after rollup compilation
	 * https://github.com/rollup/rollup/issues/1156
	 * https://github.com/Microsoft/TypeScript/issues/13017#issuecomment-268657860
	 */
	glamorous$2.default = glamorous$2;
	
	
	
	var glamorousStar = Object.freeze({
		default: glamorous$2,
		ThemeProvider: ThemeProvider,
		withTheme: withTheme
	});
	
	var glamorous = glamorous$2;
	
	Object.assign(glamorous, Object.keys(glamorousStar).reduce(function (e, prop) {
	  if (prop !== 'default') {
	    // eslint-disable-next-line import/namespace
	    e[prop] = glamorousStar[prop];
	  }
	  return e;
	}, {}));
	
	module.exports = glamorous;


/***/ }),

/***/ "./node_modules/lodash/_Symbol.js":
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__("./node_modules/lodash/_root.js");
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),

/***/ "./node_modules/lodash/_baseGetTag.js":
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__("./node_modules/lodash/_Symbol.js"),
	    getRawTag = __webpack_require__("./node_modules/lodash/_getRawTag.js"),
	    objectToString = __webpack_require__("./node_modules/lodash/_objectToString.js");
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),

/***/ "./node_modules/lodash/_freeGlobal.js":
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ "./node_modules/lodash/_getRawTag.js":
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__("./node_modules/lodash/_Symbol.js");
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),

/***/ "./node_modules/lodash/_objectToString.js":
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),

/***/ "./node_modules/lodash/_root.js":
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__("./node_modules/lodash/_freeGlobal.js");
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),

/***/ "./node_modules/lodash/debounce.js":
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__("./node_modules/lodash/isObject.js"),
	    now = __webpack_require__("./node_modules/lodash/now.js"),
	    toNumber = __webpack_require__("./node_modules/lodash/toNumber.js");
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ }),

/***/ "./node_modules/lodash/isObject.js":
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),

/***/ "./node_modules/lodash/isObjectLike.js":
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),

/***/ "./node_modules/lodash/isSymbol.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"),
	    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),

/***/ "./node_modules/lodash/now.js":
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__("./node_modules/lodash/_root.js");
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ }),

/***/ "./node_modules/lodash/toNumber.js":
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__("./node_modules/lodash/isObject.js"),
	    isSymbol = __webpack_require__("./node_modules/lodash/isSymbol.js");
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ }),

/***/ "./node_modules/moize/lib/Cache.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__("./node_modules/moize/lib/utils.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// utils
	
	
	/**
	 * @private
	 *
	 * @class Cache
	 *
	 * @classdesc
	 * class that is similar to the Map infrastructure, but faster and
	 * more targeted to moize use cases
	 */
	
	
	// types
	var Cache = function () {
	  function Cache() {
	    _classCallCheck(this, Cache);
	
	    this.lastItem = {};
	    this.list = [];
	    this.size = 0;
	  }
	
	  /**
	   * @function add
	   * @memberof Cache
	   * @instance
	   *
	   * @description
	   * add a new item to cache
	   *
	   * @param {*} key the key to assign
	   * @param {*} value the value to assign at key
	   */
	  Cache.prototype.add = function add(key, value) {
	    this.lastItem = (0, _utils.unshift)(this.list, {
	      key: key,
	      value: value
	    });
	
	    this.size++;
	  };
	
	  /**
	   * @function clear
	   * @memberof Cache
	   * @instance
	   *
	   * @description
	   * clear the cache of all items
	   */
	
	
	  Cache.prototype.clear = function clear() {
	    this.lastItem = {};
	    this.list.length = this.size = 0;
	  };
	
	  /**
	   * @function expireAfter
	   * @memberof Cache
	   * @instance
	   *
	   * @description
	   * remove from cache after maxAge time has passed
	   *
	   * @param {*} key the key to remove
	   * @param {number} maxAge the time in milliseconds to wait before removing the key
	   * @param {Function} onExpire a callback that is called after removing the key
	   */
	
	
	  Cache.prototype.expireAfter = function expireAfter(key, maxAge, onExpire) {
	    var _this = this;
	
	    setTimeout(function () {
	      _this.remove(key);
	
	      if ((0, _utils.isFunction)(onExpire)) {
	        // $FlowIgnore onExpire is a function
	        onExpire(key.key);
	      }
	    }, maxAge);
	  };
	
	  /**
	   * @function get
	   * @memberof Cache
	   * @instance
	   *
	   * @description
	   * get the value of an item from cache if it exists
	   *
	   * @param {*} key the key to get the value of
	   * @returns {*} the value at key
	   */
	
	
	  Cache.prototype.get = function get(key) {
	    if (!this.size) {
	      return;
	    }
	
	    if (key === this.lastItem.key) {
	      return this.lastItem.value;
	    }
	
	    var index = (0, _utils.findIndexAfterFirst)(this.list, key);
	
	    if (~index) {
	      this.lastItem = this.list[index];
	
	      return (0, _utils.unshift)((0, _utils.splice)(this.list, index), this.lastItem).value;
	    }
	  };
	
	  /**
	   * @private
	   *
	   * @function has
	   *
	   * @description
	   * does the key exist in the cache
	   *
	   * @param {*} key the key to find in cache
	   * @returns {boolean} does the key exist in cache
	   */
	
	
	  Cache.prototype.has = function has(key) {
	    return this.size !== 0 && (key === this.lastItem.key || !!~(0, _utils.findIndexAfterFirst)(this.list, key));
	  };
	
	  /**=
	   * @function remove
	   * @memberof Cache
	   * @instance
	   *
	   * @description
	   * remove the item at key from cach
	   *
	   * @param {*} key the key to remove from cache
	   * @returns {void}
	   */
	
	
	  Cache.prototype.remove = function remove(key) {
	    var index = (0, _utils.findIndex)(this.list, key);
	
	    if (~index) {
	      (0, _utils.splice)(this.list, index);
	
	      if (this.size === 1) {
	        return this.clear();
	      }
	
	      this.size--;
	
	      if (!index) {
	        this.lastItem = this.list[0];
	      }
	    }
	  };
	
	  /**
	   * @function update
	   * @memberof Cache
	   * @instance
	   *
	   * @description
	   * update an item in-place with a new value
	   *
	   * @param {*} key key to update value of
	   * @param {*} value value to store in the map at key
	   */
	
	
	  Cache.prototype.update = function update(key, value) {
	    var index = (0, _utils.findIndex)(this.list, key);
	
	    if (~index) {
	      this.list[index].value = value;
	
	      if (this.lastItem && key === this.lastItem.key) {
	        this.lastItem.value = value;
	      }
	    }
	  };
	
	  return Cache;
	}();
	
	exports.default = Cache;
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/moize/lib/MultipleParameterCacheKey.js":
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @private
	 *
	 * @class MultipleParameterCacheKey
	 *
	 * @classdesc
	 * cache key used when there are multiple standard parameters
	 */
	var MultipleParameterCacheKey = function () {
	  function MultipleParameterCacheKey(key) {
	    _classCallCheck(this, MultipleParameterCacheKey);
	
	    this.isMultiParamKey = true;
	    this.key = null;
	    this.size = 0;
	
	    this.key = key;
	    this.size = key.length;
	
	    return this;
	  }
	
	  /**
	   * @function matches
	   * @memberof MultipleParameterCacheKey
	   * @instance
	   *
	   * @description
	   * does the passed key match the key in the instance
	   *
	   * @param {Array<*>} key the key to test
	   * @param {boolean} isMultiParamKey is the key a multi-parameter key
	   * @returns {boolean} does the key passed match that in the instance
	   */
	  MultipleParameterCacheKey.prototype.matches = function matches(key, isMultiParamKey) {
	    if (!isMultiParamKey || key.length !== this.size) {
	      return false;
	    }
	
	    var index = 0;
	
	    while (index < this.size) {
	      if (key[index] !== this.key[index]) {
	        return false;
	      }
	
	      index++;
	    }
	
	    return true;
	  };
	
	  /**
	   * @function matchesCustom
	   * @memberof SingleParameterCacheKey
	   * @instance
	   *
	   * @description
	   * does the passed key match the key in the instance based on the custom equality function passed
	   *
	   * @param {Array<*>} key the key to test
	   * @param {boolean} isMultiParamKey is the key a multi-parameter key
	   * @param {function} isEqual method to compare equality of the keys
	   * @returns {boolean} does the key passed match that in the instance
	   */
	
	
	  MultipleParameterCacheKey.prototype.matchesCustom = function matchesCustom(key, isMultiParamKey, isEqual) {
	    return isMultiParamKey && isEqual(key, this.key);
	  };
	
	  return MultipleParameterCacheKey;
	}();
	
	exports.default = MultipleParameterCacheKey;
	module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/moize/lib/ReactCacheKey.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__("./node_modules/moize/lib/utils.js");
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// utils
	
	
	/**
	 * @private
	 *
	 * @class ReactCacheKey
	 *
	 * @classdesc
	 * cache key used specifically for react components
	 */
	var ReactCacheKey = function () {
	  function ReactCacheKey(key) {
	    _classCallCheck(this, ReactCacheKey);
	
	    this.key = null;
	
	    this.key = {
	      context: this._getKeyPart(key[1]),
	      props: this._getKeyPart(key[0])
	    };
	
	    return this;
	  }
	
	  /**
	   * @function _getKeyPart
	   * @memberof ReactCacheKey
	   * @instance
	   *
	   * @description
	   * get the object of metadata for the key part
	   *
	   * @param {Object} keyPart the key part to get the metadata of
	   * @returns {Object} the metadata for the key part
	   */
	  ReactCacheKey.prototype._getKeyPart = function _getKeyPart(keyPart) {
	    var keys = keyPart ? Object.keys(keyPart) : [];
	
	    return {
	      keys: keys,
	      size: keys.length,
	      value: keyPart
	    };
	  };
	
	  /**
	   * @function _isPropShallowEqual
	   * @memberof ReactCacheKey
	   * @instance
	   *
	   * @description
	   * check if the prop value passed is equal to the key's value
	   *
	   * @param {Object} object the new key to test against the instance
	   * @param {Object} existing the key object stored in the instance
	   * @param {Array<string>} existing.keys the keys of the existing object
	   * @param {number} existing.size the length of the keys array
	   * @param {Object} value the value of the key part
	   * @returns {boolean} is the prop value shallow equal to the object
	   */
	
	
	  ReactCacheKey.prototype._isPropShallowEqual = function _isPropShallowEqual(object, existing) {
	    if ((0, _utils.getKeyCount)(object) !== existing.size) {
	      return false;
	    }
	
	    var index = 0,
	        key = void 0;
	
	    while (index < existing.size) {
	      key = existing.keys[index];
	
	      if (object[key] !== existing.value[key]) {
	        return false;
	      }
	
	      index++;
	    }
	
	    return true;
	  };
	
	  /**
	   * @function _isPropCustomEqual
	   * @memberof ReactCacheKey
	   * @instance
	   *
	   * @description
	   * check if the prop value passed is equal to the key's value
	   *
	   * @param {Object} object the new key to test against the instance
	   * @param {Object} existingObject the key stored in the instance
	   * @param {function} isEqual custom equality comparator
	   * @returns {boolean} are the objects equal based on the isEqual method passed
	   */
	
	
	  ReactCacheKey.prototype._isPropCustomEqual = function _isPropCustomEqual(object, existingObject, isEqual) {
	    return isEqual(object, existingObject);
	  };
	
	  /**
	   * @function matches
	   * @memberof ReactCacheKey
	   * @instance
	   *
	   * @description
	   * does the passed key match the key in the instance
	   *
	   * @param {Array<*>} key the key to test
	   * @returns {boolean} does the key passed match that in the instance
	   */
	
	
	  ReactCacheKey.prototype.matches = function matches(key) {
	    return this._isPropShallowEqual(key[0], this.key.props) && this._isPropShallowEqual(key[1], this.key.context);
	  };
	
	  /**
	   * @function matchesCustom
	   * @memberof ReactCacheKey
	   * @instance
	   *
	   * @description
	   * does the passed key match the key in the instance
	   *
	   * @param {Array<*>} key the key to test
	   * @param {function} isEqual method to check equality of keys
	   * @returns {boolean} does the key passed match that in the instance
	   */
	
	
	  ReactCacheKey.prototype.matchesCustom = function matchesCustom(key, isEqual) {
	    return this._isPropCustomEqual(key[0], this.key.props.value, isEqual) && this._isPropCustomEqual(key[1], this.key.context.value, isEqual);
	  };
	
	  return ReactCacheKey;
	}();
	
	exports.default = ReactCacheKey;
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/moize/lib/SerializedCacheKey.js":
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @private
	 *
	 * @class SerializedCacheKey
	 *
	 * @classdesc
	 * cache key used when the parameters should be serialized
	 */
	var SerializedCacheKey = function () {
	  function SerializedCacheKey(key) {
	    _classCallCheck(this, SerializedCacheKey);
	
	    this.key = null;
	
	    this.key = key;
	
	    return this;
	  }
	
	  /**
	   * @function matches
	   * @memberof SerializedCacheKey
	   * @instance
	   *
	   * @description
	   * does the passed key match the key in the instance
	   *W
	   * @param {Array<*>} key the key to test
	   * @returns {boolean} does the key passed match that in the instance
	   */
	  SerializedCacheKey.prototype.matches = function matches(key) {
	    return key === this.key;
	  };
	
	  /**
	   * @function matchesCustom
	   * @memberof SerializedCacheKey
	   * @instance
	   *
	   * @description
	   * does the passed key match the key in the instance based on the custom equality function passed
	   *
	   * @param {Array<*>} key the key to test
	   * @param {function} isEqual method to compare equality of the keys
	   * @returns {boolean} does the key passed match that in the instance
	   */
	
	
	  SerializedCacheKey.prototype.matchesCustom = function matchesCustom(key, isEqual) {
	    return isEqual(key, this.key);
	  };
	
	  return SerializedCacheKey;
	}();
	
	exports.default = SerializedCacheKey;
	module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/moize/lib/SingleParameterCacheKey.js":
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @private
	 *
	 * @class SingleParameterCacheKey
	 *
	 * @classdesc
	 * cache key used when there is a single standard parameter
	 */
	var SingleParameterCacheKey = function () {
	  function SingleParameterCacheKey(key) {
	    _classCallCheck(this, SingleParameterCacheKey);
	
	    this.isMultiParamKey = false;
	    this.key = null;
	
	    this.key = key[0];
	
	    return this;
	  }
	
	  /**
	   * @function matches
	   * @memberof SingleParameterCacheKey
	   * @instance
	   *
	   * @description
	   * does the passed key match the key in the instance
	   *
	   * @param {Array<*>} key the key to test
	   * @param {boolean} isMultiParamKey is the key a multi-parameter key
	   * @returns {boolean} does the key passed match that in the instance
	   */
	  SingleParameterCacheKey.prototype.matches = function matches(key, isMultiParamKey) {
	    return !isMultiParamKey && key[0] === this.key;
	  };
	
	  /**
	   * @function matchesCustom
	   * @memberof SingleParameterCacheKey
	   * @instance
	   *
	   * @description
	   * does the passed key match the key in the instance based on the custom equality function passed
	   *
	   * @param {Array<*>} key the key to test
	   * @param {boolean} isMultiParamKey is the key a multi-parameter key
	   * @param {function} isEqual method to compare equality of the keys
	   * @returns {boolean} does the key passed match that in the instance
	   */
	
	
	  SingleParameterCacheKey.prototype.matchesCustom = function matchesCustom(key, isMultiParamKey, isEqual) {
	    return !isMultiParamKey && isEqual(key[0], this.key);
	  };
	
	  return SingleParameterCacheKey;
	}();
	
	exports.default = SingleParameterCacheKey;
	module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/moize/lib/constants.js":
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var FINITE_POSITIVE_INTEGER = exports.FINITE_POSITIVE_INTEGER = /^[1-9]\d*$/;
	
	/**
	 * @private
	 *
	 * @constant {RegExp} FUNCTION_NAME_REGEXP
	 */
	var FUNCTION_NAME_REGEXP = exports.FUNCTION_NAME_REGEXP = /^\s*function\s+([^\(\s]*)\s*/;
	
	/**
	 * @private
	 *
	 * @constant {string} FUNCTION_TYPEOF
	 * @default
	 */
	var FUNCTION_TYPEOF = exports.FUNCTION_TYPEOF = 'function';
	
	/**
	 * @private
	 *
	 * @constant {Array<Object>} GOTCHA_OBJECT_CLASSES
	 */
	var GOTCHA_OBJECT_CLASSES = exports.GOTCHA_OBJECT_CLASSES = [Boolean, Date, Number, RegExp, String];
	
	/**
	 * @private
	 *
	 * @constant {number} INFINITY
	 * @default
	 */
	var INFINITY = exports.INFINITY = Number.POSITIVE_INFINITY;
	
	/**
	 * @private
	 *
	 * @constant {string} INVALID_FIRST_PARAMETER_ERROR
	 * @default
	 */
	var INVALID_FIRST_PARAMETER_ERROR = exports.INVALID_FIRST_PARAMETER_ERROR = 'You must pass either a function or an object of options as the first parameter to moize.';
	
	/**
	 * @private
	 *
	 * @constant {string} INVALID_PROMISE_LIBRARY_ERROR
	 * @default
	 */
	var INVALID_PROMISE_LIBRARY_ERROR = exports.INVALID_PROMISE_LIBRARY_ERROR = 'The promiseLibrary passed must either be a function or an object with the resolve / reject methods.';
	
	/**
	 * @private
	 *
	 * @constant {function|undefined} NATIVE_PROMISE
	 */
	var NATIVE_PROMISE = exports.NATIVE_PROMISE = (typeof Promise === 'undefined' ? 'undefined' : _typeof(Promise)) === FUNCTION_TYPEOF ? Promise : undefined;
	
	/**
	 * @private
	 *
	 * @constant {Object} DEFAULT_OPTIONS
	 */
	var DEFAULT_OPTIONS = exports.DEFAULT_OPTIONS = {
	  equals: null,
	  isPromise: false,
	  isReact: false,
	  maxAge: INFINITY,
	  maxArgs: INFINITY,
	  maxSize: INFINITY,
	  promiseLibrary: NATIVE_PROMISE,
	  serialize: false,
	  serializeFunctions: false,
	  serializer: null,
	  transformArgs: null
	};
	
	/**
	 * @private
	 *
	 * @constant {string} OBJECT_TYPEOF
	 * @default
	 */
	var OBJECT_TYPEOF = exports.OBJECT_TYPEOF = 'object';
	
	/**
	 * @private
	 *
	 * @constant {Array<string>} STATIC_PROPERTIES_TO_PASS
	 */
	var STATIC_PROPERTIES_TO_PASS = exports.STATIC_PROPERTIES_TO_PASS = ['contextTypes', 'defaultProps', 'propTypes'];
	
	/**
	 * @private
	 *
	 * @constant {{isPromise: true}} PROMISE_OPTIONS
	 */
	var PROMISE_OPTIONS = exports.PROMISE_OPTIONS = {
	  isPromise: true
	};
	
	/**
	 * @private
	 *
	 * @constant {{maxArgs: number, serialize: boolean, serializeFunctions: boolean}} REACT_OPTIONS
	 */
	var REACT_OPTIONS = exports.REACT_OPTIONS = {
	  isReact: true
	};
	
	/**
	 * @private
	 *
	 * @constant {{serialize: boolean}} SERIALIZE_OPTIONS
	 */
	var SERIALIZE_OPTIONS = exports.SERIALIZE_OPTIONS = {
	  serialize: true
	};

/***/ }),

/***/ "./node_modules/moize/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	// cache
	
	
	// constants
	
	
	// utils
	
	
	// types
	
	
	var _Cache = __webpack_require__("./node_modules/moize/lib/Cache.js");
	
	var _Cache2 = _interopRequireDefault(_Cache);
	
	var _constants = __webpack_require__("./node_modules/moize/lib/constants.js");
	
	var _utils = __webpack_require__("./node_modules/moize/lib/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @module moize
	 */
	
	/**
	 * @function moize
	 *
	 * @description
	 * store cached values returned from calling method with arguments to avoid reprocessing data from same arguments
	 *
	 * @example
	 * import moize from 'moize';
	 *
	 * // standard implementation
	 * const fn = (foo, bar) => {
	 *  return `${foo} ${bar}`;
	 * };
	 * const memoizedFn = moize(fn);
	 *
	 * // implementation with options
	 * const fn = async (id) => {
	 *  return get(`http://foo.com/${id}`);
	 * };
	 * const memoizedFn = moize(fn, {
	 *  isPromise: true,
	 *  maxSize: 5
	 * });
	 *
	 * @param {function} functionOrComposableOptions method to memoize
	 * @param {Options} [passedOptions={}] options to customize how the caching is handled
	 * @param {boolean} [passedOptions.isPromise=false] is the function return expected to be a promise to resolve
	 * @param {number} [passedOptions.maxAge=Infinity] the maximum age the value should persist in cache
	 * @param {number} [passedOptions.maxArgs=Infinity] the maximum number of arguments to be used in serializing the keys
	 * @param {number} [passedOptions.maxSize=Infinity] the maximum size of the cache to retain
	 * @param {function} [passedOptions.promiseLibrary=Promise] promise library to use for resolution / rejection
	 * @param {function} [passedOptions.serializeFunctions=false] should function parameters be serialized as well
	 * @param {function} [passedOptions.serializer] method to serialize arguments with for cache storage
	 * @returns {Function} higher-order function which either returns from cache or newly-computed value
	 */
	var moize = function moize(functionOrComposableOptions) {
	  var passedOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if ((0, _utils.isPlainObject)(functionOrComposableOptions)) {
	    return function (fnOrOptions) {
	      var otherOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      if ((0, _utils.isPlainObject)(fnOrOptions)) {
	        return moize(_extends({}, functionOrComposableOptions, fnOrOptions));
	      }
	
	      return moize(fnOrOptions, _extends({}, functionOrComposableOptions, otherOptions));
	    };
	  }
	
	  if (!(0, _utils.isFunction)(functionOrComposableOptions)) {
	    throw new TypeError(_constants.INVALID_FIRST_PARAMETER_ERROR);
	  }
	
	  var isComposed = functionOrComposableOptions.isMoized;
	  // $FlowIgnore if the function is already moized, it has an originalFunction property on it
	  var fn = isComposed ? functionOrComposableOptions.originalFunction : functionOrComposableOptions;
	
	  var options = (0, _utils.getDefaultedOptions)(!isComposed ? passedOptions : _extends({}, functionOrComposableOptions.options, passedOptions));
	
	  var cache = new _Cache2.default();
	
	  var addPropertiesToFunction = (0, _utils.createAddPropertiesToFunction)(cache, fn, options);
	  var getCacheKey = (0, _utils.createGetCacheKey)(cache, options);
	  var setNewCachedValue = (0, _utils.createSetNewCachedValue)(cache, options);
	
	  var moizedFunction = function moizedFunction() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var key = getCacheKey(args);
	
	    return cache.size && cache.has(key) ? cache.get(key) : setNewCachedValue(key, fn.apply(this, args));
	  };
	
	  return addPropertiesToFunction(moizedFunction);
	};
	
	moize.compose = _utils.compose;
	moize.isMoized = _utils.isMoized;
	moize.maxAge = (0, _utils.createCurriableOptionMethod)(moize, 'maxAge');
	moize.maxArgs = (0, _utils.createCurriableOptionMethod)(moize, 'maxArgs');
	moize.maxSize = (0, _utils.createCurriableOptionMethod)(moize, 'maxSize');
	moize.promise = moize(_constants.PROMISE_OPTIONS);
	moize.react = moize(_constants.REACT_OPTIONS);
	moize.reactSimple = (0, _utils.compose)(moize.react, moize.maxSize(1));
	moize.serialize = moize(_constants.SERIALIZE_OPTIONS);
	moize.simple = moize.maxSize(1);
	
	exports.default = moize;
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/moize/lib/serialize.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getSerializerFunction = exports.createArgumentSerializer = exports.getStringifiedArgument = exports.stringify = exports.decycle = exports.customReplacer = undefined;
	
	var _Cache = __webpack_require__("./node_modules/moize/lib/Cache.js");
	
	var _Cache2 = _interopRequireDefault(_Cache);
	
	var _utils = __webpack_require__("./node_modules/moize/lib/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @private
	 *
	 * @function customReplacer
	 *
	 * @description
	 * custom replacer for the stringify function
	 *
	 * @param {string} key key in json object
	 * @param {*} value value in json object
	 * @returns {*} if function then toString of it, else the value itself
	 */
	
	
	// cache
	var customReplacer = exports.customReplacer = function customReplacer(key, value) {
	  return (0, _utils.isFunction)(value) ? '' + value : value;
	};
	
	/**
	 * @private
	 *
	 * @function decycle
	 *
	 * @description
	 * ES2015-ified version of cycle.decyle
	 *
	 * @param {*} object object to stringify
	 * @returns {string} stringified value of object
	 */
	
	
	// utils
	
	
	// types
	var decycle = exports.decycle = function decycle(object) {
	  var cache = new _Cache2.default();
	
	  /**
	   * @private
	   *
	   * @function coalesceCircularReferences
	   *
	   * @description
	   * recursive method to replace any circular references with a placeholder
	   *
	   * @param {*} value value in object to decycle
	   * @param {string} path path to reference
	   * @returns {*} clean value
	   */
	  var coalesceCircularReferences = function coalesceCircularReferences(value, path) {
	    if (!(0, _utils.isValueObjectOrArray)(value)) {
	      return value;
	    }
	
	    if (cache.has(value)) {
	      return {
	        $ref: cache.get(value)
	      };
	    }
	
	    cache.add(value, path);
	
	    if (Array.isArray(value)) {
	      return value.map(function (item, itemIndex) {
	        return coalesceCircularReferences(item, path + '[' + itemIndex + ']');
	      });
	    }
	
	    return Object.keys(value).reduce(function (object, name) {
	      object[name] = coalesceCircularReferences(value[name], path + '[' + JSON.stringify(name) + ']');
	
	      return object;
	    }, {});
	  };
	
	  return coalesceCircularReferences(object, '$');
	};
	
	/**
	 * @private
	 *
	 * @function stringify
	 *
	 * @description
	 * stringify with a custom replacer if circular, else use standard JSON.stringify
	 *
	 * @param {*} value value to stringify
	 * @param {function} [replacer] replacer to used in stringification
	 * @returns {string} the stringified version of value
	 */
	var stringify = exports.stringify = function stringify(value, replacer) {
	  try {
	    return JSON.stringify(value, replacer);
	  } catch (exception) {
	    return JSON.stringify(decycle(value), replacer);
	  }
	};
	
	/**
	 * @private
	 *
	 * @function getStringifiedArgument
	 *
	 * @description
	 * get the stringified version of the argument passed
	 *
	 * @param {*} arg argument to stringify
	 * @param {function} [replacer] replacer to used in stringification
	 * @returns {string}
	 */
	var getStringifiedArgument = exports.getStringifiedArgument = function getStringifiedArgument(arg, replacer) {
	  return (0, _utils.isComplexObject)(arg) || (0, _utils.isFunction)(arg) ? stringify(arg, replacer) : arg;
	};
	
	/**
	 * @private
	 *
	 * @function createArgumentSerializer
	 *
	 * @description
	 * create the internal argument serializer based on the options passed
	 *
	 * @param {boolean} serializeFunctions should functions be included in the serialization
	 * @param {number} maxArgs the cap on the number of arguments used in serialization
	 * @returns {function(...Array<*>): string} argument serialization method
	 */
	var createArgumentSerializer = exports.createArgumentSerializer = function createArgumentSerializer(_ref) {
	  var maxArgs = _ref.maxArgs,
	      serializeFunctions = _ref.serializeFunctions;
	
	  var replacer = serializeFunctions ? customReplacer : null;
	  var hasMaxArgs = (0, _utils.isFiniteAndPositiveInteger)(maxArgs);
	
	  return function (args) {
	    var length = hasMaxArgs ? maxArgs : args.length;
	
	    var index = -1,
	        key = '|',
	        value = void 0;
	
	    while (++index < length) {
	      value = getStringifiedArgument(args[index], replacer);
	
	      if (value) {
	        key += value + '|';
	      }
	    }
	
	    return key;
	  };
	};
	
	/**
	 * @private
	 *
	 * @function getSerializerFunction
	 *
	 * @description
	 * based on the options passed, either use the serializer passed or generate the internal one
	 *
	 * @param {Options} options the options passed to the moized function
	 * @returns {function} the function to use in serializing the arguments
	 */
	var getSerializerFunction = exports.getSerializerFunction = function getSerializerFunction(options) {
	  return (0, _utils.isFunction)(options.serializer) ? options.serializer : createArgumentSerializer(options);
	};

/***/ }),

/***/ "./node_modules/moize/lib/utils.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createAddPropertiesToFunction = exports.unshift = exports.splice = exports.createSetNewCachedValue = exports.createGetCacheKey = exports.getGetCacheKeyMethod = exports.getStandardCacheKeyCustomEquals = exports.getStandardCacheKey = exports.getSerializedCacheKeyCustomEquals = exports.getSerializedCacheKey = exports.getReactCacheKeyCustomEquals = exports.getReactCacheKey = exports.getKeyCount = exports.getFunctionName = exports.getFunctionNameViaRegexp = exports.getDefaultedOptions = exports.findIndexAfterFirst = exports.findIndex = exports.createPromiseResolver = exports.createPromiseRejecter = exports.createPluckFromInstanceList = exports.createFindIndex = exports.createCurriableOptionMethod = exports.compose = exports.addStaticPropertiesToFunction = exports.take = exports.isValueObjectOrArray = exports.isPlainObject = exports.isMoized = exports.isFunction = exports.isFiniteAndPositiveInteger = exports.isComplexObject = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// cache
	
	
	// cache key
	
	
	// constants
	
	
	// serialize
	
	
	var _Cache = __webpack_require__("./node_modules/moize/lib/Cache.js");
	
	var _Cache2 = _interopRequireDefault(_Cache);
	
	var _ReactCacheKey = __webpack_require__("./node_modules/moize/lib/ReactCacheKey.js");
	
	var _ReactCacheKey2 = _interopRequireDefault(_ReactCacheKey);
	
	var _SerializedCacheKey = __webpack_require__("./node_modules/moize/lib/SerializedCacheKey.js");
	
	var _SerializedCacheKey2 = _interopRequireDefault(_SerializedCacheKey);
	
	var _SingleParameterCacheKey = __webpack_require__("./node_modules/moize/lib/SingleParameterCacheKey.js");
	
	var _SingleParameterCacheKey2 = _interopRequireDefault(_SingleParameterCacheKey);
	
	var _MultipleParameterCacheKey = __webpack_require__("./node_modules/moize/lib/MultipleParameterCacheKey.js");
	
	var _MultipleParameterCacheKey2 = _interopRequireDefault(_MultipleParameterCacheKey);
	
	var _constants = __webpack_require__("./node_modules/moize/lib/constants.js");
	
	var _serialize = __webpack_require__("./node_modules/moize/lib/serialize.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @private
	 *
	 * @function isComplexObject
	 *
	 * @description
	 * is the object passed a complex object
	 *
	 * @param {*} object object to test if it is complex
	 * @returns {boolean} is it a complex object
	 */
	
	
	// types
	var isComplexObject = exports.isComplexObject = function isComplexObject(object) {
	  return !!object && (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === _constants.OBJECT_TYPEOF;
	};
	
	/**
	 * @private
	 *
	 * @function isFiniteAndPositiveInteger
	 *
	 * @description
	 * is the number passed an integer that is finite and positive
	 *
	 * @param {number} number number to test for finiteness and positivity
	 * @returns {boolean} is the number finite and positive
	 */
	var isFiniteAndPositiveInteger = exports.isFiniteAndPositiveInteger = function isFiniteAndPositiveInteger(number) {
	  return _constants.FINITE_POSITIVE_INTEGER.test('' + number);
	};
	
	/**
	 * @private
	 *
	 * @function isFunction
	 *
	 * @description
	 * is the object passed a function or not
	 *
	 * @param {*} object object to test
	 * @returns {boolean} is it a function
	 */
	var isFunction = exports.isFunction = function isFunction(object) {
	  return (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === _constants.FUNCTION_TYPEOF;
	};
	
	/**
	 * @private
	 *
	 * @function isMoized
	 *
	 * @description
	 * is the function passed a moized function or not
	 *
	 * @param {*} fn the function to get if moize
	 * @returns {boolean} is the function moized or not
	 */
	var isMoized = exports.isMoized = function isMoized(fn) {
	  return isFunction(fn) && !!fn.isMoized;
	};
	
	/**
	 * @private
	 *
	 * @function isPlainObject
	 *
	 * @description
	 * is the object passed a plain object or not
	 *
	 * @param {*} object object to test
	 * @returns {boolean} is it a plain object
	 */
	var isPlainObject = exports.isPlainObject = function isPlainObject(object) {
	  return isComplexObject(object) && object.constructor === Object;
	};
	
	/**
	 * @private
	 *
	 * @function isValueObjectOrArray
	 *
	 * @description
	 * check if the object is actually an object or array
	 *
	 * @param {*} object object to test
	 * @returns {boolean} is the object an object or array
	 */
	var isValueObjectOrArray = exports.isValueObjectOrArray = function isValueObjectOrArray(object) {
	  if (!isComplexObject(object)) {
	    return false;
	  }
	
	  var index = 0;
	
	  while (index < _constants.GOTCHA_OBJECT_CLASSES.length) {
	    if (object instanceof _constants.GOTCHA_OBJECT_CLASSES[index]) {
	      return false;
	    }
	
	    index++;
	  }
	
	  return true;
	};
	
	/**
	 * @private
	 *
	 * @function take
	 *
	 * @description
	 * take the first N number of items from the array (faster than slice)
	 *
	 * @param {number} size the number of items to take
	 * @returns {function(Array<*>): Array<*>} the shortened array
	 */
	var take = exports.take = function take(size) {
	  return function (array) {
	    if (size >= array.length) {
	      return array;
	    }
	
	    switch (size) {
	      case 1:
	        return [array[0]];
	
	      case 2:
	        return [array[0], array[1]];
	
	      case 3:
	        return [array[0], array[1], array[2]];
	
	      case 4:
	        return [array[0], array[1], array[2], array[3]];
	
	      case 5:
	        return [array[0], array[1], array[2], array[3], array[4]];
	    }
	
	    return array.slice(0, size);
	  };
	};
	
	/**
	 * @private
	 *
	 * @function addStaticPropertiesToFunction
	 *
	 * @description
	 * add static properties to the memoized function if they exist on the original
	 *
	 * @param {function} originalFunction the function to be memoized
	 * @param {function} memoizedFn the higher-order memoized function
	 * @returns {function} memoizedFn with static properties added
	 */
	var addStaticPropertiesToFunction = exports.addStaticPropertiesToFunction = function addStaticPropertiesToFunction(originalFunction, memoizedFn) {
	  var index = _constants.STATIC_PROPERTIES_TO_PASS.length,
	      property = void 0;
	
	  while (index--) {
	    property = _constants.STATIC_PROPERTIES_TO_PASS[index];
	
	    if (originalFunction[property]) {
	      memoizedFn[property] = originalFunction[property];
	    }
	  }
	
	  return memoizedFn;
	};
	
	/**
	 * @private
	 *
	 * @function compose
	 *
	 * @description
	 * method to compose functions and return a single function
	 *
	 * @param {...Array<function>} functions the functions to compose
	 * @returns {function(...Array<*>): *} the composed function
	 */
	var compose = exports.compose = function compose() {
	  for (var _len = arguments.length, functions = Array(_len), _key = 0; _key < _len; _key++) {
	    functions[_key] = arguments[_key];
	  }
	
	  return functions.reduce(function (f, g) {
	    return function () {
	      return f(g.apply(undefined, arguments));
	    };
	  });
	};
	
	/**
	 * @private
	 *
	 * @function createCurriableOptionMethod
	 *
	 * @description
	 * create a method that will curry moize with the option + value passed
	 *
	 * @param {function} fn the method to call
	 * @param {string} option the name of the option to apply
	 * @param {*} value the value to assign to option
	 * @returns {function} the moizer with the option pre-applied
	 */
	var createCurriableOptionMethod = exports.createCurriableOptionMethod = function createCurriableOptionMethod(fn, option) {
	  return function (value) {
	    var _fn;
	
	    return fn((_fn = {}, _fn[option] = value, _fn));
	  };
	};
	
	/**
	 * @private
	 *
	 * @function createFindIndex
	 *
	 * @description
	 * create a findIndex method based on the startingIndex passed
	 *
	 * @param {number} startingIndex the index to start in the find method returned
	 * @returns {function(Array<ListItem>, *): number} the findIndex method
	 */
	var createFindIndex = exports.createFindIndex = function createFindIndex(startingIndex) {
	  // eslint-disable-line no-use-before-define
	  return function (list, key) {
	    var index = startingIndex;
	
	    while (index < list.length) {
	      if (key === list[index].key) {
	        return index;
	      }
	
	      index++;
	    }
	
	    return -1;
	  };
	};
	
	/**
	 * @private
	 *
	 * @function createPluckFromInstanceList
	 *
	 * @description
	 * get a property from the list on the cache
	 *
	 * @param {{list: Array<Object>}} cache cache whose list to map over
	 * @param {string} key key to pluck from list
	 * @returns {Array<*>} array of values plucked at key
	 */
	var createPluckFromInstanceList = exports.createPluckFromInstanceList = function createPluckFromInstanceList(cache, key) {
	  return function () {
	    return cache.list.map(function (item) {
	      return item[key];
	    });
	  };
	};
	
	/**
	 * @private
	 *
	 * @function createPromiseRejecter
	 *
	 * @description
	 * create method that will reject the promise and delete the key from cache
	 *
	 * @param {Cache} cache cache to update
	 * @param {*} key key to delete from cache
	 * @param {function} promiseLibrary the promise library used
	 * @returns {function} the rejecter function for the promise
	 */
	var createPromiseRejecter = exports.createPromiseRejecter = function createPromiseRejecter(cache, key, _ref) {
	  var promiseLibrary = _ref.promiseLibrary;
	
	  return function (exception) {
	    cache.remove(key);
	
	    return promiseLibrary.reject(exception);
	  };
	};
	
	/**
	 * @private
	 *
	 * @function createPromiseResolver
	 *
	 * @description
	 * create method that will resolve the promise and update the key in cache
	 *
	 * @param {Cache} cache cache to update
	 * @param {*} key key to update in cache
	 * @param {boolean} hasMaxAge should the cache expire after some time
	 * @param {number} maxAge the age after which the cache will be expired
	 * @param {function} onExpire a callback that is called after removing the key
	 * @param {function} promiseLibrary the promise library used
	 * @returns {function} the resolver function for the promise
	 */
	var createPromiseResolver = exports.createPromiseResolver = function createPromiseResolver(cache, key, hasMaxAge, _ref2) {
	  var maxAge = _ref2.maxAge,
	      onExpire = _ref2.onExpire,
	      promiseLibrary = _ref2.promiseLibrary;
	
	  return function (resolvedValue) {
	    cache.update(key, promiseLibrary.resolve(resolvedValue));
	
	    if (hasMaxAge) {
	      cache.expireAfter(key, maxAge, onExpire);
	    }
	
	    return resolvedValue;
	  };
	};
	
	/**
	 * @private
	 *
	 * @function findIndex
	 *
	 * @description
	 * find the index of the key starting at the first index
	 *
	 * @param {Array<ListItem>} list the list to find the key in
	 * @param {*} key the key to test against
	 * @returns {number} the index of the matching key, or -1
	 */
	var findIndex = exports.findIndex = createFindIndex(0);
	
	/**
	 * @private
	 *
	 * @function findIndexAfterFirst
	 *
	 * @description
	 * find the index of the key starting at the second index
	 *
	 * @param {Array<ListItem>} list the list to find the key in
	 * @param {*} key the key to test against
	 * @returns {number} the index of the matching key, or -1
	 */
	var findIndexAfterFirst = exports.findIndexAfterFirst = createFindIndex(1);
	
	/**
	 * @private
	 *
	 * @function getDefaultedOptions
	 *
	 * @description
	 * get the options coalesced to their defaults
	 *
	 * @param {Object} options the options passed to the moize method
	 * @returns {Options} the coalesced options object
	 */
	var getDefaultedOptions = exports.getDefaultedOptions = function getDefaultedOptions(options) {
	  var coalescedOptions = _extends({}, _constants.DEFAULT_OPTIONS, options);
	
	  if (coalescedOptions.serialize) {
	    coalescedOptions.serializer = (0, _serialize.getSerializerFunction)(coalescedOptions);
	  }
	
	  return coalescedOptions;
	};
	
	/**
	 * @private
	 *
	 * @function getFunctionNameViaRegexp
	 *
	 * @description
	 * use regexp match on stringified function to get the function name
	 *
	 * @param {function} fn function to get the name of
	 * @returns {string} function name
	 */
	var getFunctionNameViaRegexp = exports.getFunctionNameViaRegexp = function getFunctionNameViaRegexp(fn) {
	  var match = fn.toString().match(_constants.FUNCTION_NAME_REGEXP);
	
	  return match ? match[1] : '';
	};
	
	/**
	 * @private
	 *
	 * @function getFunctionName
	 *
	 * @description
	 * get the function name, either from modern property or regexp match,
	 * falling back to generic string
	 *
	 * @param {function} fn function to get the name of
	 * @returns {string} function name
	 */
	var getFunctionName = exports.getFunctionName = function getFunctionName(fn) {
	  return fn.displayName || fn.name || getFunctionNameViaRegexp(fn) || _constants.FUNCTION_TYPEOF;
	};
	
	/**
	 * @private
	 *
	 * @function getKeyCount
	 *
	 * @description
	 * get the count of keys in the object (faster than Object.keys().length)
	 *
	 * @param {Object} object the object to get the key count of
	 * @returns {number} the count of keys
	 */
	var getKeyCount = exports.getKeyCount = function getKeyCount(object) {
	  var counter = 0;
	
	  for (var ignored in object) {
	    counter++;
	  }
	
	  return counter;
	};
	
	/**
	 * @private
	 *
	 * @function getReactCacheKey
	 *
	 * @description
	 * get the cache key specific to react
	 *
	 * @param {Cache} cache the cache to find a potential matching key in
	 * @param {*} key the key to try to find a match of, or turn into a new ReactCacheKey
	 * @returns {ReactCacheKey} the matching cache key, or a new one
	 */
	var getReactCacheKey = exports.getReactCacheKey = function getReactCacheKey(cache, key) {
	  // $FlowIgnore if cache has size, the key exists
	  if (cache.size && cache.lastItem.key.matches(key)) {
	    // $FlowIgnore if the key matches, the key exists
	    return cache.lastItem.key;
	  }
	
	  var index = 1;
	
	  while (index < cache.size) {
	    // $FlowIgnore if cache has size, the key exists
	    if (cache.list[index].key.matches(key)) {
	      // $FlowIgnore if the key matches, the key exists
	      return cache.list[index].key;
	    }
	
	    index++;
	  }
	
	  return new _ReactCacheKey2.default(key);
	};
	
	/**
	 * @private
	 *
	 * @function getReactCacheKey
	 *
	 * @description
	 * get the cache key specific to react
	 *
	 * @param {Cache} cache the cache to find a potential matching key in
	 * @param {*} key the key to try to find a match of, or turn into a new ReactCacheKey
	 * @param {Options} options the options passed to the moized method
	 * @returns {ReactCacheKey} the matching cache key, or a new one
	 */
	var getReactCacheKeyCustomEquals = exports.getReactCacheKeyCustomEquals = function getReactCacheKeyCustomEquals(cache, key, options) {
	  // $FlowIgnore if cache has size, the key exists
	  if (cache.size && cache.lastItem.key.matchesCustom(key, options.equals)) {
	    // $FlowIgnore if the key matches, the key exists
	    return cache.lastItem.key;
	  }
	
	  var index = 1;
	
	  while (index < cache.size) {
	    // $FlowIgnore if cache has size, the key exists
	    if (cache.list[index].key.matchesCustom(key, options.equals)) {
	      // $FlowIgnore if the key matches, the key exists
	      return cache.list[index].key;
	    }
	
	    index++;
	  }
	
	  return new _ReactCacheKey2.default(key);
	};
	
	/**
	 * @private
	 *
	 * @function getSerializedCacheKey
	 *
	 * @description
	 * get the cache key specific to serialized methods
	 *
	 * @param {Cache} cache the cache to find a potential matching key in
	 * @param {*} key the key to try to find a match of, or turn into a new SerializedCacheKey
	 * @param {Options} options the options passed to the moized method
	 * @returns {SerializedCacheKey} the matching cache key, or a new one
	 */
	var getSerializedCacheKey = exports.getSerializedCacheKey = function getSerializedCacheKey(cache, key) {
	  // $FlowIgnore if cache has size, the key exists
	  if (cache.size && cache.lastItem.key.matches(key)) {
	    // $FlowIgnore if the key matches, the key exists
	    return cache.lastItem.key;
	  }
	
	  var index = 1;
	
	  while (index < cache.size) {
	    // $FlowIgnore if cache has size, the key exists
	    if (cache.list[index].key.matches(key)) {
	      // $FlowIgnore if the key matches, the key exists
	      return cache.list[index].key;
	    }
	
	    index++;
	  }
	
	  return new _SerializedCacheKey2.default(key);
	};
	
	/**
	 * @private
	 *
	 * @function getSerializedCacheKeyCustomEquals
	 *
	 * @description
	 * get the cache key specific to serialized methods
	 *
	 * @param {Cache} cache the cache to find a potential matching key in
	 * @param {*} key the key to try to find a match of, or turn into a new SerializedCacheKey
	 * @param {Options} options the options passed to the moized method
	 * @returns {SerializedCacheKey} the matching cache key, or a new one
	 */
	var getSerializedCacheKeyCustomEquals = exports.getSerializedCacheKeyCustomEquals = function getSerializedCacheKeyCustomEquals(cache, key, options) {
	  if (cache.size &&
	  // $FlowIgnore if cache has size, the key exists
	  cache.lastItem.key.matchesCustom(key, options.equals)) {
	    // $FlowIgnore if the key matches, the key exists
	    return cache.lastItem.key;
	  }
	
	  var index = 1;
	
	  while (index < cache.size) {
	    // $FlowIgnore if cache has size, the key exists
	    if (cache.list[index].key.matchesCustom(key, options.equals)) {
	      // $FlowIgnore if the key matches, the key exists
	      return cache.list[index].key;
	    }
	
	    index++;
	  }
	
	  return new _SerializedCacheKey2.default(key);
	};
	
	/**
	 * @private
	 *
	 * @function getStandardCacheKey
	 *
	 * @description
	 * get the cache key for standard parameters, either single or multiple
	 *
	 * @param {Cache} cache the cache to find a potential matching key in
	 * @param {*} key the key to try to find a match of, or turn into a new Multiple / SingleParameterCacheKey
	 * @returns {StandardCacheKey} the matching cache key, or a new one
	 */
	var getStandardCacheKey = exports.getStandardCacheKey = function getStandardCacheKey(cache, key) {
	  var isMultiParamKey = key.length > 1;
	
	  // $FlowIgnore if cache has size, the key exists
	  if (cache.size && cache.lastItem.key.matches(key, isMultiParamKey)) {
	    // $FlowIgnore if the key matches, the key exists
	    return cache.lastItem.key;
	  }
	
	  var index = 1;
	
	  while (index < cache.size) {
	    // $FlowIgnore if cache has size, the key exists
	    if (cache.list[index].key.matches(key, isMultiParamKey)) {
	      // $FlowIgnore if the key matches, the key exists
	      return cache.list[index].key;
	    }
	
	    index++;
	  }
	
	  return isMultiParamKey ? new _MultipleParameterCacheKey2.default(key) : new _SingleParameterCacheKey2.default(key);
	};
	
	/**
	 * @private
	 *
	 * @function getStandardCacheKeyCustomEquals
	 *
	 * @description
	 * get the cache key for standard parameters, either single or multiple
	 *
	 * @param {Cache} cache the cache to find a potential matching key in
	 * @param {*} key the key to try to find a match of, or turn into a new Multiple / SingleParameterCacheKey
	 * @param {Options} options the options passed to the moized method
	 * @returns {StandardCacheKey} the matching cache key, or a new one
	 */
	var getStandardCacheKeyCustomEquals = exports.getStandardCacheKeyCustomEquals = function getStandardCacheKeyCustomEquals(cache, key, options) {
	  var isMultiParamKey = key.length > 1;
	
	  if (cache.size &&
	  // $FlowIgnore if cache has size, the key exists
	  cache.lastItem.key.matchesCustom(key, isMultiParamKey, options.equals)) {
	    // $FlowIgnore if the key matches, the key exists
	    return cache.lastItem.key;
	  }
	
	  var index = 1;
	
	  while (index < cache.size) {
	    if (
	    // $FlowIgnore if cache has size, the key exists
	    cache.list[index].key.matchesCustom(key, isMultiParamKey, options.equals)) {
	      // $FlowIgnore if the key matches, the key exists
	      return cache.list[index].key;
	    }
	
	    index++;
	  }
	
	  return isMultiParamKey ? new _MultipleParameterCacheKey2.default(key) : new _SingleParameterCacheKey2.default(key);
	};
	
	/**
	 * @private
	 *
	 * @function getGetCacheKeyMethod
	 *
	 * @description
	 * based on the options, get the getCacheKey method
	 *
	 * @param {Options} options the options passed to the moized method
	 * @returns {function(Cache, Array<*>): CacheKey} the cache key
	 */
	var getGetCacheKeyMethod = exports.getGetCacheKeyMethod = function getGetCacheKeyMethod(options) {
	  if (options.isReact) {
	    return options.equals ? getReactCacheKeyCustomEquals : getReactCacheKey;
	  }
	
	  if (options.serialize) {
	    return options.equals ? getSerializedCacheKeyCustomEquals : getSerializedCacheKey;
	  }
	
	  return options.equals ? getStandardCacheKeyCustomEquals : getStandardCacheKey;
	};
	
	/**
	 * @private
	 *
	 * @function createGetCacheKey
	 *
	 * @description
	 * create the method that will get the cache key based on the options passed to the moized method
	 *
	 * @param {Cache} cache the cache to get the key from
	 * @param {Options} options the options passed to the moized method
	 * @returns {function(*): CacheKey} the method that will get the cache key
	 */
	var createGetCacheKey = exports.createGetCacheKey = function createGetCacheKey(cache, options) {
	  var hasMaxArgs = isFiniteAndPositiveInteger(options.maxArgs);
	  var getCacheKeyMethod = getGetCacheKeyMethod(options);
	
	  var transform = options.transformArgs;
	
	  if (hasMaxArgs) {
	    transform = transform ? compose(transform, take(options.maxArgs)) : take(options.maxArgs);
	  }
	
	  if (options.serialize) {
	    transform = transform ? compose(options.serializer, transform) : options.serializer;
	  }
	
	  if (options.equals) {
	    if (transform) {
	      return function (key) {
	        // $FlowIgnore transform is a function
	        return getCacheKeyMethod(cache, transform(key), options);
	      };
	    }
	
	    return function (key) {
	      return getCacheKeyMethod(cache, key, options);
	    };
	  }
	
	  if (transform) {
	    return function (key) {
	      // $FlowIgnore transform is a function
	      return getCacheKeyMethod(cache, transform(key));
	    };
	  }
	
	  return function (key) {
	    return getCacheKeyMethod(cache, key);
	  };
	};
	
	/**
	 * @private
	 *
	 * @function createSetNewCachedValue
	 *
	 * @description
	 * assign the new value to the key in the functions cache and return the value
	 *
	 * @param {Cache} cache the cache to assign the value to at key
	 * @param {Options} options the options passed to the moize method
	 * @returns {function(function, *, *): *} value just stored in cache
	 */
	var createSetNewCachedValue = exports.createSetNewCachedValue = function createSetNewCachedValue(cache, options) {
	  var hasMaxAge = isFiniteAndPositiveInteger(options.maxAge);
	  var hasMaxSize = isFiniteAndPositiveInteger(options.maxSize);
	
	  var maxAge = options.maxAge,
	      maxSize = options.maxSize;
	
	
	  if (options.isPromise) {
	    if (!isFunction(options.promiseLibrary) && !isPlainObject(options.promiseLibrary)) {
	      throw new TypeError(_constants.INVALID_PROMISE_LIBRARY_ERROR);
	    }
	
	    return function (key, value) {
	      var promiseResolver = createPromiseResolver(cache, key, hasMaxAge, options);
	      var promiseRejecter = createPromiseRejecter(cache, key, options);
	      var handler = value.then(promiseResolver, promiseRejecter);
	
	      cache.add(key, handler);
	
	      if (hasMaxSize && cache.size > maxSize) {
	        cache.remove(cache.list[cache.list.length - 1].key);
	      }
	
	      return handler;
	    };
	  }
	
	  return function (key, value) {
	    cache.add(key, value);
	
	    if (hasMaxAge) {
	      cache.expireAfter(key, maxAge, options.onExpire);
	    }
	
	    if (hasMaxSize && cache.size > maxSize) {
	      cache.remove(cache.list[cache.list.length - 1].key);
	    }
	
	    return value;
	  };
	};
	
	/**
	 * @private
	 *
	 * @function splice
	 *
	 * @description
	 * faster version of splicing a single item from the array
	 *
	 * @param {Array<*>} array array to splice from
	 * @param {number} startingIndex index to splice at
	 * @returns {Array<*>} array minus the item removed
	 */
	var splice = exports.splice = function splice(array, startingIndex) {
	  if (!array.length) {
	    return array;
	  }
	
	  var index = startingIndex - 1;
	
	  while (++index < array.length) {
	    array[index] = array[index + 1];
	  }
	
	  array.length -= 1;
	
	  return array;
	};
	
	/**
	 * @private
	 *
	 * @function unshift
	 *
	 * @description
	 * faster version of unshifting a single item into an array
	 *
	 * @param {Array<*>} array array to unshift into
	 * @param {*} item item to unshift into array
	 * @returns {*} the item just added to the array
	 */
	var unshift = exports.unshift = function unshift(array, item) {
	  var index = array.length;
	
	  while (index--) {
	    array[index + 1] = array[index];
	  }
	
	  return array[0] = item;
	};
	
	/**
	 * @private
	 *
	 * @function createAddPropertiesToFunction
	 *
	 * @description
	 * add the static properties to the moized function
	 *
	 * @param {Cache} cache the cache for the moized function
	 * @param {function} originalFunction the function to be moized
	 * @param {Options} options the options passed to the moize method
	 * @returns {function(function): function} the method which will add the static properties
	 */
	var createAddPropertiesToFunction = exports.createAddPropertiesToFunction = function createAddPropertiesToFunction(cache, originalFunction, options) {
	  var getCacheKey = createGetCacheKey(cache, options);
	
	  return function (moizedFunction) {
	    moizedFunction.cache = cache;
	    moizedFunction.displayName = 'moize(' + getFunctionName(originalFunction) + ')';
	    moizedFunction.isMoized = true;
	    moizedFunction.options = options;
	    moizedFunction.originalFunction = originalFunction;
	
	    /**
	     * @private
	     *
	     * @function add
	     *
	     * @description
	     * manually add an item to cache if the key does not already exist
	     *
	     * @param {Array<any>} key key to use in cache
	     * @param {*} value value to assign to key
	     */
	    moizedFunction.add = function (key, value) {
	      var internalKey = getCacheKey(key);
	
	      if (!cache.has(internalKey)) {
	        cache.add(internalKey, value);
	      }
	    };
	
	    /**
	     * @private
	     *
	     * @function clear
	     *
	     * @description
	     * clear the current cache for this method
	     */
	    moizedFunction.clear = function () {
	      cache.clear();
	    };
	
	    /**
	     * @private
	     *
	     * @function has
	     *
	     * @description
	     * does the function have cache for the specific args passed
	     *
	     * @param {Array<*>} key combination of args to remove from cache
	     * @returns {boolean} does the cache for the give args exist
	     */
	    moizedFunction.has = function (key) {
	      return cache.has(getCacheKey(key));
	    };
	
	    /**
	     * @private
	     *
	     * @function keys
	     *
	     * @description
	     * get the list of keys currently in cache
	     *
	     * @returns {Array<*>}
	     */
	    moizedFunction.keys = createPluckFromInstanceList(cache, 'key');
	
	    /**
	     * @private
	     *
	     * @function remove
	     *
	     * @description
	     * remove the item from cache for the key passed for this method
	     *
	     * @param {Array<*>} key combination of args to remove from cache
	     */
	    moizedFunction.remove = function (key) {
	      cache.remove(getCacheKey(key));
	    };
	
	    /**
	     * @private
	     *
	     * @function values
	     *
	     * @description
	     * get the list of values currently in cache
	     *
	     * @returns {Array<*>}
	     */
	    moizedFunction.values = createPluckFromInstanceList(cache, 'value');
	
	    return addStaticPropertiesToFunction(originalFunction, moizedFunction);
	  };
	};

/***/ }),

/***/ "./node_modules/performance-now/lib/performance-now.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
	(function() {
	  var getNanoSeconds, hrtime, loadTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - loadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    loadTime = getNanoSeconds();
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/raf/index.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__("./node_modules/raf/node_modules/performance-now/lib/performance-now.js")
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function() {
	  root.requestAnimationFrame = raf
	  root.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ "./node_modules/raf/node_modules/performance-now/lib/performance-now.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/react-motion/lib/Motion.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__("./node_modules/react-motion/lib/mapToZero.js");
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__("./node_modules/react-motion/lib/stripStyle.js");
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__("./node_modules/react-motion/lib/stepper.js");
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__("./node_modules/performance-now/lib/performance-now.js");
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__("./node_modules/raf/index.js");
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__("./node_modules/react-motion/lib/shouldStopAnimation.js");
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	var Motion = (function (_React$Component) {
	  _inherits(Motion, _React$Component);
	
	  _createClass(Motion, null, [{
	    key: 'propTypes',
	    value: {
	      // TOOD: warn against putting a config in here
	      defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
	      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
	      children: _propTypes2['default'].func.isRequired,
	      onRest: _propTypes2['default'].func
	    },
	    enumerable: true
	  }]);
	
	  function Motion(props) {
	    var _this = this;
	
	    _classCallCheck(this, Motion);
	
	    _React$Component.call(this, props);
	    this.wasAnimating = false;
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyle = null;
	
	    this.clearUnreadPropStyle = function (destStyle) {
	      var dirty = false;
	      var _state = _this.state;
	      var currentStyle = _state.currentStyle;
	      var currentVelocity = _state.currentVelocity;
	      var lastIdealStyle = _state.lastIdealStyle;
	      var lastIdealVelocity = _state.lastIdealVelocity;
	
	      for (var key in destStyle) {
	        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	          continue;
	        }
	
	        var styleValue = destStyle[key];
	        if (typeof styleValue === 'number') {
	          if (!dirty) {
	            dirty = true;
	            currentStyle = _extends({}, currentStyle);
	            currentVelocity = _extends({}, currentVelocity);
	            lastIdealStyle = _extends({}, lastIdealStyle);
	            lastIdealVelocity = _extends({}, lastIdealVelocity);
	          }
	
	          currentStyle[key] = styleValue;
	          currentVelocity[key] = 0;
	          lastIdealStyle[key] = styleValue;
	          lastIdealVelocity[key] = 0;
	        }
	      }
	
	      if (dirty) {
	        _this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
	      }
	    };
	
	    this.startAnimationIfNecessary = function () {
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        // check if we need to animate in the first place
	        var propsStyle = _this.props.style;
	        if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
	          if (_this.wasAnimating && _this.props.onRest) {
	            _this.props.onRest();
	          }
	
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.wasAnimating = false;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        _this.wasAnimating = true;
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var newLastIdealStyle = {};
	        var newLastIdealVelocity = {};
	        var newCurrentStyle = {};
	        var newCurrentVelocity = {};
	
	        for (var key in propsStyle) {
	          if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
	            continue;
	          }
	
	          var styleValue = propsStyle[key];
	          if (typeof styleValue === 'number') {
	            newCurrentStyle[key] = styleValue;
	            newCurrentVelocity[key] = 0;
	            newLastIdealStyle[key] = styleValue;
	            newLastIdealVelocity[key] = 0;
	          } else {
	            var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
	            var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
	            for (var i = 0; i < framesToCatchUp; i++) {
	              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              newLastIdealStyleValue = _stepper[0];
	              newLastIdealVelocityValue = _stepper[1];
	            }
	
	            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            var nextIdealX = _stepper2[0];
	            var nextIdealV = _stepper2[1];
	
	            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	            newLastIdealStyle[key] = newLastIdealStyleValue;
	            newLastIdealVelocity[key] = newLastIdealVelocityValue;
	          }
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyle: newCurrentStyle,
	          currentVelocity: newCurrentVelocity,
	          lastIdealStyle: newLastIdealStyle,
	          lastIdealVelocity: newLastIdealVelocity
	        });
	
	        _this.unreadPropStyle = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  Motion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyle = _props.defaultStyle;
	    var style = _props.style;
	
	    var currentStyle = defaultStyle || _stripStyle2['default'](style);
	    var currentVelocity = _mapToZero2['default'](currentStyle);
	    return {
	      currentStyle: currentStyle,
	      currentVelocity: currentVelocity,
	      lastIdealStyle: currentStyle,
	      lastIdealVelocity: currentVelocity
	    };
	  };
	
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	
	  Motion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyle != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyle);
	    }
	
	    this.unreadPropStyle = props.style;
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  Motion.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  Motion.prototype.render = function render() {
	    var renderedChildren = this.props.children(this.state.currentStyle);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return Motion;
	})(_react2['default'].Component);
	
	exports['default'] = Motion;
	module.exports = exports['default'];
	
	// after checking for unreadPropStyle != null, we manually go set the
	// non-interpolating values (those that are a number, without a spring
	// config)

/***/ }),

/***/ "./node_modules/react-motion/lib/StaggeredMotion.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__("./node_modules/react-motion/lib/mapToZero.js");
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__("./node_modules/react-motion/lib/stripStyle.js");
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__("./node_modules/react-motion/lib/stepper.js");
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__("./node_modules/performance-now/lib/performance-now.js");
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__("./node_modules/raf/index.js");
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__("./node_modules/react-motion/lib/shouldStopAnimation.js");
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
	  for (var i = 0; i < currentStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
	      return false;
	    }
	  }
	  return true;
	}
	
	var StaggeredMotion = (function (_React$Component) {
	  _inherits(StaggeredMotion, _React$Component);
	
	  _createClass(StaggeredMotion, null, [{
	    key: 'propTypes',
	    value: {
	      // TOOD: warn against putting a config in here
	      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
	      styles: _propTypes2['default'].func.isRequired,
	      children: _propTypes2['default'].func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function StaggeredMotion(props) {
	    var _this = this;
	
	    _classCallCheck(this, StaggeredMotion);
	
	    _React$Component.call(this, props);
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyles = null;
	
	    this.clearUnreadPropStyle = function (unreadPropStyles) {
	      var _state = _this.state;
	      var currentStyles = _state.currentStyles;
	      var currentVelocities = _state.currentVelocities;
	      var lastIdealStyles = _state.lastIdealStyles;
	      var lastIdealVelocities = _state.lastIdealVelocities;
	
	      var someDirty = false;
	      for (var i = 0; i < unreadPropStyles.length; i++) {
	        var unreadPropStyle = unreadPropStyles[i];
	        var dirty = false;
	
	        for (var key in unreadPropStyle) {
	          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	            continue;
	          }
	
	          var styleValue = unreadPropStyle[key];
	          if (typeof styleValue === 'number') {
	            if (!dirty) {
	              dirty = true;
	              someDirty = true;
	              currentStyles[i] = _extends({}, currentStyles[i]);
	              currentVelocities[i] = _extends({}, currentVelocities[i]);
	              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	            }
	            currentStyles[i][key] = styleValue;
	            currentVelocities[i][key] = 0;
	            lastIdealStyles[i][key] = styleValue;
	            lastIdealVelocities[i][key] = 0;
	          }
	        }
	      }
	
	      if (someDirty) {
	        _this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
	      }
	    };
	
	    this.startAnimationIfNecessary = function () {
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        var destStyles = _this.props.styles(_this.state.lastIdealStyles);
	
	        // check if we need to animate in the first place
	        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var newLastIdealStyles = [];
	        var newLastIdealVelocities = [];
	        var newCurrentStyles = [];
	        var newCurrentVelocities = [];
	
	        for (var i = 0; i < destStyles.length; i++) {
	          var destStyle = destStyles[i];
	          var newCurrentStyle = {};
	          var newCurrentVelocity = {};
	          var newLastIdealStyle = {};
	          var newLastIdealVelocity = {};
	
	          for (var key in destStyle) {
	            if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	              continue;
	            }
	
	            var styleValue = destStyle[key];
	            if (typeof styleValue === 'number') {
	              newCurrentStyle[key] = styleValue;
	              newCurrentVelocity[key] = 0;
	              newLastIdealStyle[key] = styleValue;
	              newLastIdealVelocity[key] = 0;
	            } else {
	              var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
	              var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
	              for (var j = 0; j < framesToCatchUp; j++) {
	                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	                newLastIdealStyleValue = _stepper[0];
	                newLastIdealVelocityValue = _stepper[1];
	              }
	
	              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              var nextIdealX = _stepper2[0];
	              var nextIdealV = _stepper2[1];
	
	              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	              newLastIdealStyle[key] = newLastIdealStyleValue;
	              newLastIdealVelocity[key] = newLastIdealVelocityValue;
	            }
	          }
	
	          newCurrentStyles[i] = newCurrentStyle;
	          newCurrentVelocities[i] = newCurrentVelocity;
	          newLastIdealStyles[i] = newLastIdealStyle;
	          newLastIdealVelocities[i] = newLastIdealVelocity;
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyles: newCurrentStyles,
	          currentVelocities: newCurrentVelocities,
	          lastIdealStyles: newLastIdealStyles,
	          lastIdealVelocities: newLastIdealVelocities
	        });
	
	        _this.unreadPropStyles = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  StaggeredMotion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	
	    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
	    var currentVelocities = currentStyles.map(function (currentStyle) {
	      return _mapToZero2['default'](currentStyle);
	    });
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: currentStyles,
	      lastIdealVelocities: currentVelocities
	    };
	  };
	
	  StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  StaggeredMotion.prototype.render = function render() {
	    var renderedChildren = this.props.children(this.state.currentStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return StaggeredMotion;
	})(_react2['default'].Component);
	
	exports['default'] = StaggeredMotion;
	module.exports = exports['default'];
	
	// it's possible that currentStyle's value is stale: if props is immediately
	// changed from 0 to 400 to spring(0) again, the async currentStyle is still
	// at 0 (didn't have time to tick and interpolate even once). If we naively
	// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	// In reality currentStyle should be 400
	
	// after checking for unreadPropStyles != null, we manually go set the
	// non-interpolating values (those that are a number, without a spring
	// config)

/***/ }),

/***/ "./node_modules/react-motion/lib/TransitionMotion.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__("./node_modules/react-motion/lib/mapToZero.js");
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__("./node_modules/react-motion/lib/stripStyle.js");
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__("./node_modules/react-motion/lib/stepper.js");
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _mergeDiff = __webpack_require__("./node_modules/react-motion/lib/mergeDiff.js");
	
	var _mergeDiff2 = _interopRequireDefault(_mergeDiff);
	
	var _performanceNow = __webpack_require__("./node_modules/performance-now/lib/performance-now.js");
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__("./node_modules/raf/index.js");
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__("./node_modules/react-motion/lib/shouldStopAnimation.js");
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	// the children function & (potential) styles function asks as param an
	// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
	// {key: string, data?: any, style: PlainStyle}. However, the way we keep
	// internal states doesn't contain such a data structure (check the state and
	// TransitionMotionState). So when children function and others ask for such
	// data we need to generate them on the fly by combining mergedPropsStyles and
	// currentStyles/lastIdealStyles
	function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
	  // Copy the value to a `const` so that Flow understands that the const won't
	  // change and will be non-nullable in the callback below.
	  var cUnreadPropStyles = unreadPropStyles;
	  if (cUnreadPropStyles == null) {
	    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	      return {
	        key: mergedPropsStyle.key,
	        data: mergedPropsStyle.data,
	        style: plainStyles[i]
	      };
	    });
	  }
	  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	    for (var j = 0; j < cUnreadPropStyles.length; j++) {
	      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
	        return {
	          key: cUnreadPropStyles[j].key,
	          data: cUnreadPropStyles[j].data,
	          style: plainStyles[i]
	        };
	      }
	    }
	    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
	  });
	}
	
	function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
	  if (mergedPropsStyles.length !== destStyles.length) {
	    return false;
	  }
	
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (mergedPropsStyles[i].key !== destStyles[i].key) {
	      return false;
	    }
	  }
	
	  // we have the invariant that mergedPropsStyles and
	  // currentStyles/currentVelocities/last* are synced in terms of cells, see
	  // mergeAndSync comment for more info
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	// core key merging logic
	
	// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
	// c}, previous current (interpolating) style is {a, b}
	// **invariant**: current[i] corresponds to merged[i] in terms of key
	
	// steps:
	// turn merged style into {a?, b, c}
	//    add c, value of c is destStyles.c
	//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
	// turn current (interpolating) style from {a, b} into {a?, b, c}
	//    maybe remove a
	//    certainly add c, value of c is willEnter(c)
	// loop over merged and construct new current
	// dest doesn't change, that's owner's
	function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
	  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
	    var leavingStyle = willLeave(oldMergedPropsStyle);
	    if (leavingStyle == null) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
	  });
	
	  var newCurrentStyles = [];
	  var newCurrentVelocities = [];
	  var newLastIdealStyles = [];
	  var newLastIdealVelocities = [];
	  for (var i = 0; i < newMergedPropsStyles.length; i++) {
	    var newMergedPropsStyleCell = newMergedPropsStyles[i];
	    var foundOldIndex = null;
	    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
	      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
	        foundOldIndex = j;
	        break;
	      }
	    }
	    // TODO: key search code
	    if (foundOldIndex == null) {
	      var plainStyle = willEnter(newMergedPropsStyleCell);
	      newCurrentStyles[i] = plainStyle;
	      newLastIdealStyles[i] = plainStyle;
	
	      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
	      newCurrentVelocities[i] = velocity;
	      newLastIdealVelocities[i] = velocity;
	    } else {
	      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
	      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
	      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
	      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
	    }
	  }
	
	  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
	}
	
	var TransitionMotion = (function (_React$Component) {
	  _inherits(TransitionMotion, _React$Component);
	
	  _createClass(TransitionMotion, null, [{
	    key: 'propTypes',
	    value: {
	      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	        key: _propTypes2['default'].string.isRequired,
	        data: _propTypes2['default'].any,
	        style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
	      })),
	      styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	        key: _propTypes2['default'].string.isRequired,
	        data: _propTypes2['default'].any,
	        style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
	      }))]).isRequired,
	      children: _propTypes2['default'].func.isRequired,
	      willEnter: _propTypes2['default'].func,
	      willLeave: _propTypes2['default'].func,
	      didLeave: _propTypes2['default'].func
	    },
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: {
	      willEnter: function willEnter(styleThatEntered) {
	        return _stripStyle2['default'](styleThatEntered.style);
	      },
	      // recall: returning null makes the current unmounting TransitionStyle
	      // disappear immediately
	      willLeave: function willLeave() {
	        return null;
	      },
	      didLeave: function didLeave() {}
	    },
	    enumerable: true
	  }]);
	
	  function TransitionMotion(props) {
	    var _this = this;
	
	    _classCallCheck(this, TransitionMotion);
	
	    _React$Component.call(this, props);
	    this.unmounting = false;
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyles = null;
	
	    this.clearUnreadPropStyle = function (unreadPropStyles) {
	      var _mergeAndSync = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	      var mergedPropsStyles = _mergeAndSync[0];
	      var currentStyles = _mergeAndSync[1];
	      var currentVelocities = _mergeAndSync[2];
	      var lastIdealStyles = _mergeAndSync[3];
	      var lastIdealVelocities = _mergeAndSync[4];
	
	      for (var i = 0; i < unreadPropStyles.length; i++) {
	        var unreadPropStyle = unreadPropStyles[i].style;
	        var dirty = false;
	
	        for (var key in unreadPropStyle) {
	          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	            continue;
	          }
	
	          var styleValue = unreadPropStyle[key];
	          if (typeof styleValue === 'number') {
	            if (!dirty) {
	              dirty = true;
	              currentStyles[i] = _extends({}, currentStyles[i]);
	              currentVelocities[i] = _extends({}, currentVelocities[i]);
	              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	              mergedPropsStyles[i] = {
	                key: mergedPropsStyles[i].key,
	                data: mergedPropsStyles[i].data,
	                style: _extends({}, mergedPropsStyles[i].style)
	              };
	            }
	            currentStyles[i][key] = styleValue;
	            currentVelocities[i][key] = 0;
	            lastIdealStyles[i][key] = styleValue;
	            lastIdealVelocities[i][key] = 0;
	            mergedPropsStyles[i].style[key] = styleValue;
	          }
	        }
	      }
	
	      // unlike the other 2 components, we can't detect staleness and optionally
	      // opt out of setState here. each style object's data might contain new
	      // stuff we're not/cannot compare
	      _this.setState({
	        currentStyles: currentStyles,
	        currentVelocities: currentVelocities,
	        mergedPropsStyles: mergedPropsStyles,
	        lastIdealStyles: lastIdealStyles,
	        lastIdealVelocities: lastIdealVelocities
	      });
	    };
	
	    this.startAnimationIfNecessary = function () {
	      if (_this.unmounting) {
	        return;
	      }
	
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        // https://github.com/chenglou/react-motion/pull/420
	        // > if execution passes the conditional if (this.unmounting), then
	        // executes async defaultRaf and after that component unmounts and after
	        // that the callback of defaultRaf is called, then setState will be called
	        // on unmounted component.
	        if (_this.unmounting) {
	          return;
	        }
	
	        var propStyles = _this.props.styles;
	        var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;
	
	        // check if we need to animate in the first place
	        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var _mergeAndSync2 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	        var newMergedPropsStyles = _mergeAndSync2[0];
	        var newCurrentStyles = _mergeAndSync2[1];
	        var newCurrentVelocities = _mergeAndSync2[2];
	        var newLastIdealStyles = _mergeAndSync2[3];
	        var newLastIdealVelocities = _mergeAndSync2[4];
	
	        for (var i = 0; i < newMergedPropsStyles.length; i++) {
	          var newMergedPropsStyle = newMergedPropsStyles[i].style;
	          var newCurrentStyle = {};
	          var newCurrentVelocity = {};
	          var newLastIdealStyle = {};
	          var newLastIdealVelocity = {};
	
	          for (var key in newMergedPropsStyle) {
	            if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
	              continue;
	            }
	
	            var styleValue = newMergedPropsStyle[key];
	            if (typeof styleValue === 'number') {
	              newCurrentStyle[key] = styleValue;
	              newCurrentVelocity[key] = 0;
	              newLastIdealStyle[key] = styleValue;
	              newLastIdealVelocity[key] = 0;
	            } else {
	              var newLastIdealStyleValue = newLastIdealStyles[i][key];
	              var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
	              for (var j = 0; j < framesToCatchUp; j++) {
	                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	                newLastIdealStyleValue = _stepper[0];
	                newLastIdealVelocityValue = _stepper[1];
	              }
	
	              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              var nextIdealX = _stepper2[0];
	              var nextIdealV = _stepper2[1];
	
	              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	              newLastIdealStyle[key] = newLastIdealStyleValue;
	              newLastIdealVelocity[key] = newLastIdealVelocityValue;
	            }
	          }
	
	          newLastIdealStyles[i] = newLastIdealStyle;
	          newLastIdealVelocities[i] = newLastIdealVelocity;
	          newCurrentStyles[i] = newCurrentStyle;
	          newCurrentVelocities[i] = newCurrentVelocity;
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyles: newCurrentStyles,
	          currentVelocities: newCurrentVelocities,
	          lastIdealStyles: newLastIdealStyles,
	          lastIdealVelocities: newLastIdealVelocities,
	          mergedPropsStyles: newMergedPropsStyles
	        });
	
	        _this.unreadPropStyles = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  TransitionMotion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	    var willEnter = _props.willEnter;
	    var willLeave = _props.willLeave;
	    var didLeave = _props.didLeave;
	
	    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;
	
	    // this is special. for the first time around, we don't have a comparison
	    // between last (no last) and current merged props. we'll compute last so:
	    // say default is {a, b} and styles (dest style) is {b, c}, we'll
	    // fabricate last as {a, b}
	    var oldMergedPropsStyles = undefined;
	    if (defaultStyles == null) {
	      oldMergedPropsStyles = destStyles;
	    } else {
	      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
	        // TODO: key search code
	        for (var i = 0; i < destStyles.length; i++) {
	          if (destStyles[i].key === defaultStyleCell.key) {
	            return destStyles[i];
	          }
	        }
	        return defaultStyleCell;
	      });
	    }
	    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    });
	    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    });
	
	    var _mergeAndSync3 = mergeAndSync(
	    // Because this is an old-style createReactClass component, Flow doesn't
	    // understand that the willEnter and willLeave props have default values
	    // and will always be present.
	    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
	    oldCurrentVelocities);
	
	    var mergedPropsStyles = _mergeAndSync3[0];
	    var currentStyles = _mergeAndSync3[1];
	    var currentVelocities = _mergeAndSync3[2];
	    var lastIdealStyles = _mergeAndSync3[3];
	    var lastIdealVelocities = _mergeAndSync3[4];
	    // oldLastIdealVelocities really
	
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: lastIdealStyles,
	      lastIdealVelocities: lastIdealVelocities,
	      mergedPropsStyles: mergedPropsStyles
	    };
	  };
	
	  // after checking for unreadPropStyles != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	
	  TransitionMotion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    var styles = props.styles;
	    if (typeof styles === 'function') {
	      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
	    } else {
	      this.unreadPropStyles = styles;
	    }
	
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounting = true;
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  TransitionMotion.prototype.render = function render() {
	    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
	    var renderedChildren = this.props.children(hydratedStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return TransitionMotion;
	})(_react2['default'].Component);
	
	exports['default'] = TransitionMotion;
	module.exports = exports['default'];
	
	// list of styles, each containing interpolating values. Part of what's passed
	// to children function. Notice that this is
	// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
	// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
	// contains the key & data info (so that we only have a single source of truth
	// for these, and to save space). Check the comment for `rehydrateStyles` to
	// see how we regenerate the entirety of what's passed to children function
	
	// the array that keeps track of currently rendered stuff! Including stuff
	// that you've unmounted but that's still animating. This is where it lives
	
	// it's possible that currentStyle's value is stale: if props is immediately
	// changed from 0 to 400 to spring(0) again, the async currentStyle is still
	// at 0 (didn't have time to tick and interpolate even once). If we naively
	// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	// In reality currentStyle should be 400

/***/ }),

/***/ "./node_modules/react-motion/lib/mapToZero.js":
/***/ (function(module, exports) {

	
	
	// currently used to initiate the velocity style object to 0
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mapToZero;
	
	function mapToZero(obj) {
	  var ret = {};
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      ret[key] = 0;
	    }
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-motion/lib/mergeDiff.js":
/***/ (function(module, exports) {

	
	
	// core keys merging algorithm. If previous render's keys are [a, b], and the
	// next render's [c, b, d], what's the final merged keys and ordering?
	
	// - c and a must both be before b
	// - b before d
	// - ordering between a and c ambiguous
	
	// this reduces to merging two partially ordered lists (e.g. lists where not
	// every item has a definite ordering, like comparing a and c above). For the
	// ambiguous ordering we deterministically choose to place the next render's
	// item after the previous'; so c after a
	
	// this is called a topological sorting. Except the existing algorithms don't
	// work well with js bc of the amount of allocation, and isn't optimized for our
	// current use-case bc the runtime is linear in terms of edges (see wiki for
	// meaning), which is huge when two lists have many common elements
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mergeDiff;
	
	function mergeDiff(prev, next, onRemove) {
	  // bookkeeping for easier access of a key's index below. This is 2 allocations +
	  // potentially triggering chrome hash map mode for objs (so it might be faster
	
	  var prevKeyIndex = {};
	  for (var i = 0; i < prev.length; i++) {
	    prevKeyIndex[prev[i].key] = i;
	  }
	  var nextKeyIndex = {};
	  for (var i = 0; i < next.length; i++) {
	    nextKeyIndex[next[i].key] = i;
	  }
	
	  // first, an overly elaborate way of merging prev and next, eliminating
	  // duplicates (in terms of keys). If there's dupe, keep the item in next).
	  // This way of writing it saves allocations
	  var ret = [];
	  for (var i = 0; i < next.length; i++) {
	    ret[i] = next[i];
	  }
	  for (var i = 0; i < prev.length; i++) {
	    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
	      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
	      // merge in keys that the user desires to kill
	      var fill = onRemove(i, prev[i]);
	      if (fill != null) {
	        ret.push(fill);
	      }
	    }
	  }
	
	  // now all the items all present. Core sorting logic to have the right order
	  return ret.sort(function (a, b) {
	    var nextOrderA = nextKeyIndex[a.key];
	    var nextOrderB = nextKeyIndex[b.key];
	    var prevOrderA = prevKeyIndex[a.key];
	    var prevOrderB = prevKeyIndex[b.key];
	
	    if (nextOrderA != null && nextOrderB != null) {
	      // both keys in next
	      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
	    } else if (prevOrderA != null && prevOrderB != null) {
	      // both keys in prev
	      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
	    } else if (nextOrderA != null) {
	      // key a in next, key b in prev
	
	      // how to determine the order between a and b? We find a "pivot" (term
	      // abuse), a key present in both prev and next, that is sandwiched between
	      // a and b. In the context of our above example, if we're comparing a and
	      // d, b's (the only) pivot
	      for (var i = 0; i < next.length; i++) {
	        var pivot = next[i].key;
	        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	          continue;
	        }
	
	        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
	          return -1;
	        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
	          return 1;
	        }
	      }
	      // pluggable. default to: next bigger than prev
	      return 1;
	    }
	    // prevOrderA, nextOrderB
	    for (var i = 0; i < next.length; i++) {
	      var pivot = next[i].key;
	      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	        continue;
	      }
	      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
	        return 1;
	      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
	        return -1;
	      }
	    }
	    // pluggable. default to: next bigger than prev
	    return -1;
	  });
	}
	
	module.exports = exports['default'];
	// to loop through and find a key's index each time), but I no longer care

/***/ }),

/***/ "./node_modules/react-motion/lib/presets.js":
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = {
	  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
	  gentle: { stiffness: 120, damping: 14 },
	  wobbly: { stiffness: 180, damping: 12 },
	  stiff: { stiffness: 210, damping: 20 }
	};
	module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/react-motion/lib/react-motion.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }
	
	var _Motion = __webpack_require__("./node_modules/react-motion/lib/Motion.js");
	
	exports.Motion = _interopRequire(_Motion);
	
	var _StaggeredMotion = __webpack_require__("./node_modules/react-motion/lib/StaggeredMotion.js");
	
	exports.StaggeredMotion = _interopRequire(_StaggeredMotion);
	
	var _TransitionMotion = __webpack_require__("./node_modules/react-motion/lib/TransitionMotion.js");
	
	exports.TransitionMotion = _interopRequire(_TransitionMotion);
	
	var _spring = __webpack_require__("./node_modules/react-motion/lib/spring.js");
	
	exports.spring = _interopRequire(_spring);
	
	var _presets = __webpack_require__("./node_modules/react-motion/lib/presets.js");
	
	exports.presets = _interopRequire(_presets);
	
	var _stripStyle = __webpack_require__("./node_modules/react-motion/lib/stripStyle.js");
	
	exports.stripStyle = _interopRequire(_stripStyle);
	
	// deprecated, dummy warning function
	
	var _reorderKeys = __webpack_require__("./node_modules/react-motion/lib/reorderKeys.js");
	
	exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ }),

/***/ "./node_modules/react-motion/lib/reorderKeys.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = reorderKeys;
	
	var hasWarned = false;
	
	function reorderKeys() {
	  if (false) {
	    if (!hasWarned) {
	      hasWarned = true;
	      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-motion/lib/shouldStopAnimation.js":
/***/ (function(module, exports) {

	
	
	// usage assumption: currentStyle values have already been rendered but it says
	// nothing of whether currentStyle is stale (see unreadPropStyle)
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = shouldStopAnimation;
	
	function shouldStopAnimation(currentStyle, style, currentVelocity) {
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	
	    if (currentVelocity[key] !== 0) {
	      return false;
	    }
	
	    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
	    // stepper will have already taken care of rounding precision errors, so
	    // won't have such thing as 0.9999 !=== 1
	    if (currentStyle[key] !== styleValue) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-motion/lib/spring.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = spring;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _presets = __webpack_require__("./node_modules/react-motion/lib/presets.js");
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var defaultConfig = _extends({}, _presets2['default'].noWobble, {
	  precision: 0.01
	});
	
	function spring(val, config) {
	  return _extends({}, defaultConfig, config, { val: val });
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-motion/lib/stepper.js":
/***/ (function(module, exports) {

	
	
	// stepper is used a lot. Saves allocation to return the same array wrapper.
	// This is fine and danger-free against mutations because the callsite
	// immediately destructures it and gets the numbers inside without passing the
	"use strict";
	
	exports.__esModule = true;
	exports["default"] = stepper;
	
	var reusedTuple = [0, 0];
	
	function stepper(secondPerFrame, x, v, destX, k, b, precision) {
	  // Spring stiffness, in kg / s^2
	
	  // for animations, destX is really spring length (spring at rest). initial
	  // position is considered as the stretched/compressed position of a spring
	  var Fspring = -k * (x - destX);
	
	  // Damping, in kg / s
	  var Fdamper = -b * v;
	
	  // usually we put mass here, but for animation purposes, specifying mass is a
	  // bit redundant. you could simply adjust k and b accordingly
	  // let a = (Fspring + Fdamper) / mass;
	  var a = Fspring + Fdamper;
	
	  var newV = v + a * secondPerFrame;
	  var newX = x + newV * secondPerFrame;
	
	  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
	    reusedTuple[0] = destX;
	    reusedTuple[1] = 0;
	    return reusedTuple;
	  }
	
	  reusedTuple[0] = newX;
	  reusedTuple[1] = newV;
	  return reusedTuple;
	}
	
	module.exports = exports["default"];
	// array reference around.

/***/ }),

/***/ "./node_modules/react-motion/lib/stripStyle.js":
/***/ (function(module, exports) {

	
	// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
	// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}
	
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = stripStyle;
	
	function stripStyle(style) {
	  var ret = {};
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/dylanmozlowski/dylanmoz.github.io/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/dylanmozlowski/dylanmoz.github.io/node_modules/babel-plugin-lodash/lib/index.js\",[\"/Users/dylanmozlowski/dylanmoz.github.io/node_modules/babel-plugin-module-resolver/lib/index.js\",{\"root\":[\"./src\"]}],\"/Users/dylanmozlowski/dylanmoz.github.io/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/dylanmozlowski/dylanmoz.github.io/node_modules/babel-plugin-transform-object-assign/lib/index.js\",[\"transform-react-jsx\",{\"pragma\":\"Glamor.createElement\"}],\"glamor/babel-hoist\"],\"presets\":[[\"/Users/dylanmozlowski/dylanmoz.github.io/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/dylanmozlowski/dylanmoz.github.io/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/dylanmozlowski/dylanmoz.github.io/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/trello/TrelloGraph.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _glamorous = __webpack_require__("./node_modules/glamorous/dist/glamorous.cjs.js");
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _moize = __webpack_require__("./node_modules/moize/lib/index.js");
	
	var _moize2 = _interopRequireDefault(_moize);
	
	var _shape = __webpack_require__("./node_modules/@vx/shape/build/index.js");
	
	var _group = __webpack_require__("./node_modules/@vx/group/build/index.js");
	
	var _curve = __webpack_require__("./node_modules/@vx/curve/build/index.js");
	
	var _responsive = __webpack_require__("./node_modules/@vx/responsive/build/index.js");
	
	var _axis = __webpack_require__("./node_modules/@vx/axis/build/index.js");
	
	var _grid = __webpack_require__("./node_modules/@vx/grid/build/index.js");
	
	var _scale = __webpack_require__("./node_modules/@vx/scale/build/index.js");
	
	var _event = __webpack_require__("./node_modules/@vx/event/build/index.js");
	
	var _touchPoint2 = __webpack_require__("./node_modules/@vx/event/build/touchPoint.js");
	
	var _touchPoint3 = _interopRequireDefault(_touchPoint2);
	
	var _reactMotion = __webpack_require__("./node_modules/react-motion/lib/react-motion.js");
	
	var _d3Array = __webpack_require__("./node_modules/d3-array/build/d3-array.js");
	
	var _shallowEqual = __webpack_require__("./node_modules/fbjs/lib/shallowEqual.js");
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _Delay = __webpack_require__("./src/utils/Delay.js");
	
	var _Delay2 = _interopRequireDefault(_Delay);
	
	var _findPathYAtX = __webpack_require__("./src/utils/findPathYAtX.js");
	
	var _findPathYAtX2 = _interopRequireDefault(_findPathYAtX);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// memoizing components improves performance from 30fps to 50+fps on 5x throttled cpu
	var GridRowsMem = _moize2.default.reactSimple(_grid.GridRows);
	var GroupMem = _moize2.default.reactSimple(_group.Group);
	var LinePathMem = _moize2.default.reactSimple(_shape.LinePath);
	var AxisLeftMem = _moize2.default.reactSimple(_axis.AxisLeft);
	var AxisBottomMem = _moize2.default.reactSimple(_axis.AxisBottom);
	
	var bisectDate = (0, _d3Array.bisector)(function (d) {
	  return new Date(d.date);
	}).left;
	
	var colors = ['rgb(107, 157, 255)', 'rgb(252, 137, 159)'];
	
	var data = [{ date: new Date(2017, 3, 1), value: 1 }, { date: new Date(2017, 4, 1), value: 2 }, { date: new Date(2017, 5, 1), value: 6 }, { date: new Date(2017, 6, 1), value: 3 }, { date: new Date(2017, 7, 1), value: 1 }, { date: new Date(2017, 8, 1), value: 5 }];
	
	var data2 = [{ date: new Date(2017, 3, 1), value: 4 }, { date: new Date(2017, 4, 1), value: 4 }, { date: new Date(2017, 5, 1), value: 0 }, { date: new Date(2017, 6, 1), value: 1.5 }, { date: new Date(2017, 7, 1), value: 2 }, { date: new Date(2017, 8, 1), value: 1 }];
	
	var series = [data, data2];
	var allData = series.reduce(function (acc, arr) {
	  return acc.concat(arr);
	}, []);
	
	var Container = (0, _glamorous2.default)('div', { shouldClassNameUpdate: function shouldClassNameUpdate() {
	    return false;
	  } })({
	  backgroundColor: 'white'
	});
	
	var Tooltip = (0, _glamorous2.default)('div', { shouldClassNameUpdate: function shouldClassNameUpdate() {
	    return false;
	  } })({
	  position: 'absolute',
	  backgroundColor: 'white',
	  color: 'rgba(25, 29, 34, 0.54)',
	  padding: 12,
	  fontSize: 14,
	  boxShadow: '0 4px 8px 0 rgba(25, 29, 34, 0.1)',
	  pointerEvents: 'none',
	  borderRadius: 3,
	  border: '1px solid rgba(25, 29, 34, 0.12)'
	});
	
	var aspectRatio = 0.5;
	var margin = { top: 10, left: 15, bottom: 30, right: 35 };
	
	var axisLeftTickLabel = Glamor.createElement('text', {
	  fill: 'rgb(25, 29, 34)',
	  opacity: '0.20',
	  fontSize: 10,
	  dy: '0.25em',
	  textAnchor: 'middle',
	  fontWeight: 'bold'
	});
	
	var axisBottomTickLabel = Glamor.createElement('text', {
	  fill: 'rgb(25, 29, 34)',
	  opacity: '0.20',
	  fontSize: 10,
	  dy: '0.25em',
	  textAnchor: 'middle',
	  fontWeight: 'bold'
	});
	
	var TrelloGraph = function (_React$Component) {
	  _inherits(TrelloGraph, _React$Component);
	
	  function TrelloGraph() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TrelloGraph);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      tooltipOpen: false,
	      tooltipLeft: 0,
	      tooltipTop: 0,
	      tooltipData: null,
	      vertLineLeft: 0
	    }, _this.tooltipWidth = 0, _this.pathRefs = {}, _this.x = function (d) {
	      return d.date;
	    }, _this.y = function (d) {
	      return d.value;
	    }, _this.setSvgRef = function (ref) {
	      _this.svg = ref;
	    }, _this.setTooltipRef = function (ref) {
	      _this.tooltip = ref;
	
	      if (_this.tooltip) {
	        _this.tooltipWidth = ref.getBoundingClientRect().width;
	      }
	    }, _this.setPathRef = function (ref) {
	      if (!ref) {
	        _this.pathRefs = null;
	        return;
	      }
	
	      _this.pathRefs[ref.getAttribute('data-index')] = ref;
	    }, _this.mouseLeave = function (event) {
	      _this.closeTooltip();
	    }, _this.touchMove = function (event) {
	      var _touchPoint = (0, _touchPoint3.default)(_this.svg, event),
	          x = _touchPoint.x,
	          y = _touchPoint.y;
	
	      _this.showTooltipAt(x, y);
	    }, _this.mouseMove = function (event) {
	      var _localPoint = (0, _event.localPoint)(_this.svg, event),
	          x = _localPoint.x,
	          y = _localPoint.y;
	
	      _this.showTooltipAt(x, y);
	    }, _this.showTooltipAt = function (x, y) {
	      var xMax = _this.getXMax();
	      var yMax = _this.getYMax();
	
	      var positionX = x - margin.left;
	      var positionY = y - margin.top;
	
	      if (positionX < 0 || positionX > xMax || positionY < 0 || positionY > yMax) {
	        _this.closeTooltip();
	        return;
	      }
	
	      _this.tooltipWidth = _this.tooltip.getBoundingClientRect().width;
	
	      var dataPoints = series.map(function (d) {
	        var xDomain = _this.xScale.invert(x - margin.left);
	
	        var index = bisectDate(d, xDomain, 1);
	
	        var dLeft = d[index - 1];
	        var dRight = d[index];
	
	        var isRightCloser = xDomain - new Date(dLeft.date) > new Date(dRight.date) - xDomain;
	
	        return isRightCloser ? dRight : dLeft;
	      });
	
	      var xOffset = 18;
	      var yOffset = 18;
	
	      var positionXWithOffset = positionX + xOffset;
	      var pastRightSide = positionXWithOffset + _this.tooltipWidth > xMax;
	      var tooltipLeft = pastRightSide ? positionX - _this.tooltipWidth - xOffset : positionXWithOffset;
	
	      var tooltipTop = positionY - yOffset;
	
	      _this.setState({
	        tooltipOpen: true,
	        tooltipData: dataPoints,
	        tooltipLeft: tooltipLeft,
	        tooltipTop: tooltipTop,
	        vertLineLeft: _this.xScale(new Date(dataPoints[0].date))
	      });
	    }, _this.closeTooltip = function () {
	      _this.setState({
	        tooltipOpen: false
	      });
	    }, _this.getXScale = _moize2.default.simple(function (data, x, xMax) {
	      return (0, _scale.scaleTime)({
	        domain: (0, _d3Array.extent)(data, x),
	        range: [0, xMax]
	      });
	    }), _this.getYScale = _moize2.default.simple(function (data, y, yMax) {
	      return (0, _scale.scaleLinear)({
	        domain: [0, (0, _d3Array.max)(data, y)],
	        range: [yMax, 0]
	      });
	    }), _this.getPathYFromX = function (index, x) {
	      var path = _this.pathRefs[index];
	
	      return (0, _findPathYAtX2.default)(x, path, index);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  TrelloGraph.prototype.componentWillMount = function componentWillMount() {
	    this.update();
	  };
	
	  TrelloGraph.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (!(0, _shallowEqual2.default)(this.props, nextProps)) {
	      this.update(nextProps);
	    }
	  };
	
	  TrelloGraph.prototype.update = function update() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	    this.xMax = this.getXMax(props);
	    this.yMax = this.getYMax(props);
	
	    this.xScale = this.getXScale(allData, this.x, this.xMax);
	    this.yScale = this.getYScale(allData, this.y, this.yMax);
	
	    this.yScaleFormat = this.yScale.tickFormat(3, "0");
	  };
	
	  TrelloGraph.prototype.getXMax = function getXMax() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	    return props.parentWidth - margin.left - margin.right;
	  };
	
	  TrelloGraph.prototype.getYMax = function getYMax() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	    return props.parentWidth * aspectRatio - margin.top - margin.bottom;
	  };
	
	  TrelloGraph.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        parentWidth = _props.parentWidth,
	        parentHeight = _props.parentHeight;
	    var _state = this.state,
	        tooltipOpen = _state.tooltipOpen,
	        tooltipLeft = _state.tooltipLeft,
	        tooltipData = _state.tooltipData,
	        tooltipTop = _state.tooltipTop,
	        vertLineLeft = _state.vertLineLeft;
	
	
	    var width = parentWidth;
	    var height = parentWidth * aspectRatio;
	
	    return Glamor.createElement(
	      'div',
	      { style: { position: 'relative' } },
	      Glamor.createElement(
	        'svg',
	        { width: width, height: height, ref: this.setSvgRef },
	        Glamor.createElement('rect', { x: 0, y: 0, width: width, height: height, fill: 'white' }),
	        Glamor.createElement(GridRowsMem, {
	          top: margin.top,
	          left: margin.left,
	          scale: this.yScale,
	          numTicks: 3,
	          width: this.xMax
	        }),
	        Glamor.createElement(
	          GroupMem,
	          { top: margin.top, left: margin.left },
	          Glamor.createElement(
	            _reactMotion.Motion,
	            {
	              defaultStyle: { left: 0, opacity: 0 },
	              style: { left: (0, _reactMotion.spring)(vertLineLeft || 0), opacity: (0, _reactMotion.spring)(tooltipOpen ? .12 : 0) }
	            },
	            function (style) {
	              return Glamor.createElement(_shape.Line, {
	                from: { x: style.left, y: 0 },
	                to: { x: style.left, y: _this2.yMax },
	                stroke: 'rgb(25, 29, 34)',
	                opacity: style.opacity
	              });
	            }
	          ),
	          series.map(function (seriesData, i) {
	            return Glamor.createElement(LinePathMem, {
	              key: i,
	              'data-index': i,
	              data: seriesData,
	              xScale: _this2.xScale,
	              yScale: _this2.yScale,
	              x: _this2.x,
	              y: _this2.y,
	              curve: _curve.curveBasis,
	              stroke: colors[i],
	              strokeLinecap: 'round',
	              innerRef: _this2.setPathRef
	            });
	          }),
	          Glamor.createElement(
	            _reactMotion.Motion,
	            {
	              defaultStyle: { opacity: 0, x: vertLineLeft },
	              style: {
	                opacity: (0, _reactMotion.spring)(tooltipOpen ? 1 : 0),
	                x: (0, _reactMotion.spring)(vertLineLeft)
	              }
	            },
	            function (style) {
	              return tooltipData && Glamor.createElement(
	                'g',
	                null,
	                tooltipData.map(function (d, i) {
	                  var y = _this2.getPathYFromX(i, style.x);
	
	                  return Glamor.createElement(
	                    'g',
	                    { key: i },
	                    Glamor.createElement('circle', {
	                      cx: style.x,
	                      cy: y,
	                      r: 12,
	                      fill: colors[i],
	                      stroke: colors[i],
	                      strokeWidth: '.6',
	                      fillOpacity: style.opacity / 12,
	                      strokeOpacity: style.opacity / 2
	                    }),
	                    Glamor.createElement('circle', {
	                      cx: style.x,
	                      cy: y,
	                      r: 4,
	                      fill: 'white',
	                      stroke: colors[i],
	                      strokeWidth: '1.5',
	                      fillOpacity: style.opacity,
	                      strokeOpacity: style.opacity
	                    })
	                  );
	                })
	              );
	            }
	          ),
	          Glamor.createElement('rect', {
	            x: '0',
	            y: '0',
	            width: this.xMax,
	            height: this.yMax,
	            fill: 'transparent',
	            onMouseLeave: this.mouseLeave,
	            onMouseMove: this.mouseMove,
	            onTouchMove: this.touchMove
	          }),
	          Glamor.createElement(
	            _Delay2.default,
	            { initial: 0, value: this.xMax, period: 300 },
	            function (delayed) {
	              return Glamor.createElement(
	                _reactMotion.Motion,
	                { defaultStyle: { x: 0 }, style: { x: (0, _reactMotion.spring)(delayed) } },
	                function (style) {
	                  return Glamor.createElement('rect', {
	                    x: style.x,
	                    y: '0',
	                    width: Math.max(_this2.xMax - style.x, 0),
	                    height: _this2.yMax,
	                    fill: 'white'
	                  });
	                }
	              );
	            }
	          )
	        ),
	        Glamor.createElement(AxisLeftMem, {
	          top: margin.top,
	          left: margin.left,
	          scale: this.yScale,
	          hideTicks: true,
	          hideAxisLine: true,
	          numTicks: 3,
	          stroke: '#eaf0f6',
	          tickLabelComponent: axisLeftTickLabel,
	          tickFormat: this.yScaleFormat
	        }),
	        Glamor.createElement(AxisBottomMem, {
	          top: height - margin.bottom,
	          left: margin.left,
	          scale: this.xScale,
	          hideTicks: true,
	          stroke: '#eaf0f6',
	          tickLabelComponent: axisBottomTickLabel
	        })
	      ),
	      Glamor.createElement(
	        'div',
	        {
	          style: {
	            position: 'absolute',
	            top: margin.top,
	            left: margin.left,
	            width: this.xMax,
	            height: this.yMax,
	            pointerEvents: 'none'
	          } },
	        Glamor.createElement(
	          _reactMotion.Motion,
	          {
	            defaultStyle: { left: tooltipLeft || 0, top: tooltipTop || 0, opacity: 0 },
	            style: {
	              left: (0, _reactMotion.spring)(tooltipLeft || 0),
	              top: (0, _reactMotion.spring)(tooltipTop || 0),
	              opacity: (0, _reactMotion.spring)(tooltipOpen ? 1 : 0)
	            }
	          },
	          function (style) {
	            return Glamor.createElement(
	              Tooltip,
	              {
	                innerRef: _this2.setTooltipRef,
	                style: {
	                  top: style.top,
	                  left: style.left,
	                  opacity: style.opacity
	                }
	              },
	              Glamor.createElement(
	                'div',
	                null,
	                Glamor.createElement(
	                  'strong',
	                  null,
	                  tooltipData && new Date(tooltipData[0].date).toLocaleDateString()
	                ),
	                tooltipData && tooltipData.map(function (d, i) {
	                  return Glamor.createElement(
	                    'div',
	                    { key: i },
	                    Glamor.createElement('span', {
	                      style: {
	                        display: 'inline-block',
	                        borderRadius: '50%',
	                        width: 8,
	                        height: 8,
	                        marginRight: 6,
	                        backgroundColor: colors[i]
	                      }
	                    }),
	                    d.value
	                  );
	                })
	              )
	            );
	          }
	        )
	      )
	    );
	  };
	
	  return TrelloGraph;
	}(_react2.default.Component);
	
	exports.default = (0, _responsive.withParentSize)(TrelloGraph);
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/dylanmozlowski/dylanmoz.github.io/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/dylanmozlowski/dylanmoz.github.io/node_modules/babel-plugin-lodash/lib/index.js\",[\"/Users/dylanmozlowski/dylanmoz.github.io/node_modules/babel-plugin-module-resolver/lib/index.js\",{\"root\":[\"./src\"]}],\"/Users/dylanmozlowski/dylanmoz.github.io/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/dylanmozlowski/dylanmoz.github.io/node_modules/babel-plugin-transform-object-assign/lib/index.js\",[\"transform-react-jsx\",{\"pragma\":\"Glamor.createElement\"}],\"glamor/babel-hoist\"],\"presets\":[[\"/Users/dylanmozlowski/dylanmoz.github.io/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/dylanmozlowski/dylanmoz.github.io/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/dylanmozlowski/dylanmoz.github.io/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/trello/index.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _glamorous = __webpack_require__("./node_modules/glamorous/dist/glamorous.cjs.js");
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _glamorousGrid = __webpack_require__("./node_modules/glamorous-grid/lib/index.js");
	
	var _withSpacing = __webpack_require__("./node_modules/glamorous-grid/lib/withSpacing.js");
	
	var _withSpacing2 = _interopRequireDefault(_withSpacing);
	
	var _TrelloGraph = __webpack_require__("./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/dylanmozlowski/dylanmoz.github.io/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/dylanmozlowski/dylanmoz.github.io/node_modules/babel-plugin-lodash/lib/index.js\",[\"/Users/dylanmozlowski/dylanmoz.github.io/node_modules/babel-plugin-module-resolver/lib/index.js\",{\"root\":[\"./src\"]}],\"/Users/dylanmozlowski/dylanmoz.github.io/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/dylanmozlowski/dylanmoz.github.io/node_modules/babel-plugin-transform-object-assign/lib/index.js\",[\"transform-react-jsx\",{\"pragma\":\"Glamor.createElement\"}],\"glamor/babel-hoist\"],\"presets\":[[\"/Users/dylanmozlowski/dylanmoz.github.io/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/dylanmozlowski/dylanmoz.github.io/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/dylanmozlowski/dylanmoz.github.io/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/trello/TrelloGraph.js");
	
	var _TrelloGraph2 = _interopRequireDefault(_TrelloGraph);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GraphContainer = (0, _withSpacing2.default)(_glamorous2.default.div({
	  borderRadius: 6,
	  marginBottom: 24,
	  boxShadow: '0 2px 4px 0 rgba(25, 29, 34, 0.1)',
	  backgroundColor: 'white',
	  color: 'rgba(25, 29, 34, 0.54)',
	  overflow: 'hidden'
	}));
	
	var Trello = function (_React$Component) {
	  _inherits(Trello, _React$Component);
	
	  function Trello() {
	    _classCallCheck(this, Trello);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Trello.prototype.render = function render() {
	    return Glamor.createElement(
	      _glamorousGrid.Container,
	      { fluid: true, style: { background: 'rgb(246, 247, 251)' } },
	      Glamor.createElement(
	        _glamorousGrid.Row,
	        { style: { height: '100%' } },
	        Glamor.createElement(
	          _glamorousGrid.Col,
	          { alignSelf: 'center' },
	          Glamor.createElement(
	            _glamorousGrid.Row,
	            { justifyContent: 'center' },
	            Glamor.createElement(
	              _glamorousGrid.Col,
	              { span: { xs: 1, sm: 10 / 12, md: 9 / 12, lg: 8 / 12, xl: 6 / 12 } },
	              Glamor.createElement(
	                GraphContainer,
	                { p: { xs: 12, sm: 24 } },
	                Glamor.createElement(
	                  'h5',
	                  null,
	                  'Recent Activity'
	                ),
	                Glamor.createElement(_TrelloGraph2.default, null)
	              )
	            )
	          ),
	          Glamor.createElement(
	            _glamorousGrid.Row,
	            { justifyContent: 'center' },
	            Glamor.createElement(
	              _glamorousGrid.Col,
	              { span: { xs: 1, sm: 9 / 12, md: 8 / 12 }, textAlign: 'center' },
	              Glamor.createElement(
	                'p',
	                { style: { marginBottom: 0, color: 'rgba(25, 29, 34, 0.38)' } },
	                'Desktop: hover for tooltip. Mobile: Touch or drag for tooltip.'
	              ),
	              Glamor.createElement(
	                'p',
	                { style: { color: 'rgba(25, 29, 34, 0.38)' } },
	                Glamor.createElement(
	                  'a',
	                  { href: 'https://github.com/DylanMoz/dylanmoz.github.io/blob/source/src/pages/trello/TrelloGraph.js' },
	                  'Source'
	                ),
	                '. ',
	                Glamor.createElement(
	                  'a',
	                  { href: 'https://devblog.classy.org/how-to-make-beautiful-graphs-with-vx-and-react-motion-6ffe7aecf6f3' },
	                  'Medium post'
	                ),
	                '. Inspired by this ',
	                Glamor.createElement(
	                  'a',
	                  { href: 'https://dribbble.com/shots/3626885-Trello-Atlassian-Stats' },
	                  'trello design'
	                ),
	                '.'
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Trello;
	}(_react2.default.Component);
	
	exports.default = Trello;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ }),

/***/ "./src/utils/Delay.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Delay = function (_React$Component) {
	  _inherits(Delay, _React$Component);
	
	  function Delay() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Delay);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      value: _this.props.initial
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Delay.prototype.componentDidMount = function componentDidMount() {
	    this.refresh(this.props);
	  };
	
	  Delay.prototype.componentWillReceiveProps = function componentWillReceiveProps(next) {
	    // if (!this.unmounting) {
	    //   this.refresh(next)
	    // }
	  };
	
	  Delay.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounting = true;
	
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	      this.timeout = 0;
	    }
	  };
	
	  Delay.prototype.refresh = function refresh(props) {
	    var _this2 = this;
	
	    var value = props.value,
	        period = props.period;
	
	
	    this.timeout = setTimeout(function () {
	      return _this2.setState({
	        value: value
	      });
	    }, period);
	  };
	
	  Delay.prototype.render = function render() {
	    return this.props.children(this.state.value);
	  };
	
	  return Delay;
	}(_react2.default.Component);
	
	Delay.defaultProps = {
	  period: 0
	};
	exports.default = Delay;
	module.exports = exports['default'];

/***/ }),

/***/ "./src/utils/findPathYAtX.js":
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getPathYFromX;
	var pathYCache = {};
	
	function getPathYFromX(x, path, name, error) {
	    var key = name + "-" + x;
	
	    if (key in pathYCache) {
	        return pathYCache[key];
	    }
	
	    error = error || 0.01;
	
	    var maxIterations = 100;
	
	    var lengthStart = 0;
	    var lengthEnd = path.getTotalLength();
	    var point = path.getPointAtLength((lengthEnd + lengthStart) / 2);
	    var iterations = 0;
	
	    while (x < point.x - error || x > point.x + error) {
	        var midpoint = (lengthStart + lengthEnd) / 2;
	
	        point = path.getPointAtLength(midpoint);
	
	        if (x < point.x) {
	            lengthEnd = midpoint;
	        } else {
	            lengthStart = midpoint;
	        }
	
	        iterations += 1;
	        if (maxIterations < iterations) {
	            break;
	        }
	    }
	
	    pathYCache[key] = point.y;
	
	    return pathYCache[key];
	}
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-trello-index-js-48173a0f0e8a8e4f714e.js